import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject, Observable, Subject, Subscription } from "rxjs";
import { INVENT, NOMED, environment } from "../../environments/environment"
import { ApiService } from "./api.service";
import { ClientService } from "./client.service";

import { ProcCostModel } from "../models/proc-cost.model";
import { CheckPetSexSpecieModel } from "../models/check-pet-sex-specie.model";
import { HandleInvtModel } from "../models/handle-invt.model";
import { UpdateTranInfoModel } from "../models/update-tran-info.model";
import { DeleteATranModel } from "../models/delete-a-tran.model";
import { HandleCorSModel } from "../models/handle-cors.model";
import { UpdateStatusModel } from "../models/update-status.model";
import { TranDynOptModel } from "../models/tran-dyn-opt.model";
import { GetChildPriceModel } from "../models/get-child-price.model";
import { GetProcLinkModel, LinkRecordModel } from "../models/get-proc-link.model";
import { BuildTransactModel } from "../models/build-transact.model";
import { UpdateTranModel } from "../models/update-tran.model";
import { CalcDosageModel } from "../models/calc-dosage.model";
import { SaveSubTranModel } from "../models/save-sub-tran.model";
import { UpdatePStatusModel } from "../models/update-pstatus.model";
import { CheckBaseChargeModel } from "../models/check-base-charge.model";
import { GetResponseModel } from "../models/get-response.model";
import { RefundProcModel } from "../models/refund-proc.model";
import { TreatmentProcModel } from "../models/treatment-proc.model";
import { TreatGenModel } from "../models/treat-gen.model";
import { TranRecordModel } from "../models/tran-record.model";
import { SubTranRecordModel } from "../models/sub-tran-record.model";
import { DosageModel } from "../models/dosage.model";
import { CatalogService } from "./catalog.service";
import Swal from 'sweetalert2';
import { PetService } from "./pet.service";
import { PetProcsModel } from "../models/pet-proc.model";
import { DrugAdminRouteModel } from "../models/drug-admin-route.model";
import { CodesFileModel } from "../models/codes-file.model";
import { InvtListModel } from "../models/invt-list.model";
import { OrderItemInfoModel } from "../models/order-item-info.model";
import { TxSetupModel } from "../models/tx-setup.model";
import { DatePipe } from "@angular/common";
import { IndicationModel } from "../models/indication-model";
import { SearchResult } from "../models/search-result.model";
import { Proc_HandleInvtModel } from "../models/procedures-excess.model";
import { RespNotesModel } from "../models/resp-notes.model";
import { link } from "fs";
import { Console } from "console";
import { ConsoleLogger } from "@microsoft/signalr/dist/esm/Utils";
import { ProcLinksAllModel } from "../models/proc-links-all.model";
import { CurrentUserModel } from "../models/current-user.model";
import { PharmProcModel } from "../models/pharm-proc.model";
import { LabelEntry } from "../models/label-entry.model";
import { LabelEntryService } from "./label-entry.service";
import { PetDetailModel } from "../models/pet-detail.model";
import { ClientModel } from "../models/client.model";
import { AnalyticsService } from "../@core/utils";

interface NotificationPayload {
    origin: any;
    pet_no: any;
}

declare var $: any;

@Injectable({
    providedIn: "root"
})
export class ProcedureService {

    private baseUrl: string = 'procedure';
    tx_setup: TxSetupModel = new TxSetupModel(0, '', '', '', '', false, false);
    tx_setup_array: TxSetupModel[] = [];
    check_pss: CheckPetSexSpecieModel = new CheckPetSexSpecieModel(0, 0, 0, 0, 0, '', 0);
    LinkInfoParent: LinkRecordModel[] = [];
    LinkIndications: IndicationModel[] = [];
    LinkTreeview: LinkRecordModel[] = [];
    LinkList: string[] = [];
    currentUser: CurrentUserModel = new CurrentUserModel(0, 0, 0, '', '', 0, 1, 1);  //= JSON.parse(localStorage.currentUser); 
    Clinic_no: number = 1;
    strCodeName: string = '';
    txtchar: string = '';
    lngPetNo: number;
    resp_notes: RespNotesModel[] = [];

    observable1: Subscription;
    observable2: Subscription;

    private messageGenericSource = new BehaviorSubject<boolean>(false);
    selectedGeneric = this.messageGenericSource.asObservable();

    private messageFinishGenericSource = new BehaviorSubject<boolean>(false);
    selectedFinishGeneric = this.messageFinishGenericSource.asObservable();

    private messageFinishTxSetupSource = new BehaviorSubject<boolean>(false);
    selectedFinishTxSetup = this.messageFinishTxSetupSource.asObservable();

    private messageEditProcSource = new BehaviorSubject<PetProcsModel | null>(null);
    selectedEditProc = this.messageEditProcSource.asObservable();
    selectedEditProcVar(proc: PetProcsModel | null) { this.messageEditProcSource.next(proc); }
    obsTxSetup: Subscription;

    private respNotesSource = new BehaviorSubject<RespNotesModel[]>([]);
    respNotes$ = this.respNotesSource.asObservable();

    ArrayCount: number;
    admin_routes: DrugAdminRouteModel[] = [];

    // proc_cost: ProcCostModel = new ProcCostModel(0, 0, '', 0, 0);
    // handle_invt: HandleInvtModel = new HandleInvtModel(0, 0, 0, '', '', 0, '', 0, 0, '', 0, '', '', 0, 0, 0);
    // update_tran: UpdateTranInfoModel = new UpdateTranInfoModel(0, '', '', '', '', 0, 0, 0, 0, '', '');

    constructor(
        private api: ApiService,
        private clientService: ClientService,
        public petService: PetService,
        private catalogService: CatalogService,
        private datePipe: DatePipe,
        private labelEntryService: LabelEntryService,
    ) {
        this.Clinic_no = this.currentUser.clinic_no;
    }

    selectedGenericVar(message: boolean) {
        this.messageGenericSource.next(message)
    }

    selectedFinishGenericVar(message: boolean) {
        this.messageFinishGenericSource.next(message)
    }

    selectedFinishTxSetupVar(message: boolean) {
        this.messageFinishTxSetupSource.next(message)
    }

    private notify_FromEstModal = new Subject<PetProcsModel[]>();
    notify_FromEstModalObservable = this.notify_FromEstModal.asObservable();
    notify_FromEstModalFunction(procs: PetProcsModel[]) {
        this.notify_FromEstModal.next(procs);
    }

    private _estProcAdded = new Subject<void>();
    estProcAddedObservable = this._estProcAdded.asObservable();

    private notify_InitProcTableModal = new Subject<boolean>();
    notify_InitProcTableModalObservable = this.notify_InitProcTableModal.asObservable();
    notify_InitProcTableModalFunction() {
        this.notify_InitProcTableModal.next(true);
    }


    async admitted(valor: string) {
        //Swal.close();
        const { value: email } = await Swal.fire({
            title: `Enter quantity to use of ${valor}`,
            input: 'text',
            inputLabel: 'Qty. To Use',
            inputValue: valor
        })

        if (email) {
            Swal.fire(`Entered email: ${email}`)
        }
    }

    // loading() {
    //     Swal.fire({
    //         title: 'Loading...',
    //         timerProgressBar: true,
    //         didOpen: () => {
    //             Swal.showLoading()
    //         },
    //     })
    // }

    async childProc(intIndex: number, intTotalIdx: number, strCodeName: string, strStatus: string, strReqEmp: string, intEmpNo: number,
        lngClientNo: number, lngPetNo: number, lngSupSeq: number, SelectedLinks: string[]) {

        let intCodeType: number, intCodeNo: number, intSel: number;
        let intLinkCount: number;
        let intLinkCatCount: number, j: number, k: number, i: number;

        let lngSeq: number
        let strFix: string, strLinkCat: string
        let LinkInfo: LinkRecordModel[] = [];
        let DoseArr: DosageModel[] = [];
        let strOptions: string[] = [];

        let intLinkIndicationID: number = 0;


        let code = this.catalogService.codes_file.find(t => t.code_name === strCodeName);

        let RequestProc = -1
        let Result: LinkRecordModel
        //debugger;

        if (intIndex < 0) {
            if (code && code.code_type < 0) {
                Swal.fire({
                    title: `Code Not Found`,
                    text: `Invalid code type for ${strCodeName}`,
                    didOpen: () => {
                    },
                })
                return { RequestProc, Result };
            }

            intCodeType = code.code_type;
            intCodeNo = code.code_no;

            if (intCodeType === undefined) {
                Swal.fire({
                    title: `Code Not Found`,
                    text: `Invalid code type for ${strCodeName}`,
                    didOpen: () => {
                    },
                })
                return { RequestProc, Result };
            }
        }
        else {
            return { RequestProc, Result };
        }

        this.check_pss = new CheckPetSexSpecieModel(code.code_no, code.code_type, this.petService.current_pet_no, INVENT, this.Clinic_no, '', 0);
        await this.checkPetSexSpecie()
            .then(() => {
                // Swal.close();

            });
        if (this.check_pss.check !== 1) {
            Swal.fire({
                title: this.check_pss.message,
                didOpen: () => {
                },
            })
            return { RequestProc, Result };

        }

        let strCodeDesc = '';

        let intPIdx: number;

        strFix = code.code_fix;

        await this.getProcLink(new GetProcLinkModel(intCodeNo, intCodeType, strCodeName, LinkInfo, intLinkCount, intLinkCatCount, lngPetNo, this.Clinic_no, 0, ''))
            .then((res: GetProcLinkModel) => {
                LinkInfo = res.LinkInfo;
                intLinkCount = res.intLinkCount;
                intLinkCatCount = res.intLinkCatCount;
            });

        switch (strFix) {
            case 'G':
                if (intIndex >= 0) {
                    Swal.fire({
                        title: `Invalid Code Setup`,
                        text: `Group codes cannot be linked to other codes.`,
                        didOpen: () => {
                        },
                    })
                    return;
                }
                else if (intLinkCount === 0) {
                    Swal.fire({
                        text: `No linkages found for a group code.`,
                        didOpen: () => {
                        },
                    })
                    return;
                } else {
                    i = 0
                    k = 0

                    // NextLinkCat:
                    do {

                        let strLinkCat = LinkInfo[k].Category

                        for (i = k; i <= intLinkCount - 1; i++) {
                            if (strLinkCat == LinkInfo[i].Category) {
                                strOptions.push(`${LinkInfo[i].LinkName}`);
                                j = j + 1;
                            } else {
                                continue;
                            }
                        }

                        if (j == 1) {
                            intSel = 0 + k;
                        } else {

                            // intSel = OptionSelection("Select Item for " & strCodeName, j) + k
                            var some = this.findOption_v2(strOptions);
                            if (some) {
                                intSel = some.Index;
                                Result = LinkInfo[intSel]
                                SelectedLinks.push(`${Result.LinkName}`);
                            } else {
                                let options = {};
                                strOptions.forEach((element, index) => {
                                    options[`${index}`] = element;
                                });

                                const { value: selection } = await Swal.fire({
                                    title: "Select Item for " + strCodeName,
                                    input: 'select',
                                    inputOptions: options,
                                    // inputPlaceholder: 'Select a fruit',
                                    showCancelButton: false,
                                    inputValidator: (value) => {
                                        return new Promise((resolve) => {
                                            resolve(undefined)
                                        })
                                    }
                                })

                                if (selection) {
                                    // Swal.fire(`You selected: ${selection}`)
                                    // if (strOptions.some(t => t === selection)) {
                                    intSel = Number(selection) + k;
                                    Result = LinkInfo[intSel]
                                    SelectedLinks.push(`${Result.LinkName}`);
                                    // }
                                }
                            }
                        }


                        k = i;
                    } while (k < intLinkCount - 1 && i < intLinkCount);

                    RequestProc = 0;
                }
                break;
            case 'M':
                if (intLinkCount === 0) {
                    Swal.fire({
                        text: `No linkages found for a menu code.`,
                        didOpen: () => {
                        },
                    })
                    return;
                } else if (intLinkCatCount === 1) {
                    //code
                    if (intIndex < 0) {
                        for (i = 0; i <= intLinkCount - 1; i++) {
                            strOptions.push(`${LinkInfo[i].LinkName}`);
                        }
                        if (i === 1) {
                            intSel = 0;
                            Result = LinkInfo[intSel];
                            SelectedLinks.push(`${Result.LinkName}`);
                        } else {

                            var some = this.findOption_v2(strOptions);
                            if (some) {
                                intSel = some.Index;
                                Result = LinkInfo[intSel]
                            } else {
                                let options = {};
                                strOptions.forEach((element, index) => {
                                    options[`${index}`] = element;
                                });
                                //LKRK
                                const { value: selection } = await Swal.fire({
                                    title: "Select Item for " + strCodeName,
                                    input: 'select',
                                    inputOptions: options,
                                    // inputPlaceholder: 'Select a fruit',
                                    showCancelButton: true,
                                    inputValidator: (value) => {
                                        return new Promise((resolve) => {
                                            resolve(undefined)
                                        })
                                    }
                                })
                                if (selection) {
                                    intSel = Number(selection);
                                    Result = LinkInfo[intSel]
                                    SelectedLinks.push(`${Result.LinkName}`);
                                }
                            }
                        }
                        if (intSel >= 0) {

                            await this.childProc(intIndex, intTotalIdx, LinkInfo[intSel].code, strStatus, strReqEmp, intEmpNo, lngClientNo, lngPetNo, lngSupSeq, SelectedLinks)
                                .then((res) => {
                                    if (res && res.RequestProc)
                                        intIndex = res.RequestProc;


                                });
                        }
                        RequestProc = intIndex;

                    }
                } else {
                    Swal.fire({
                        text: `Too many link categories found for M type code.`,
                        didOpen: () => {
                        },
                    })
                    return;
                }
                break;

                const DoAgain = async (ejecutar: boolean, exec: boolean) => {

                    if (intIndex < 0 || ejecutar) {
                        if (exec) {
                            if (!(lngSupSeq === 0 && exec)) {
                                lngSeq = lngSupSeq;
                            }

                            i = 0;
                            k = 0;

                            DoseArr = [];
                        }

                        // DoAgain:

                        strLinkCat = LinkInfo[k].Category;
                        j = 0;
                        strOptions = [];

                        for (i = k; i <= intLinkCount - 1; i++) {
                            if (strLinkCat === LinkInfo[i].Category) {
                                strOptions.push(`${LinkInfo[i].LinkName}`);
                                if (LinkInfo[i].LinkType === INVENT) {
                                    if (LinkInfo[i].RecFix === "R") {
                                        var sglRecDose = 0;
                                        DoseArr.push(new DosageModel(sglRecDose, 0, 0, 0, ''));
                                        await this.CalcDosage(new CalcDosageModel(LinkInfo[i].LinkNo, LinkInfo[i].Dosage, lngPetNo, LinkInfo[i].Variant, DoseArr[i].sglMinDose, DoseArr[i].sglMaxDose, this.Clinic_no, DoseArr[i].sglRecDose, DoseArr[i].sglQty, DoseArr[i].QtyUnit))
                                            .then((res: CalcDosageModel) => {
                                                DoseArr[i].sglRecDose = res.CalcDose;
                                                DoseArr[i].sglMinDose = res.sglMinDose;
                                                DoseArr[i].sglMaxDose = res.sglMaxDose;
                                            });
                                        //strOptions[i] = `${strOptions[i]}"`
                                    } else if (LinkInfo[i].RecFix === "F") {
                                        // DoseArr[i].sglRecDose = LinkInfo[i].Dosage
                                        DoseArr.push(new DosageModel(LinkInfo[i].Dosage, 0, 0, LinkInfo[i].Qty, LinkInfo[i].DosageUnit));
                                    } else {
                                        // DoseArr[i].sglRecDose = 1;
                                        DoseArr.push(new DosageModel(1, 0, 0, 0, ''));
                                    }
                                } else {
                                    // DoseArr[i].sglRecDose = 1
                                    DoseArr.push(new DosageModel(1, 0, 0, 0, ''));
                                }
                                j = j + 1;
                            } else {
                                break;
                            }
                        }

                        if (j === 1) {
                            intSel = 0 + k;
                        } else {

                            // intSel = OptionSelection("Select Item for " & strCodeName, j) + k
                            var some = this.findOption_v2(strOptions);
                            if (some) {
                                intSel = some.Index + k;
                                Result = LinkInfo[intSel]
                                SelectedLinks.push(`${Result.LinkName}`);
                            } else {
                                let options = {};
                                strOptions.forEach((element, index) => {
                                    options[`${index}`] = element;
                                });
                                const { value: selection } = await Swal.fire({
                                    title: "Select Item for " + strCodeName,
                                    input: 'select',
                                    inputOptions: options,
                                    // inputPlaceholder: 'Select a fruit',
                                    showCancelButton: false,
                                    inputValidator: (value) => {
                                        return new Promise((resolve) => {
                                            resolve(undefined)
                                        })
                                    }
                                })

                                if (selection) {
                                    // Swal.fire(`You selected: ${selection}`)
                                    // if (strOptions.some(t => t === selection)) {
                                    intSel = Number(selection) + k;
                                    Result = LinkInfo[intSel]
                                    SelectedLinks.push(`${Result.LinkName}`);
                                    // }
                                }
                            }
                        }

                        if (intSel < k) {
                            return;
                        } else if (LinkInfo[intSel].LinkNo === NOMED && LinkInfo[intSel].LinkType === 0) {
                            if (k < intLinkCount - 1) {
                                if (i < intLinkCount) {
                                    k = i
                                    // GoTo DoAgain
                                    await DoAgain(true, false);
                                } else {
                                    RequestProc = intIndex
                                    // GoTo ChkOtherStatus
                                }
                            }
                        }

                        await this.childProc(-1, intTotalIdx, LinkInfo[intSel].code, strStatus, strReqEmp, intEmpNo, lngClientNo, lngPetNo, lngSeq, SelectedLinks)
                            .then((res: any) => {
                                if (res && res.RequestProc)
                                    intIndex = res.RequestProc;

                            });
                        if (k < intLinkCount - 1) {
                            if (i < intLinkCount) {
                                k = i;
                                // GoTo DoAgain
                                await DoAgain(true, false);
                            }
                        }


                    }
                    await DoAgain(true, true);
                }

                RequestProc = intIndex;
                break;
            case 'P':

                for (i = 0; i <= intLinkCount - 1; i++) {
                    strOptions.push(`${LinkInfo[i].LinkName}`);
                    if (LinkInfo[i].LinkType === INVENT) {
                        if (LinkInfo[i].RecFix === "R") {
                            var sglRecDose = 0;
                            DoseArr.push(new DosageModel(sglRecDose, 0, 0, 0, ''))
                            await this.CalcDosage(new CalcDosageModel(LinkInfo[i].LinkNo, LinkInfo[i].Dosage, lngPetNo, LinkInfo[i].Variant, DoseArr[i].sglMinDose, DoseArr[i].sglMaxDose, this.Clinic_no, DoseArr[i].sglRecDose, DoseArr[i].sglQty, DoseArr[i].QtyUnit))
                                .then((res: CalcDosageModel) => {
                                    DoseArr[i].sglRecDose = res.CalcDose;
                                    DoseArr[i].sglMinDose = res.sglMinDose;
                                    DoseArr[i].sglMaxDose = res.sglMaxDose;
                                    DoseArr[i].QtyUnit = res.QtyUnit
                                });
                            // DoseArr.push(new DosageModel(sglRecDose, 0, 0));
                            //strOptions[i] = `${strOptions[i]}"`
                        } else if (LinkInfo[i].RecFix === "F") {
                            // DoseArr[i].sglRecDose = LinkInfo[i].Dosage;
                            DoseArr.push(new DosageModel(LinkInfo[i].Dosage, 0, 0, 0, ''));
                        } else {
                            // DoseArr[i].sglRecDose = 1;
                            DoseArr.push(new DosageModel(1, 0, 0, 0, ''));
                        }
                    } else {
                        // DoseArr[i].sglRecDose = 1;
                        DoseArr.push(new DosageModel(1, 0, 0, 0, ''));
                    }
                }
                if (i === 1) {
                    intSel = 0;
                    Result = LinkInfo[intSel]
                    SelectedLinks.push(`${Result.LinkName}`);
                } else {

                    // intSel = OptionSelection("Select Item for " & strCodeName, i)e
                    var some = this.findOption_v2(strOptions);
                    if (some) {
                        intSel = some.Index;
                    } else {
                        let options = {};
                        strOptions.forEach((element, index) => {
                            options[`${index}`] = element;
                        });
                        const { value: selection } = await Swal.fire({
                            title: "Select Item for " + strCodeName,
                            input: 'select',
                            inputOptions: options,
                            // inputPlaceholder: 'Select a fruit',
                            showCancelButton: false,
                            inputValidator: (value) => {
                                return new Promise((resolve) => {
                                    resolve(undefined)
                                })
                            }
                        })

                        if (selection) {
                            // Swal.fire(`You selected: ${selection}`)
                            // if (strOptions.some(t => t === selection)) {
                            intSel = Number(selection);
                            Result = LinkInfo[intSel]
                            SelectedLinks.push(`${Result.LinkName}`);
                            // }
                        }
                    }
                }


                break;
        }

        return { RequestProc, Result };


    }

    async requestProc(Trans: TranRecordModel[], intIndex: number, intTotalIdx: number, strCodeName: string, strStatus: string, strReqEmp: string, intEmpNo: number,
        lngClientNo: number, lngPetNo: number, lngSupSeq: number, sglPrice?: number, sglLUnit?: number, strLFix?: string, strLChk?: string) {
        let intCodeType: number, intCodeNo: number, intSel: number;
        let intParentIdx: number, intParentCode: number, intLinkCount: number;
        let intLinkCatCount: number, j: number, k: number, i: number;
       
        let sglTemp: number;

        let strFix: string, strLinkFix: string = '', strLinkCat: string
        let strChkCost: string = ''
        let lngSeq: number
        let LinkInfo: LinkRecordModel[] = [];
        let SubTrans: SubTranRecordModel[];
        let DoseArr: DosageModel[] = [];
        let strOptions: string[] = [];

        let sglLinkCost: number;
        let sglLinkUnit: number; 
        let sglProcPrice: number
        let sglDosage: number = 0;

        
        let code = this.catalogService.codes_file.find(t => t.code_name === strCodeName);
        this.ArrayCount = intTotalIdx;

        // Close any open Swal.fire() to ensure that any subsequent Swal.fire() with input will work properly with the DOM in a clean state.
        //Swal.close();

        let RequestProc = -1
        //debugger;

        if (intIndex < 0) {
            if (code && code.code_type < 0) {
                Swal.fire({
                    title: `Code Not Found`,
                    text: `Invalid code type for ${strCodeName}`,
                    didOpen: () => {
                    },
                })
                return { RequestProc, Trans };
            }

            intCodeType = code.code_type;
            intCodeNo = code.code_no;

            if (intCodeType === undefined) {
                Swal.fire({
                    title: `Code Not Found`,
                    text: `Invalid code type for ${strCodeName}`,
                    didOpen: () => {
                    },
                })
                return { RequestProc, Trans };
            }
        } else {
            intCodeNo = Trans[intIndex].LinkNo;
            intCodeType = Trans[intIndex].LinkType;

            let tran: TranRecordModel = Trans[intIndex];

            if (tran.Status === 'C' && strStatus !== 'S') {
                sglPrice = Number(tran.UnitCost);
                lngSupSeq = tran.SupSeq;
                await this.deleteATran(new DeleteATranModel(Trans, intIndex, intTotalIdx, false, '', this.Clinic_no, 0, false))
                    .then(() => { });
                intIndex = -1
            } else if (tran.Status === 'S' && strStatus !== 'S') {
                await this.deleteATran(new DeleteATranModel(Trans, intIndex, intTotalIdx, false, '', this.Clinic_no, 0, false))
                    .then(() => { });
                intIndex = -1
            }
        }
        //console.log('RequestProc.3:', RequestProc) 
        this.check_pss = new CheckPetSexSpecieModel(code.code_no, code.code_type, this.petService.current_pet_no, INVENT, this.Clinic_no, '', 0);
        const PetSexSpecie: CheckPetSexSpecieModel = await this.checkPetSexSpecie();
        //console.log('RequestProc.4:', RequestProc) 
        if (PetSexSpecie.check != 1) {
            await Swal.fire({
                title: PetSexSpecie.message,
                didOpen: () => {
                },
            });

            return { RequestProc, Trans };
        }

        let strCodeDesc = '';

        switch (strStatus) {
            case 'C':
                if (lngSupSeq !== 0) {
                    Swal.fire({
                        title: `Cannot change status to C for this item.`,
                        didOpen: () => {
                        },
                    })
                    return;
                }
                this.handleCorS(new HandleCorSModel(lngClientNo, lngPetNo, intCodeNo, intCodeType, "C", strReqEmp, intEmpNo, Trans, intTotalIdx, intIndex, strCodeName, strCodeDesc, this.Clinic_no))
                    .then((_intIndex: number) => {
                        //Success
                        RequestProc = _intIndex;
                    });

                break;
            case 'S':
                if (lngSupSeq !== 0) {
                    Swal.fire({
                        title: `Cannot change status to S for this item.`,
                        didOpen: () => {
                        },
                    })
                    return;
                }
                if (intIndex < 0) {
                    await this.handleCorS(new HandleCorSModel(lngClientNo, lngPetNo, intCodeNo, intCodeType, "S", strReqEmp, intEmpNo, Trans, intTotalIdx, intIndex, strCodeName, strCodeDesc, this.Clinic_no))
                        .then((_intIndex: number) => {
                            //Success
                            RequestProc = _intIndex;
                        });
                } else {
                    await this.updateStatus(new UpdateStatusModel(Trans[intIndex], "S"))
                        .then((res: boolean) => {
                            //Success
                            if (res) {
                                RequestProc = intIndex;
                            }
                        });
                }
                break;
            case 'W':
                if (intIndex >= 0) {
                    await this.updateStatus(new UpdateStatusModel(Trans[intIndex], "W"))
                        .then((res: boolean) => {
                            //Success
                            if (res) {
                                RequestProc = intIndex;
                            }
                        });
                }
                break;
            case 'E':
                if (intIndex < 0)
                    strStatus = 'R'
                else if (Trans[intIndex].IsRerequest === "R") {
                    //this.requestProc
                    intIndex = -1;
                    await this.requestProc(Trans, intIndex, intTotalIdx, strCodeName, "R", strReqEmp, intEmpNo, lngClientNo, lngPetNo, lngSupSeq)
                        .then((res) => {
                            if (res && res.RequestProc)
                                intIndex = res.RequestProc;
                            if (res && res.Trans)
                                Trans = res.Trans;
                        });
                    Trans[intIndex].IsRerequest = "Y";
                    await this.tranDynOpt(new TranDynOptModel(Trans[intIndex])).then(() => { });
                    RequestProc = intIndex;
                } else {
                    Swal.fire({
                        title: `This code may not be re-requested.`,
                        didOpen: () => {
                        },
                    })
                    return;
                }
                break;
            case 'R':
                if (this.tx_setup_array.length > 0) {
                    strStatus = 'T';
                }
                break;
            default:
                break;
        }

        let intPIdx: number;

        if (intIndex < 0 && lngSupSeq !== 0) {
            intParentCode = this.getParentCode(Trans, intTotalIdx, lngSupSeq, intParentIdx);
            await this.getChildPrice(new GetChildPriceModel(intParentCode, intCodeNo, intCodeType, sglLinkCost, strLinkFix, sglLinkUnit, lngPetNo, strChkCost, this.Clinic_no))
                .then((res: GetChildPriceModel) => {
                    sglLinkCost = res.sglLinkCost
                    sglLinkUnit = res.sglLinkUnit
                    strChkCost = res.strChkCost
                    strLinkFix = res.strLinkFix
                });
        }



        // ChkOtherStatus:
        const ChkOtherStatus = async () => {
            //debugger;
            if (intIndex < 0) {
                // MsgBox "Transaction was not created properly.", vbExclamation, "Request Failed"
                Swal.fire({
                    text: 'Transaction was not created properly.',
                })
                RequestProc = -1;
                return { RequestProc, Trans };
            }


            if (strStatus === "F") {
                await this.getResponse(new GetResponseModel(Trans[intIndex], false, this.Clinic_no)).then(() => { });
                if (Trans[intIndex].Cost >= 0) {
                    let refundProc = false;
                    await this.refundProc(new RefundProcModel(Trans, intIndex, intTotalIdx, '', 0, 1, 1))
                        .then((res: boolean) => {
                            refundProc = res;
                        });

                    if (refundProc) {
                        RequestProc = intIndex;
                        Trans[intIndex].DoneBy = intEmpNo;
                        Trans[intIndex].DoneDate = new Date().toLocaleDateString("en-US");
                        Trans[intIndex].DoneName = strReqEmp;

                        let u1 = new UpdateTranModel(undefined, 0, '', false, 0, '', 0, 0, '', 0);
                        u1.Trans = Trans[intIndex];
                        u1.intIndex = intIndex;
                        u1.sglLUnit = intEmpNo;
                        await this.updateTranBaseDone(u1).then(() => { });
                    } else {
                        RequestProc = -1;
                    }
                } else {
                    RequestProc = intIndex;
                    if (Trans[intIndex].DoneBy <= 0) {
                        Trans[intIndex].DoneBy = intEmpNo;
                        Trans[intIndex].DoneDate = new Date().toLocaleDateString("en-US");
                        Trans[intIndex].DoneName = strReqEmp;

                        let u1 = new UpdateTranModel(undefined, 0, '', false, 0, '', 0, 0, '', 0);
                        u1.Trans = Trans[intIndex];
                        u1.intIndex = intIndex;
                        u1.sglLUnit = intEmpNo;
                        await this.updateTranBaseDone(u1).then(() => { });
                    }

                    let u1 = new UpdateTranModel(undefined, 0, '', false, 0, '', 0, 0, '', 0);
                    u1.Trans = Trans[intIndex];
                    u1.intIndex = intIndex;
                    u1.sglProcPrice = Trans[intIndex].Cost;
                    await this.updateTranCost(u1).then(() => { });
                }
            } else if (strStatus === "T" && Trans[intIndex].SupSeq === 0) {
                if (Trans[intIndex].LinkType === INVENT) {
                    // sglLinkUnit = Val(MyInputBox("Enter quantity to use of " & vbCrLf & Trans[intIndex].LinkDesc, _
                    // "Qty. To Use", str$(Trans[intIndex].Unit), 6))

                    //declined = false;
                    
                    var some = this.findOption(strOptions);
                    if (some && some.Option) {
                         intSel = some.Index;
                        sglLinkUnit = some.Option.Qty;   
                        sglDosage = some.Option.Dosage;
                       
                        //    declined = (typeof some.Option.Declined === 'undefined') ? false : some.Option.Declined;
                    } else {
                        //Swal.close();
                        const { value: quantity } = await Swal.fire({
                            title: `Enter quantity to use of ${Trans[intIndex].LinkDesc}`,
                            input: 'text',
                            inputLabel: 'Qty. To Use',
                            inputValue: Trans[intIndex].Unit ?? ''
                            // inputPlaceholder: 'Enter your email address'
                        })

                        if (quantity) {
                            // Swal.fire(`Entered email: ${quantity}`)
                            sglLinkUnit = quantity;
                        }
                    }

                    if (sglLinkUnit > 0) {
                        Trans[intIndex].Unit = sglLinkUnit;


                        let u1 = new UpdateTranModel(undefined, 0, '', false, 0, '', 0, 0, '', 0);
                        u1.Trans = Trans[intIndex];
                        u1.intIndex = intIndex;
                        u1.sglLUnit = sglLinkUnit;

                        await this.updateTranLUnit(u1).then(() => { });
                    }
                }

                await this.updateStatus(new UpdateStatusModel(Trans[intIndex], strStatus)).then(() => { });
            }

            return { RequestProc, Trans };
        }

        // await this.petService.findFix(intCodeNo, intCodeType, strFix).then(() => { });
        strFix = code.code_fix;

        await this.assignProcLinkData(lngSupSeq, new GetProcLinkModel(intCodeNo, intCodeType, strCodeName, LinkInfo, intLinkCount, intLinkCatCount, lngPetNo, this.Clinic_no, 0, strStatus))
            .then((res: GetProcLinkModel) => {
                LinkInfo = res.LinkInfo;
                intLinkCount = res.intLinkCount;
                intLinkCatCount = res.intLinkCatCount;
                strStatus = res.strStatus || strStatus;
            });


        if (intCodeType === INVENT) {           
                
            if (intIndex < 0) {
                if (sglLUnit === 0) sglLUnit = 1;
                       
                if (strStatus === "F" || strStatus === "T" || strStatus === "S" || (strStatus === "D" && lngSupSeq > 0)) {
                    await this.handleInvt(new HandleInvtModel(lngClientNo, lngPetNo, intCodeNo, strStatus, strReqEmp, intEmpNo, strFix, Trans, intTotalIdx, intIndex, strCodeName, lngSupSeq, strLFix, sglLinkUnit, this.Clinic_no))
                        .then(async (res: any) => {
                            Trans = res.Trans;
                            intIndex = res.intIndex;
                            await this.buildTreatGen_array(Trans, intIndex, intTotalIdx);

                        });
                } else {
                    await this.handleInvt(new HandleInvtModel(lngClientNo, lngPetNo, intCodeNo, "R", strReqEmp, intEmpNo, strFix, Trans, intTotalIdx, intIndex, strCodeName, lngSupSeq, strLFix, sglLinkUnit, this.Clinic_no))
                        .then(async (res: any) => {
                            Trans = res.Trans;
                            intIndex = res.intIndex;
                            await this.buildTreatGen_array(Trans, intIndex, intTotalIdx);
                        });

                    if (strStatus === "T" && strLChk === "F") {
                        await this.updateTranInfo(new UpdateTranInfoModel(Trans[intIndex], sglPrice / sglLUnit, strLFix, sglLinkUnit, strLChk, 0 ))
                            .then(() => { });
                    } else if (strStatus === "F" && strLChk === "N") {
                        Trans[intIndex].UnitCost = 0
                    }
                }

                if (strLinkFix !== '') {
                    if (lngSupSeq !== 0) {
                        await this.updateTranInfo(new UpdateTranInfoModel(Trans[intIndex], sglLinkCost, strLinkFix, sglLinkUnit, strChkCost, 0))
                            .then((update_tran: UpdateTranInfoModel) => {
                                sglLinkCost = update_tran.sglLinkCost;
                                strLinkFix = update_tran.strLinkFix;
                                sglLinkUnit = update_tran.sglLinkUnit;
                            });
                    }
                }
            } else {

                await this.updateStatus(new UpdateStatusModel(Trans[intIndex], strStatus))
                    .then(() => { });
            }

            RequestProc = intIndex
            return await ChkOtherStatus();
        } //INVENT

        if (intIndex < 0) {
            // this.proc_cost = new ProcCostModel(intCodeNo, 0, strStatus, 0, 1);
            await this.getProcCost(new ProcCostModel(intCodeNo, 0, strStatus, 0, this.Clinic_no, lngPetNo))
                .then((proc_cost: ProcCostModel) => {
                    sglProcPrice = proc_cost.getProcCost;
                })
        }



        switch (strFix) {
            case 'F':
                if (intLinkCount === 0) {
                    if (intIndex < 0) {
                        var build = new BuildTransactModel(
                                lngClientNo,
                                this.Clinic_no,
                                lngPetNo,
                                intCodeNo,
                                intCodeType,
                                strCodeName,
                                "",
                                0,
                                "",
                                strFix,
                                sglLinkUnit,
                                sglLinkCost,
                                "",
                                sglDosage,
                                "",
                                "",
                                "",
                                0,
                                null,
                                intEmpNo, 
                                strReqEmp, 
                                strStatus,
                                sglPrice,
                                lngSupSeq,
                                Trans,
                                intTotalIdx,
                                intIndex

                        );    
                        await this.buildTransact(build)
                            .then(async (res: any) => {
                                Trans = res.Trans;
                                intIndex = res.intIndex;

                                await this.buildTreatGen_array(Trans, intIndex, intTotalIdx);
                            });

                        if (lngSupSeq !== 0) {
                            await this.updateTranInfo(new UpdateTranInfoModel(Trans[intIndex], sglLinkCost, strLinkFix, sglLinkUnit, "", 0))
                                .then((update_tran: UpdateTranInfoModel) => {
                                    Trans[intIndex].Cost = update_tran.sglLinkCost;
                                    Trans[intIndex].LinkFix = update_tran.strLinkFix;
                                    Trans[intIndex].Unit = update_tran.sglLinkUnit;
                                });
                        }

                        // strSQL = "UPDATE tblTransaction SET unit_cost = unit_cost + " & sglProcPrice _
                        // & ", unit = 1, cost = cost + " & sglProcPrice _
                        // & " WHERE tran_sequence = " & Trans[intSel].Seq
                        // Call DB_Update(strSQL)
                        let u1 = new UpdateTranModel(undefined, 0, '', false, 0, '', 0, 0, '', 0);
                        u1.Trans = Trans[intIndex];
                        u1.intIndex = intIndex;
                        u1.sglProcPrice = sglProcPrice;
                        await this.updateTran(u1).then(() => { });

                        Trans[intIndex].UnitCost = Trans[intIndex].UnitCost + sglProcPrice;
                        Trans[intIndex].Cost = Trans[intIndex].Cost + sglProcPrice;
                    } else {
                        await this.updateStatus(new UpdateStatusModel(Trans[intIndex], strStatus))
                            .then(() => { });
                    }
                } else if (intLinkCatCount === 1) {
                    if (intIndex < 0) {
                        strOptions = [];
                        for (i = 0; i <= intLinkCount - 1; i++) {
                            strOptions.push(`${LinkInfo[i].LinkName}`);
                            if (LinkInfo[i].LinkType === INVENT) {
                                if (LinkInfo[i].RecFix === "R") {
                                    var sglRecDose = 0;
                                    DoseArr.push(new DosageModel(sglRecDose, 0, 0, 0, ''));
                                    await this.CalcDosage(new CalcDosageModel(LinkInfo[i].LinkNo, LinkInfo[i].Dosage, lngPetNo, LinkInfo[i].Variant, DoseArr[i].sglMinDose, DoseArr[i].sglMaxDose, this.Clinic_no, DoseArr[i].sglRecDose, DoseArr[i].sglQty, DoseArr[i].QtyUnit))
                                        .then((res: CalcDosageModel) => {
                                            DoseArr[i].sglRecDose = res.CalcDose;
                                            DoseArr[i].sglMinDose = res.sglMinDose;
                                            DoseArr[i].sglMaxDose = res.sglMaxDose;
                                            DoseArr[i].QtyUnit = res.QtyUnit;
                                        });
                                    //strOptions[i] = `${strOptions[i]}"`
                                    //strOptions[i] = `${strOptions[i]}  (${DoseArr[i].sglRecDose})"`
                                }
                            }
                        }

                        // intSel = OptionSelection("Select Item for " & strCodeName, i)
                        //         declined = false;
                        var some = this.findOption(strOptions,LinkInfo);
                        
                        if (some.Index != -1) {
                            intSel = some.Index;
                            sglLinkUnit = some.Option.Qty;   
                            sglDosage = some.Option.Dosage;
                            
                        } else {
                            let options = {};
                            strOptions.forEach((element, index) => {
                                options[`${index}`] = element;
                            });
                            const { value: selection } = await Swal.fire({
                                title: "Select Item for " + strCodeName,
                                input: 'select',
                                inputOptions: options,
                                // inputPlaceholder: 'Select a fruit',
                                showCancelButton: false,
                                inputValidator: (value) => {
                                    return new Promise((resolve) => {
                                        resolve(undefined)
                                    })
                                }
                            })

                            if (selection) {
                                // Swal.fire(`You selected: ${selection}`)
                                // if (strOptions.some(t => t === selection)) {
                                intSel = Number(selection);

                                // }
                            }
                        }



                        if (intSel < 0) return;

                        SubTrans.push(new SubTranRecordModel(0, 0, 0, false, false, '', 0, '', 0))
                        SubTrans[0].BaseCharge = LinkInfo[intSel].BaseCharge;

                        if (LinkInfo[intSel].ChkPrice === "Y") {
                            SubTrans[0].CheckCost = true;
                            let getProcCost = 0;
                            await this.getProcCost(new ProcCostModel(LinkInfo[intSel].LinkNo, LinkInfo[intSel].LinkType, strStatus, getProcCost, this.Clinic_no, lngPetNo))
                                .then((proc_cost: ProcCostModel) => {
                                    SubTrans[0].UnitCost = proc_cost.getProcCost;
                                })
                        }
                        else {
                            SubTrans[0].CheckCost = false;
                            SubTrans[0].UnitCost = LinkInfo[intSel].SalePrice;


                            SubTrans[0].FixUnit = LinkInfo[intSel].RecFix;
                            SubTrans[0].LinkNo = LinkInfo[intSel].LinkNo;
                            SubTrans[0].SubHist = Boolean(LinkInfo[intSel].SubHist);

                            if (LinkInfo[intSel].RecFix === "R") {
                                SubTrans[0].Unit = LinkInfo[intSel].Dosage;
                            } else if (LinkInfo[intSel].RecFix === "F") {
                                // SubTrans[0].Unit = Val(MyInputBox("Enter quantity to use of " & vbCrLf & LinkInfo[intSel].Desc, _
                                //                                         "Qty. To Use", str$(LinkInfo[intSel].Dosage), 6))

                                //declined = false;
                                
                                var some = this.findOption(strOptions,LinkInfo);
                                if (some.Index != -1) {
                                    
                                    sglLinkUnit = some.Option.Qty;   
                                    sglDosage = some.Option.Dosage;
                                   
                                    SubTrans[0].Unit = sglLinkUnit;
                                } else {
                                    if (strOptions.length > 0) {
                                        //Swal.close();
                                        const { value: quantity } = await Swal.fire({
                                            title: `Enter quantity to use of ${LinkInfo[intSel].Desc}`,
                                            input: 'text',
                                            inputLabel: 'Qty. To Use',
                                            inputValue: LinkInfo[intSel].Dosage ?? ''
                                            // inputPlaceholder: 'Enter your email address'
                                        })

                                        if (quantity) {
                                            // Swal.fire(`Entered email: ${quantity}`)
                                            SubTrans[0].Unit = quantity;
                                        }
                                    }
                                }
                            }

                            if (strStatus === "F") {
                                SubTrans[0].Unit = SubTrans[0].Unit * -1;
                            }

                            SubTrans[0].LinkType = LinkInfo[intSel].LinkType;
                        }
                        var build = new BuildTransactModel(
                                lngClientNo,
                                this.Clinic_no,
                                lngPetNo,
                                intCodeNo,
                                intCodeType,
                                strCodeName,
                                "",
                                0,
                                "",
                                strFix,
                                sglLinkUnit,
                                sglLinkCost,
                                "",
                                sglDosage,
                                "",
                                "",
                                "",
                                0,
                                null,
                                intEmpNo, 
                                strReqEmp, 
                                strStatus,
                                sglPrice,
                                lngSupSeq,
                                Trans,
                                intTotalIdx,
                                intIndex

                        );    
                        if (LinkInfo[intSel].LinkType === INVENT) {
                            await this.buildTransact(build)
                                .then(async (res: any) => {
                                    Trans = res.Trans;
                                    intIndex = res.intIndex;
                                    await this.buildTreatGen_array(Trans, intIndex, intTotalIdx);

                                });
                        } else if (strStatus === "F") {
                            SubTrans[0].UnitCost = SubTrans[0].UnitCost * -1;
                            await this.buildTransact(build)
                                .then(async (res: any) => {
                                    Trans = res.Trans;
                                    intIndex = res.intIndex;
                                    await this.buildTreatGen_array(Trans, intIndex, intTotalIdx);
                                });
                        } else {
                            await this.buildTransact(build)
                                .then(async (res: any) => {
                                    Trans = res.Trans;
                                    intIndex = res.intIndex;
                                    await this.buildTreatGen_array(Trans, intIndex, intTotalIdx);
                                });
                        }

                        SubTrans[0].Seq = Trans[intIndex].Seq;
                        await this.saveSubTran(new SaveSubTranModel(SubTrans, 1), LinkInfo[intSel].code, LinkInfo[intSel].Desc)
                            .then(() => { });

                        if (lngSupSeq != 0) {

                            await this.updateTranInfo(new UpdateTranInfoModel(Trans[intIndex], Trans[intIndex].Cost, Trans[intIndex].LinkFix, Trans[intIndex].Unit, strLChk, 0))
                                .then(() => { });

                            let u1 = new UpdateTranModel(undefined, 0, '', false, 0, '', 0, 0, '', 0);
                            u1.Trans = Trans[intIndex];
                            u1.intIndex = intIndex;
                            u1.sglProcPrice = sglProcPrice;
                            await this.updateTran(u1)
                                .then(() => { });

                            Trans[intIndex].UnitCost = Trans[intIndex].UnitCost + SubTrans[0].UnitCost;
                            Trans[intIndex].Cost = Trans[intIndex].Cost + sglProcPrice;
                        }
                    } else {
                        await this.updateStatus(new UpdateStatusModel(Trans[intIndex], strStatus))
                            .then(() => { });
                    }

                    RequestProc = intIndex;
                } else {
                    Swal.fire({
                        title: `Too many link categories found for F type code.`,
                        didOpen: () => {
                        },
                    })
                    return;
                }
                break;
            case 'G':
                if (intIndex >= 0) {
                    Swal.fire({
                        title: `Invalid Code Setup`,
                        text: `Group codes cannot be linked to other codes.`,
                        didOpen: () => {
                        },
                    })
                    return;
                } else if (intLinkCount === 0) {
                    Swal.fire({
                        text: `No linkages found for a group code.`,
                        didOpen: () => {
                        },
                    })
                    return;
                } else {
                    i = 0
                    k = 0

                    // NextLinkCat:
                    strOptions = [];
                    do {

                        let strLinkCat = LinkInfo[k].Category

                        for (i = k; i <= intLinkCount - 1; i++) {
                            if (strLinkCat == LinkInfo[i].Category) {
                                strOptions.push(`${LinkInfo[i].LinkName}`);
                                j = j + 1;
                            } else {
                                continue;
                            }
                        }

                        if (j == 1) {
                            intSel = 0 + k;
                        } else {

                            // intSel = OptionSelection("Select Item for " & strCodeName, j) + k
                            //declined = false;
                            
                            var some = this.findOption(strOptions,LinkInfo);
                            if (some.Index != -1) {
                                    intSel = some.Index;
                                    sglLinkUnit = some.Option.Qty;   
                                    sglDosage = some.Option.Dosage;
                                   
                                //    declined = (typeof some.Option.Declined === 'undefined') ? false : some.Option.Declined;
                            } else {
                                let options = {};
                                strOptions.forEach((element, index) => {
                                    options[`${index}`] = element;
                                });

                                const { value: selection } = await Swal.fire({
                                    title: "Select Item for " + strCodeName,
                                    input: 'select',
                                    inputOptions: options,
                                    // inputPlaceholder: 'Select a fruit',
                                    showCancelButton: false,
                                    inputValidator: (value) => {
                                        return new Promise((resolve) => {
                                            resolve(undefined)
                                        })
                                    }
                                })

                                if (selection) {
                                    // Swal.fire(`You selected: ${selection}`)
                                    // if (strOptions.some(t => t === selection)) {
                                    intSel = Number(selection) + k;
                                    // }

                                }
                            }
                        }

                        if (intSel >= k) {
                            await this.requestProc(Trans, -1, intTotalIdx, LinkInfo[intSel].code, "C", strReqEmp, intEmpNo, lngClientNo, lngPetNo, lngSeq)
                                .then((res) => {
                                    if (res && res.RequestProc)
                                        intIndex = res.RequestProc;
                                    if (res && res.Trans)
                                        Trans = res.Trans;
                                });


                            await this.updateTranInfo(new UpdateTranInfoModel(Trans[intIndex], Trans[intIndex].Cost, Trans[intIndex].LinkFix, Trans[intIndex].Unit, LinkInfo[intSel].ChkPrice, 0))
                                .then(() => { });

                            if (LinkInfo[intSel].ChkPrice != "Y") {
                                let u1 = new UpdateTranModel(undefined, 0, '', false, 0, '', 0, 0, '', 0);
                                u1.Trans = Trans[intIndex];
                                u1.intIndex = intIndex;
                                u1.sglProcPrice = LinkInfo[intSel].SalePrice;
                                await this.updateTranSec(u1)
                                    .then(() => { });
                            }

                            Trans[intIndex].UnitCost = LinkInfo[intSel].SalePrice;
                        }

                        k = i;
                    } while (k < intLinkCount - 1 && i < intLinkCount);

                    RequestProc = 0;
                }
                break;
            case 'M':
                if (intLinkCount === 0) {
                    Swal.fire({
                        text: `No linkages found for a menu code.`,
                        didOpen: () => {
                        },
                    })
                    return;
                } else if (intLinkCatCount === 1) {
                    //code
                    if (intIndex < 0) {
                        strOptions = [];
                        for (i = 0; i <= intLinkCount - 1; i++) {
                            strOptions.push(`${LinkInfo[i].LinkName}`);
                        }
                        if (i === 1) {
                            intSel = 0;
                        } else {

                            // intSel = OptionSelection("Select Item for " & strCodeName, i)
                            //declined = false;
                            
                            var some = this.findOption(strOptions,LinkInfo);
                            if (some.Index != -1) {
                                    intSel = some.Index;
                                    sglLinkUnit = some.Option.Qty;   
                                    sglDosage = some.Option.Dosage;
                                   
                            } else {
                                let options = {};
                                strOptions.forEach((element, index) => {
                                    options[`${index}`] = element;
                                });
                                const { value: selection } = await Swal.fire({
                                    title: "Select Item for " + strCodeName,
                                    input: 'select',
                                    inputOptions: options,
                                    // inputPlaceholder: 'Select a fruit',
                                    showCancelButton: false,
                                    inputValidator: (value) => {
                                        return new Promise((resolve) => {
                                            resolve(undefined)
                                        })
                                    }
                                })

                                if (selection) {
                                    // Swal.fire(`You selected: ${selection}`)
                                    // if (strOptions.some(t => t === selection)) {
                                    intSel = Number(selection);
                                    // }
                                }
                            }
                        }
                        if (intSel < 0) {
                            var build = new BuildTransactModel(
                                lngClientNo,
                                this.Clinic_no,
                                lngPetNo,
                                intCodeNo,
                                intCodeType,
                                strCodeName,
                                "",
                                0,
                                "",
                                strFix,
                                sglLinkUnit,
                                sglLinkCost,
                                "",
                                sglDosage,
                                "",
                                "",
                                "",
                                0,
                                null,
                                intEmpNo, 
                                strReqEmp, 
                                strStatus,
                                sglPrice,
                                lngSupSeq,
                                Trans,
                                intTotalIdx,
                                intIndex

                        ); 

                            build.Status = "C";
                            await this.buildTransact(build)
                                .then(async (res: any) => {
                                    Trans = res.Trans;
                                    intIndex = res.intIndex;
                                    await this.buildTreatGen_array(Trans, intIndex, intTotalIdx);
                                });
                        } else {
                            await this.requestProc(Trans, intIndex, intTotalIdx, LinkInfo[intSel].code, strStatus, strReqEmp, intEmpNo, lngClientNo, lngPetNo, lngSupSeq, sglPrice)
                                .then((res) => {
                                    if (res && res.RequestProc)
                                        intIndex = res.RequestProc;
                                    if (res && res.Trans)
                                        Trans = res.Trans;
                                });
                        }
                        RequestProc = intIndex;
                    }
                } else {
                    Swal.fire({
                        text: `Too many link categories found for M type code.`,
                        didOpen: () => {
                        },
                    })
                    return;
                }
                break;
            case 'P':
                if (intLinkCatCount === 0) {
                    if (intIndex < 0) {
                         var build = new BuildTransactModel(
                                lngClientNo,
                                this.Clinic_no,
                                lngPetNo,
                                intCodeNo,
                                intCodeType,
                                strCodeName,
                                "",
                                0,
                                "",
                                strFix,
                                sglLinkUnit,
                                sglLinkCost,
                                "",
                                sglDosage,
                                "",
                                "",
                                "",
                                0,
                                null,
                                intEmpNo, 
                                strReqEmp, 
                                strStatus,
                                sglPrice,
                                lngSupSeq,
                                Trans,
                                intTotalIdx,
                                intIndex

                        );    
                        await this.buildTransact(build)
                            .then(async (res: any) => {
                                Trans = res.Trans;
                                intIndex = res.intIndex;
                                await this.buildTreatGen_array(Trans, intIndex, intTotalIdx);
                            });

                        if (strStatus === "F" && Trans[intIndex].Unit > 0) {
                            let u1 = new UpdateTranModel(undefined, 0, '', false, 0, '', 0, 0, '', 0);
                            u1.Trans = Trans[intIndex];
                            u1.intIndex = intIndex;
                            u1.sglProcPrice = 0;
                            await this.updateTranUnit(u1).then(() => { });
                            Trans[intIndex].Unit = Trans[intIndex].Unit * -1;
                        }
                    } else {
                        await this.updateStatus(new UpdateStatusModel(Trans[intIndex], strStatus))
                            .then((res: boolean) => {
                                //Success
                                if (res) {
                                    lngSupSeq = Trans[intIndex].SupSeq;
                                }
                            });
                    }

                    if (lngSupSeq != 0) {

                        await this.updateTranInfo(new UpdateTranInfoModel(Trans[intIndex], sglLinkCost, strLinkFix, sglLinkUnit, "", 0))
                            .then(() => { });
                    }
                } else if (intLinkCatCount === 1) {
                    strOptions = [];
                    for (i = 0; i <= intLinkCount - 1; i++) {
                        strOptions.push(`${LinkInfo[i].LinkName}`);
                        if (LinkInfo[i].LinkType === INVENT) {
                            if (LinkInfo[i].RecFix === "R") {
                                var sglRecDose = 0;
                                DoseArr.push(new DosageModel(sglRecDose, 0, 0, 0, ''))
                                await this.CalcDosage(new CalcDosageModel(LinkInfo[i].LinkNo, LinkInfo[i].Dosage, lngPetNo, LinkInfo[i].Variant, DoseArr[i].sglMinDose, DoseArr[i].sglMaxDose, this.Clinic_no, DoseArr[i].sglRecDose, DoseArr[i].sglQty, DoseArr[i].QtyUnit))
                                    .then((res: CalcDosageModel) => {
                                        DoseArr[i].sglRecDose = res.CalcDose;
                                        DoseArr[i].sglMinDose = res.sglMinDose;
                                        DoseArr[i].sglMaxDose = res.sglMaxDose;
                                        DoseArr[i].QtyUnit = res.QtyUnit;
                                    });
                                // DoseArr.push(new DosageModel(sglRecDose, 0, 0));
                                //strOptions[i] = `${strOptions[i]}"`
                            } else if (LinkInfo[i].RecFix === "F") {
                                // DoseArr[i].sglRecDose = LinkInfo[i].Dosage;
                                DoseArr.push(new DosageModel(LinkInfo[i].Dosage, 0, 0, LinkInfo[i].Qty, LinkInfo[i].DosageUnit));
                            } else {
                                // DoseArr[i].sglRecDose = 1;
                                DoseArr.push(new DosageModel(1, 0, 0, 0, ''));
                            }
                        } else {
                            // DoseArr[i].sglRecDose = 1;
                            DoseArr.push(new DosageModel(1, 0, 0, 0, ''));
                        }
                    }



                    // intSel = OptionSelection("Select Item for " & strCodeName, i)e

                    //declined = false;
                    

                    var some = this.findOption(strOptions,LinkInfo);
                    if (some.Index != -1) {
                            intSel = some.Index;
                            sglLinkUnit = some.Option.Qty;   
                            sglDosage = some.Option.Dosage;
                          
                    } else {
                        let options = {};
                        strOptions.forEach((element, index) => {
                            options[`${index}`] = element;
                        });
                        const { value: selection } = await Swal.fire({
                            title: "Select Item for " + strCodeName,
                            input: 'select',
                            inputOptions: options,
                            // inputPlaceholder: 'Select a fruit',
                            showCancelButton: false,
                            inputValidator: (value) => {
                                return new Promise((resolve) => {
                                    resolve(undefined)
                                })
                            }
                        })

                        if (selection) {
                            intSel = Number(selection);
                           
                        }
                    }

                    if (intSel < 0) return;

                    let strParent = '';
                    if (intIndex < 0) {
                        strParent = strCodeName;
                        if (LinkInfo[intSel].ChkPrice === "Y") {
                            let getProcCost = 0;
                            await this.getProcCost(new ProcCostModel(LinkInfo[intSel].LinkNo, LinkInfo[intSel].LinkType, strStatus, getProcCost, this.Clinic_no, lngPetNo))
                                .then((proc_cost: ProcCostModel) => {
                                    sglLinkCost = proc_cost.getProcCost;
                                })
                        } else {
                            sglLinkCost = LinkInfo[intSel].SalePrice;
                        }

                        if (LinkInfo[intSel].RecFix === "R") {
                            // sglLinkUnit = Val(MyInputBox("Enter quantity to use of " & vbCrLf & LinkInfo[intSel].Desc _
                            //                         & vbCrLf & "Recommended range: " & DoseArr[intSel].sglMinDose & " - " _
                            //                         & DoseArr[intSel].sglMaxDose, "Qty. To Use", str$(DoseArr[intSel].sglRecDose), 6))
                            //declined = false;
                            
                            var some = this.findOption(strOptions,LinkInfo);
                            if (some.Index != -1) { //LKRK
                                    sglLinkUnit = some.Option.Qty;   
                                    sglDosage = some.Option.Dosage;
                                                                } else {
                                //Swal.close();
                                const { value: quantity } = await Swal.fire({
                                    title: `Enter quantity to use of ${LinkInfo[intSel].Desc}`,
                                    text: `Recommended range: ${DoseArr[intSel].sglMinDose} - ${DoseArr[intSel].sglMaxDose}`,
                                    input: 'text',
                                    inputLabel: 'Qty. To Use',
                                    inputValue: LinkInfo[intSel].Dosage ?? ''
                                    // inputPlaceholder: 'Enter your email address'
                                })

                                if (quantity) {
                                    // Swal.fire(`Entered email: ${quantity}`)
                                    sglLinkUnit = quantity;
                                }
                            }
                        } else if (LinkInfo[intSel].RecFix === "F") {
                            // SubTrans[0].Unit = LinkInfo[intSel].Dosage;
                            // SubTrans.push(new SubTranRecordModel(0, 0, LinkInfo[intSel].Dosage, 0, 0, '', 0, '', 0));
                            sglLinkUnit = LinkInfo[intSel].Dosage;
                        } else if (LinkInfo[intSel].LinkType === INVENT) {
                            // sglLinkUnit = Val(MyInputBox("Enter quantity to use of " & vbCrLf & LinkInfo[intSel].Desc, _
                            // "Qty. To Use", str$(LinkInfo[intSel].Dosage), 6))

                            //declined = false;
                            
                            var some = this.findOption(strOptions,LinkInfo);
                            if (some.Index != -1) {
                                
                                    sglLinkUnit = some.Option.Qty;   
                                    sglDosage = some.Option.Dosage;
                                    
                            } else {
                                //Swal.close();   
                                const { value: quantity } = await Swal.fire({
                                    title: `Enter quantity to use of ${LinkInfo[intSel].Desc}`,
                                    input: 'text',
                                    inputLabel: 'Qty. To Use',
                                    inputValue: LinkInfo[intSel].Dosage ?? ''
                                    // inputPlaceholder: 'Enter your email address'
                                })

                                if (quantity) {
                                    // Swal.fire(`Entered email: ${quantity}`)
                                    sglLinkUnit = quantity;
                                }
                            }
                        }

                        strLinkFix = LinkInfo[intSel].SaleTreat;

                        if (strStatus === "F" || strStatus === "T" || strStatus === "S" || (strStatus === "D" && lngSupSeq > 0)) {
                            const res = await this.requestProc(Trans, intIndex, intTotalIdx, LinkInfo[intSel].code, strStatus, strReqEmp, intEmpNo, lngClientNo, lngPetNo, lngSupSeq, sglLinkCost, sglLinkUnit, strLinkFix, LinkInfo[intSel].ChkPrice);
                            if (res && res.RequestProc !== undefined) {
                                intIndex = res.RequestProc;
                            }
                            if (res && res.Trans !== undefined) {
                                Trans = res.Trans;
                            }
                        } else {
                            const res = await this.requestProc(Trans, intIndex, intTotalIdx, LinkInfo[intSel].code, "R", strReqEmp, intEmpNo, lngClientNo, lngPetNo, lngSupSeq, sglLinkCost, sglLinkUnit, strLinkFix, LinkInfo[intSel].ChkPrice);

                            if (res && res.RequestProc !== undefined) {
                                intIndex = res.RequestProc;
                            }
                            if (res && res.Trans !== undefined) {
                                Trans = res.Trans;
                            }
                        }

                        if (intIndex >= 0) {

                            for (i = 0; i <= intTotalIdx - 1; i++) {
                                if (Trans[i].Seq === Trans[intIndex].SupSeq) {
                                    if (Trans[intIndex].LinkType === INVENT) {
                                        if (strLChk != "F") {
                                            if (sglLinkUnit != 0) {
                                                sglTemp = (sglLinkCost + sglProcPrice) / sglLinkUnit;
                                            } else {
                                                sglTemp = 0;
                                            }

                                            await this.updateTranInfo(new UpdateTranInfoModel(Trans[intIndex], sglTemp, Trans[intIndex].LinkFix, sglLinkUnit, LinkInfo[intSel].ChkPrice, 0)).then(() => { });
                                        } else {
                                            await this.updateTranInfo(new UpdateTranInfoModel(Trans[intIndex], (sglLinkCost + sglProcPrice), Trans[intIndex].LinkFix, sglLinkUnit, LinkInfo[intSel].ChkPrice, 0)).then(() => { });
                                        }
                                    } else if (strLChk != "Y") {
                                        await this.updateTranInfo(new UpdateTranInfoModel(Trans[intIndex], sglPrice, strLinkFix, sglLinkUnit, strLChk, 0)).then(() => { });
                                    } else {
                                        await this.updateTranInfo(new UpdateTranInfoModel(Trans[intIndex], sglLinkCost, strLinkFix, sglLinkUnit, LinkInfo[intSel].ChkPrice, 0)).then(() => { });
                                    }

                                    await this.updatePStatus(new UpdatePStatusModel(Trans[intIndex], LinkInfo[intSel].SubHist === 1))
                                        .then(() => { });
                                    continue;
                                }
                            }

                            await this.updatePStatus(new UpdatePStatusModel(Trans[intIndex], LinkInfo[intSel].SubHist === 1))
                                .then(() => { });

                            let Category: any = LinkInfo[intSel].Category;
                            if (!isNaN(Category)) {
                                Trans[intTotalIdx - 1].IsRerequest = "R"
                            }

                            if (LinkInfo[intSel].Active === "O") {
                                Trans[intTotalIdx - 1].IsOptional = true;
                            } else if (!isNaN(Category)) {
                                Trans[intTotalIdx - 1].IsOptional = true
                            }

                            if (!isNaN(Number(Category)) || LinkInfo[intSel].Active === "O") {
                                await this.tranDynOpt(new TranDynOptModel(Trans[intTotalIdx - 1])).then(() => { });
                            }

                            await this.updateTranPrintable(new UpdateTranModel(Trans[intSel], intSel, '', false, 0, '', LinkInfo[intSel].Printable ? 1 : 0, Number(sglLinkUnit), LinkInfo[intSel].SaleTreat, 0)).then(() => { });

                            Trans[intIndex].Unit = sglLinkUnit;
                            Trans[intIndex].Printed = Boolean(LinkInfo[intSel].Printable);
                            Trans[intIndex].IType = LinkInfo[intSel].SaleTreat

                            if (strStatus === "F") {
                                if (i <= intTotalIdx) {
                                    if (LinkInfo[intSel].ChkPrice === "N") {
                                        sglProcPrice = sglProcPrice + sglLinkCost
                                    }

                                    let u1 = new UpdateTranModel(undefined, 0, '', false, 0, '', 0, 0, '', 0);
                                    u1.sglProcPrice = sglProcPrice;
                                    u1.Trans = Trans[intIndex];
                                    await this.updateTranBaseCost(u1).then(() => { });

                                    Trans[intIndex].Cost = Trans[intIndex].Cost - sglProcPrice
                                    RequestProc = intIndex;
                                    // GoTo ChkOtherStatus
                                    await ChkOtherStatus();
                                }
                            } else if (i < intTotalIdx) {
                                RequestProc = intIndex;
                                // GoTo ChkOtherStatus
                                await ChkOtherStatus();
                            }

                            if (LinkInfo[intSel].ChkPrice === "Y") {
                                let u1 = new UpdateTranModel(undefined, 0, '', false, 0, '', 0, 0, '', 0);
                                u1.BaseCharge = LinkInfo[intSel].BaseCharge ?? '';
                                u1.Trans = Trans[intIndex];
                                await this.updateTranBaseChargeCost(u1).then(() => { });
                            } else if (LinkInfo[intSel].ChkPrice === "F") {
                                if (Trans[intIndex].Unit != 0) {
                                    let u1 = new UpdateTranModel(undefined, 0, '', false, 0, '', 0, 0, '', 0);
                                    u1.BaseCharge = LinkInfo[intSel].BaseCharge ?? '';
                                    u1.sglProcPrice = sglLinkCost;
                                    u1.Trans = Trans[intIndex];
                                    await this.updateTranBaseChargeCostChk(u1).then(() => { });
                                } else {
                                    let u1 = new UpdateTranModel(undefined, 0, '', false, 0, '', 0, 0, '', 0);
                                    u1.BaseCharge = LinkInfo[intSel].BaseCharge ?? '';
                                    u1.sglProcPrice = sglLinkCost;
                                    u1.Trans = Trans[intIndex];
                                    await this.updateTranBaseChargeCostChkUnitDiv(u1).then(() => { });
                                }

                                Trans[intIndex].Cost = Trans[intIndex].Cost + sglLinkCost;
                                Trans[intIndex].BaseChg = LinkInfo[intSel].BaseCharge ?? '';
                                Trans[intIndex].CheckCost = "F";
                                if (Trans[intIndex].Unit !== 0) {
                                    Trans[intIndex].UnitCost = sglLinkCost / Trans[intIndex].Unit;
                                }
                            } else {

                                let u1 = new UpdateTranModel(undefined, 0, '', false, 0, '', 0, 0, '', 0);
                                u1.BaseCharge = LinkInfo[intSel].BaseCharge ?? '';
                                u1.sglProcPrice = sglProcPrice;
                                u1.SalePrice = LinkInfo[intSel].SalePrice;
                                u1.Trans = Trans[intIndex];

                                await this.updateTranBaseChargeCostUnit(u1).then(() => { });
                            }

                            if (strStatus === "T") {
                                let u1 = new UpdateTranModel(undefined, 0, '', false, 0, '', 0, 0, '', 0);
                                u1.BaseCharge = LinkInfo[intIndex].BaseCharge ?? '';
                                u1.sglProcPrice = Trans[intIndex].Cost;
                                u1.Chk = Trans[intIndex].CheckCost;
                                u1.UnitCost = Trans[intIndex].UnitCost;
                                u1.Trans = Trans[intIndex];
                                await this.updateTranBaseChargeCostChkUnit(u1).then(() => { });
                            } else if (strStatus !== "R") {
                                // GoTo ChkOtherStatus
                                await ChkOtherStatus();
                            }

                            if (LinkInfo[intSel].LinkType === INVENT) {

                                if (LinkInfo[intSel].ChkPrice !== "F") {
                                    if (sglLinkUnit !== 0) {
                                        sglTemp = sglLinkCost;
                                    } else {
                                        sglTemp = 0;
                                    }

                                    await this.updateTranInfo(new UpdateTranInfoModel(Trans[intIndex], sglTemp, Trans[intIndex].LinkFix, Number(sglLinkUnit), LinkInfo[intSel].ChkPrice, sglProcPrice)).then(() => { });
                                } else {
                                    await this.updateTranInfo(new UpdateTranInfoModel(Trans[intIndex], Trans[intIndex].UnitCost, Trans[intIndex].LinkFix, Number(sglLinkUnit), LinkInfo[intSel].ChkPrice, (sglLinkCost + sglProcPrice))).then(() => { });
                                }
                            } else if (Trans[intSel].SupSeq !== 0) {
                                await this.updateTranInfo(new UpdateTranInfoModel(Trans[intIndex], Trans[intIndex].Cost, Trans[intIndex].LinkFix, Number(Trans[intIndex].Unit), LinkInfo[intSel].ChkPrice, 0)).then(() => { });
                            }
                        }
                        strParent = "";
                    } else {
                        await this.updateStatus(new UpdateStatusModel(Trans[intIndex], strStatus))
                            .then(() => { });
                    }
                } else {
                    const DoAgain = async (ejecutar: boolean, exec: boolean) => {

                        if (intIndex < 0 || ejecutar) {
                            if (exec) {
                                if (lngSupSeq === 0 && exec) {
                                     var build = new BuildTransactModel(
                                lngClientNo,
                                this.Clinic_no,
                                lngPetNo,
                                intCodeNo,
                                intCodeType,
                                strCodeName,
                                "",
                                0,
                                "",
                                strFix,
                                sglLinkUnit,
                                sglLinkCost,
                                "",
                                sglDosage,
                                "",
                                "",
                                "",
                                0,
                                null,
                                intEmpNo, 
                                strReqEmp, 
                                strStatus,
                                sglPrice,
                                lngSupSeq,
                                Trans,
                                intTotalIdx,
                                intIndex

                        );    
                                    if (strStatus === "F" || strStatus === "T" || strStatus === "S" || (strStatus === "D" && lngSupSeq !== 0)) {
                                        await this.buildTransact(build)
                                            .then(async (res: any) => {
                                                Trans = res.Trans;
                                                intIndex = res.intIndex;
                                                await this.buildTreatGen_array(Trans, intIndex, intTotalIdx);
                                            });
                                    } else {
                                        build.Status = "R";
                                        await this.buildTransact(build)
                                            .then(async (res: any) => {
                                                Trans = res.Trans;
                                                intIndex = res.intIndex;
                                                await this.buildTreatGen_array(Trans, intIndex, intTotalIdx);
                                            });
                                    }
                                    lngSeq = Trans[intIndex].Seq
                                } else {
                                    lngSeq = lngSupSeq;
                                }

                                i = 0;
                                k = 0;

                                DoseArr = [];
                            }

                            // DoAgain:

                            strLinkCat = LinkInfo[k].Category;
                            j = 0;
                            strOptions = [];

                            for (i = k; i <= intLinkCount - 1; i++) {
                                if (strLinkCat === LinkInfo[i].Category) {
                                    strOptions.push(`${LinkInfo[i].LinkName}`);
                                    if (LinkInfo[i].LinkType === INVENT) {
                                        if (LinkInfo[i].RecFix === "R") {
                                            var sglRecDose = 0;
                                            DoseArr.push(new DosageModel(sglRecDose, 0, 0, 0, ''));
                                            await this.CalcDosage(new CalcDosageModel(LinkInfo[i].LinkNo, LinkInfo[i].Dosage, lngPetNo, LinkInfo[i].Variant, DoseArr[i].sglMinDose, DoseArr[i].sglMaxDose, this.Clinic_no, DoseArr[i].sglRecDose, DoseArr[i].sglQty, DoseArr[i].QtyUnit))
                                                .then((res: CalcDosageModel) => {
                                                    DoseArr[i].sglRecDose = res.CalcDose;
                                                    DoseArr[i].sglMinDose = res.sglMinDose;
                                                    DoseArr[i].sglMaxDose = res.sglMaxDose;
                                                    DoseArr[i].QtyUnit = res.QtyUnit;
                                                });
                                            // strOptions[i] = `${strOptions[i]}"`
                                        } else if (LinkInfo[i].RecFix === "F") {
                                            // DoseArr[i].sglRecDose = LinkInfo[i].Dosage
                                            DoseArr.push(new DosageModel(LinkInfo[i].Dosage, 0, 0, 0, ''));
                                        } else {
                                            // DoseArr[i].sglRecDose = 1;
                                            DoseArr.push(new DosageModel(1, 0, 0, 0, ''));
                                        }
                                    } else {
                                        // DoseArr[i].sglRecDose = 1
                                        DoseArr.push(new DosageModel(1, 0, 0, 0, ''));
                                    }
                                    j = j + 1;
                                } else {
                                    break;
                                }
                            }

                            if (j === 1) {
                                intSel = 0 + k;
                            } else {

                                // intSel = OptionSelection("Select Item for " & strCodeName, j) + k
                                //declined = false;
                                
                                var some = this.findOption(strOptions, LinkInfo);
                                if (some.Index != -1) {
                                    intSel = some.Index + k;
                                    sglLinkUnit = some.Option.Qty;   
                                                                    } else {
                                    let options = {};
                                    strOptions.forEach((element, index) => {
                                        options[`${index}`] = element;
                                    });
                                    const { value: selection } = await Swal.fire({
                                        title: "Select Item for " + strCodeName,
                                        input: 'select',
                                        inputOptions: options,
                                        // inputPlaceholder: 'Select a fruit',
                                        showCancelButton: false,
                                        inputValidator: (value) => {
                                            return new Promise((resolve) => {
                                                resolve(undefined)
                                            })
                                        }
                                    })

                                    if (selection) {
                                        // Swal.fire(`You selected: ${selection}`)
                                        // if (strOptions.some(t => t === selection)) {
                                        intSel = Number(selection) + k;
                                        // }
                                    }
                                }
                            }

                            if (intSel < k) {
                                return;
                            } else if (LinkInfo[intSel].LinkNo === NOMED && LinkInfo[intSel].LinkType === 0) {
                                if (k < intLinkCount - 1) {
                                    if (i < intLinkCount) {
                                        k = i
                                        // GoTo DoAgain
                                        await DoAgain(true, false);
                                    } else {
                                        RequestProc = intIndex
                                        // GoTo ChkOtherStatus
                                        await ChkOtherStatus();
                                    }
                                }
                            }

                            if (LinkInfo[intSel].RecFix === "R") {
                                // sglLinkUnit = Val(MyInputBox("Enter quantity to use of " & vbCrLf & LinkInfo[intSel].Desc _
                                //                                & vbCrLf & "Recommended range: " & DoseArr[intSel].sglMinDose & " - " _
                                //                                & DoseArr[intSel].sglMaxDose, "Qty. To Use", str$(DoseArr[intSel].sglRecDose), 6))

                                var some = this.findOption(strOptions, LinkInfo);
                                //declined = false;
                                
                                if (some.Option >= 0) {
                                    sglLinkUnit = some.Option.Qty;   
                                    sglDosage = some.Option.Dosage;
                                      
                                } else {
                                    //Swal.close();
                                    const { value: quantity } = await Swal.fire({
                                        title: `Enter quantity to use of ${LinkInfo[intSel].Desc}`,
                                        text: `Recommended range: ${DoseArr[intSel].sglMinDose} - ${DoseArr[intSel].sglMaxDose}`,
                                        input: 'text',
                                        inputLabel: 'Qty. To Use',
                                        inputValue: LinkInfo[intSel].Dosage ?? ''
                                        // inputPlaceholder: 'Enter your email address'
                                    })

                                    if (quantity) {
                                        // Swal.fire(`Entered email: ${quantity}`)
                                        sglLinkUnit = quantity;
                                    }
                                }
                            } else if (LinkInfo[intSel].RecFix === "F") {
                                sglLinkUnit = LinkInfo[intSel].Dosage;
                            } else {
                                // sglLinkUnit = Val(MyInputBox("Enter quantity to use of " & vbCrLf & LinkInfo[intSel].Desc, _
                                //                                         "Qty. To Use", str$(LinkInfo[intSel].Dosage), 6))
                                
                                var some = this.findOption(strOptions, LinkInfo);
                                //declined = false;
                                if (some.Option >= 0) {
                                    sglLinkUnit = some.Option.Qty;   
                                    sglDosage = some.Option.Dosage;
                                   
                                } else {
                                    //Swal.close();
                                    const { value: quantity } = await Swal.fire({
                                        title: `Enter quantity to use of ${LinkInfo[intSel].Desc}`,
                                        input: 'text',
                                        inputLabel: 'Qty. To Use',
                                        inputValue: LinkInfo[intSel].Dosage ?? ''
                                        // inputPlaceholder: 'Enter your email address'
                                    })

                                    if (quantity) {
                                        // Swal.fire(`Entered email: ${quantity}`)
                                        sglLinkUnit = quantity;
                                    }
                                }
                            }

                            if (LinkInfo[intSel].ChkPrice === "Y") {
                                sglLinkCost = LinkInfo[intSel].Price;
                            } else {
                                sglLinkCost = LinkInfo[intSel].SalePrice;
                            }

                            if (sglLinkUnit === 0) {
                                if (LinkInfo[intSel].Active === "O") {
                                    if (k < intLinkCount - 1) {
                                        if (i < intLinkCount) {
                                            k = i;
                                            // GoTo DoAgain
                                        } else {
                                            RequestProc = intIndex;
                                            // GoTo ChkOtherStatus
                                            await ChkOtherStatus();
                                        }
                                    } else {
                                        if (intIndex > 0) {
                                            RequestProc = intIndex
                                            // GoTo ChkOtherStatus
                                            await ChkOtherStatus();
                                        } else if (lngSupSeq === 0) {
                                            for (j = 0; j < intTotalIdx - 1; j++) {
                                                if (Trans[j].Seq === lngSeq) {
                                                    intIndex = j
                                                    RequestProc = intIndex
                                                    // GoTo ChkOtherStatus
                                                    await ChkOtherStatus();
                                                }
                                            }
                                        } else {
                                            return;
                                        }
                                    }
                                }
                            }

                            await this.requestProc(Trans, -1, intTotalIdx, LinkInfo[intSel].code, strStatus, strReqEmp, intEmpNo, lngClientNo, lngPetNo, lngSeq, sglLinkCost, sglLinkUnit, strLinkFix, LinkInfo[intSel].ChkPrice)
                                .then((res: any) => {
                                    if (res && res.RequestProc)
                                        intIndex = res.RequestProc;
                                    if (res && res.Trans)
                                        Trans = res.Trans;
                                });

                            if (intIndex < 0) {
                                if (LinkInfo[intSel].Active === "O") {
                                    if (k < intLinkCount - 1) {
                                        if (i < intLinkCount) {
                                            k = i
                                            // GoTo DoAgain
                                        } else {
                                            RequestProc = intIndex
                                            // GoTo ChkOtherStatus
                                            await ChkOtherStatus();
                                        }
                                    } else {
                                        for (j = 0; j < intTotalIdx - 1; j++) {
                                            if (Trans[j].Seq === lngSeq) {
                                                intIndex = j
                                                RequestProc = intIndex
                                                // GoTo ChkOtherStatus
                                                await ChkOtherStatus();
                                            }
                                        }
                                    }
                                } else {
                                    return;
                                }
                            } else if (Trans[intIndex].Status !== "R") {
                                if (k < intLinkCount - 1) {
                                    if (i < intLinkCount) {
                                        k = i
                                        // GoTo DoAgain
                                        await DoAgain(true, false);
                                    }
                                } else {
                                    if (strStatus === "T") {
                                        for (i = 0; i < intTotalIdx - 1; i++) {
                                            if (Trans[i].Seq === lngSeq) {
                                                intIndex = i;
                                                break;
                                            }
                                        }
                                    }
                                    RequestProc = intIndex
                                    // GoTo ChkOtherStatus
                                    await ChkOtherStatus();
                                }
                            }

                            await this.updatePStatus(new UpdatePStatusModel(Trans[intTotalIdx - 1], LinkInfo[intSel].SubHist === 1)).then(() => { });

                            let Category: any = LinkInfo[intSel].Category;
                            if (!isNaN(Category)) {
                                Trans[intTotalIdx - 1].IsRerequest = "R"
                            }

                            if (LinkInfo[intSel].Active === "O") {
                                Trans[intTotalIdx - 1].IsOptional = true;
                            } else if (!isNaN(Category)) {
                                Trans[intTotalIdx - 1].IsOptional = true
                            }

                            if (isNaN(Category) || (LinkInfo[intSel].Active === "O")) {
                                await this.tranDynOpt(new TranDynOptModel(Trans[intTotalIdx - 1])).then(() => { });
                            }

                            await this.updateTranPrintable(new UpdateTranModel(Trans[intTotalIdx - 1], intSel, '', false, 0, '', LinkInfo[intSel].Printable ? 1 : 0, sglLinkUnit, LinkInfo[intSel].SaleTreat, 0)).then(() => { });

                            Trans[intIndex].Unit = sglLinkUnit;
                            Trans[intTotalIdx - 1].Printed = Boolean(LinkInfo[intSel].Printable);
                            Trans[intTotalIdx - 1].IType = LinkInfo[intSel].SaleTreat;


                            if (LinkInfo[intSel].ChkPrice === "Y") {
                                let getProcCost = 0;
                                await this.getProcCost(new ProcCostModel(LinkInfo[intSel].LinkNo, LinkInfo[intSel].LinkType, strStatus, getProcCost, this.Clinic_no, lngPetNo))
                                    .then((proc_cost: ProcCostModel) => {
                                        sglLinkCost = proc_cost.getProcCost;
                                    })
                            } else {
                                sglLinkCost = LinkInfo[intSel].SalePrice;
                            }

                            let u1 = new UpdateTranModel(undefined, 0, '', false, 0, '', 0, 0, '', 0);
                            u1.BaseCharge = LinkInfo[intSel].BaseCharge ?? '';
                            u1.Trans = Trans[intTotalIdx - 1];
                            await this.updateTranBaseCharge(u1).then(() => { });

                            Trans[intTotalIdx - 1].BaseChg = LinkInfo[intSel].BaseCharge ?? '';

                            if (LinkInfo[intSel].LinkType === INVENT) {
                                if (LinkInfo[intSel].ChkPrice === "F") {
                                    if (sglLinkUnit != 0) {
                                        sglTemp = sglLinkCost / sglLinkUnit;
                                    } else {
                                        sglTemp = 0;
                                    }

                                    await this.updateTranInfo(new UpdateTranInfoModel(Trans[intIndex], sglTemp, Trans[intIndex].LinkFix, sglLinkUnit, LinkInfo[intSel].ChkPrice, 0)).then(() => { });
                                } else {
                                    await this.updateTranInfo(new UpdateTranInfoModel(Trans[intIndex], sglTemp, Trans[intIndex].LinkFix, sglLinkUnit, LinkInfo[intSel].ChkPrice, 0)).then(() => { });
                                }
                            } else if (Trans[intIndex].SupSeq != 0) {
                                if (LinkInfo[intSel].ChkPrice !== "Y") {
                                    await this.updateTranInfo(new UpdateTranInfoModel(Trans[intIndex], sglLinkCost, Trans[intIndex].LinkFix, sglLinkUnit, LinkInfo[intSel].ChkPrice, 0)).then(() => { });
                                }
                            }
                        } else {
                            await this.updateStatus(new UpdateStatusModel(Trans[intIndex], strStatus))
                                .then(() => { });
                        }

                        if (k < intLinkCount - 1) {
                            if (i < intLinkCount) {
                                k = i;
                                // GoTo DoAgain
                                await DoAgain(true, false);
                            }
                        }

                        if (strStatus === "T") {
                            for (i = 0; i < intTotalIdx - 1; i++) {
                                if (Trans[i].Seq === lngSeq) {
                                    intIndex = i;
                                    break;
                                }
                            }
                        }
                    }
                    await DoAgain(true, true);
                }

                RequestProc = intIndex;
                break;
            case 'R':
            case 'T':
            //debugger;
            case ' ':

                     var build = new BuildTransactModel(
                                lngClientNo,
                                this.Clinic_no,
                                lngPetNo,
                                intCodeNo,
                                intCodeType,
                                strCodeName,
                                "",
                                0,
                                "",
                                strFix,
                                sglLinkUnit,
                                sglLinkCost,
                                "",
                                sglDosage,
                                "",
                                "",
                                "",
                                0,
                                null,
                                intEmpNo, 
                                strReqEmp, 
                                strStatus,
                                sglPrice,
                                lngSupSeq,
                                Trans,
                                intTotalIdx,
                                intIndex

                        );    
                    
                if (intLinkCount <= 0) {
                    if (intIndex < 0) {
                        if (strStatus === "F") {
                            build.Price = 0;    
                            await this.buildTransact(build)
                                .then(async (res: any) => {
                                    Trans = res.Trans;
                                    intIndex = res.intIndex;
                                    await this.buildTreatGen_array(Trans, intIndex, intTotalIdx);
                                });
                        } else if (strStatus === "T" || strStatus === "S" || (strStatus === "D" && lngSupSeq > 0)) {
                            build.Status = strStatus;
                            await this.buildTransact(build)
                                .then(async (res: any) => {
                                    Trans = res.Trans;
                                    intIndex = res.intIndex;
                                    await this.buildTreatGen_array(Trans, intIndex, intTotalIdx);
                                });
                        } else {
                            build.Status = "R";
                            await this.buildTransact(build)
                                .then(async (res: any) => {
                                    Trans = res.Trans;
                                    intIndex = res.intIndex;
                                    await this.buildTreatGen_array(Trans, intIndex, intTotalIdx);
                                });
                        }

                        if ((strStatus === "F") && (Trans[intIndex].Unit > 0)) {
                            let u1 = new UpdateTranModel(undefined, 0, '', false, 0, '', 0, 0, '', 0);
                            u1.Trans = Trans[intIndex];
                            u1.intIndex = intIndex;
                            await this.updateTranUnit(u1).then(() => { });
                            Trans[intIndex].Unit = Trans[intIndex].Unit * -1;
                        } else if (lngSupSeq !== 0) {
                            let u1 = new UpdateTranModel(undefined, 0, '', false, 0, '', 0, 0, '', 0);
                            u1.Trans = Trans[intIndex];
                            u1.intIndex = intIndex;
                            u1.sglLUnit = sglLUnit;
                            await this.updateTranLUnit(u1).then(() => { });
                            Trans[intIndex].Unit = sglLUnit;
                        }
                    } else {
                        await this.updateStatus(new UpdateStatusModel(Trans[intIndex], strStatus)).then(() => { });
                    }
                    RequestProc = intIndex;
                } else {
                    
                    if (strStatus === "F" || strStatus === "T" || strStatus === "S" || (strStatus === "D" && lngSupSeq > 0)) {
                        build.Status = strStatus;
                        await this.buildTransact(build)
                            .then(async (res: any) => {
                                Trans = res.Trans;
                                intIndex = res.intIndex;
                                await this.buildTreatGen_array(Trans, intIndex, intTotalIdx);
                            });
                    } else {
                        build.Status = "R";
                        await this.buildTransact(build)
                            .then(async (res: any) => {
                                Trans = res.Trans;
                                intIndex = res.intIndex;
                                await this.buildTreatGen_array(Trans, intIndex, intTotalIdx);
                            });
                    }

                    i = 0;
                    k = 0;

                    // RepeatLoop:
                    var RepeatLoop = async () => {
                        strLinkCat = LinkInfo[k].Category;
                        j = 0;
                        strOptions = [];
                        for (i = k; i <= intLinkCount - 1; i++) {
                            if (strLinkCat === LinkInfo[i].Category) {
                                strOptions.push(`${LinkInfo[i].LinkName}`);
                                if (LinkInfo[i].LinkType === INVENT) {
                                    if (LinkInfo[i].RecFix === "R") {
                                        var sglRecDose = 0;
                                        DoseArr.push(new DosageModel(sglRecDose, 0, 0, 0, ''))
                                        await this.CalcDosage(new CalcDosageModel(LinkInfo[i].LinkNo, LinkInfo[i].Dosage, lngPetNo, LinkInfo[i].Variant, DoseArr[i].sglMinDose, DoseArr[i].sglMaxDose, this.Clinic_no, DoseArr[i].sglRecDose, DoseArr[i].sglQty, LinkInfo[i].DosageUnit))
                                            .then((res: CalcDosageModel) => {
                                                DoseArr[i].sglRecDose = res.CalcDose;
                                                DoseArr[i].sglMinDose = res.sglMinDose;
                                                DoseArr[i].sglMaxDose = res.sglMaxDose;
                                            });
                                        //strOptions[i] = `${strOptions[j]}"`
                                    } else if (LinkInfo[i].RecFix === "F") {
                                        // DoseArr[i].sglRecDose = LinkInfo[i].Dosage
                                        DoseArr.push(new DosageModel(LinkInfo[i].Dosage, 0, 0, 0, ''));
                                    } else if (LinkInfo[i].LinkType === INVENT) {
                                        // DoseArr[i].sglRecDose = 1;
                                        DoseArr.push(new DosageModel(1, 0, 0, 0, ''));
                                    }
                                    j = j + 1;
                                }
                            } else {
                                break;
                            }
                        }

                        if (j === 1) {
                            intSel = 0 + k
                        } else {

                            // intSel = OptionSelection("Select Item for " & strCodeName, j) + k
                            //declined = false;
                            
                            var some = this.findOption(strOptions, LinkInfo);
                            if (some.Index != -1) {
                                intSel = some.Index + k;
                                    sglLinkUnit = some.Option.Qty;   
                                    sglDosage = some.Option.Dosage;
                                   
                            } else {
                                let options = {};
                                strOptions.forEach((element, index) => {
                                    options[`${index}`] = element;
                                });
                                const { value: selection } = await Swal.fire({
                                    title: "Select Item for " + strCodeName,
                                    input: 'select',
                                    inputOptions: options,
                                    // inputPlaceholder: 'Select a fruit',
                                    showCancelButton: false,
                                    inputValidator: (value) => {
                                        return new Promise((resolve) => {
                                            resolve(undefined)
                                        })
                                    }
                                })

                                if (selection) {
                                    // Swal.fire(`You selected: ${selection}`)
                                    // if (strOptions.some(t => t === selection)) {
                                    intSel = Number(selection) + k;
                                    // }
                                }
                            }
                        }

                        if (LinkInfo[intSel].RecFix === "R") {
                            if (DoseArr[intSel].sglMaxDose === DoseArr[intSel].sglMinDose) {
                                // sglLinkUnit = Val(MyInputBox("Enter quantity to use of " & vbCrLf & LinkInfo[intSel].Desc, "Qty. To Use", _
                                // str$(DoseArr[intSel].sglRecDose), 6))

                                //declined = false;
                                
                                var some = this.findOption(strOptions, LinkInfo);
                                if (some.Index != -1) {
                                    sglLinkUnit = some.Option.Qty;   
                                    sglDosage = some.Option.Dosage;
                                   
                                } else {
                                    //Swal.close();
                                    const { value: quantity } = await Swal.fire({
                                        title: `Enter quantity to use of ${LinkInfo[intSel].Desc}`,
                                        input: 'text',
                                        inputLabel: 'Qty. To Use',
                                        inputValue: LinkInfo[intSel].Dosage ?? ''
                                        // inputPlaceholder: 'Enter your email address'
                                    })

                                    if (quantity) {
                                        // Swal.fire(`Entered email: ${quantity}`)
                                        sglLinkUnit = quantity;
                                    }
                                }
                            } else {
                                // sglLinkUnit = Val(MyInputBox("Enter quantity to use of " & vbCrLf & LinkInfo[intSel].Desc _
                                // & vbCrLf & "Recommended range: " & DoseArr[intSel].sglMinDose & " - " _
                                // & DoseArr[intSel].sglMaxDose, "Qty. To Use", str$(DoseArr[intSel].sglRecDose), 6))
                                //declined = false;
                                
                                var some = this.findOption(strOptions, LinkInfo);
                                if (some.Index != -1) {
                                    sglLinkUnit = some.Option.Qty;   
                                    sglDosage = some.Option.Dosage;
                                   
                                } else {
                                    //Swal.close();
                                    const { value: quantity } = await Swal.fire({
                                        title: `Enter quantity to use of ${LinkInfo[intSel].Desc}`,
                                        text: `Recommended range: ${DoseArr[intSel].sglMinDose} - ${DoseArr[intSel].sglMaxDose}`,
                                        input: 'text',
                                        inputLabel: 'Qty. To Use',
                                        inputValue: LinkInfo[intSel].Dosage ?? ''
                                        // inputPlaceholder: 'Enter your email address'
                                    })

                                    if (quantity) {
                                        // Swal.fire(`Entered email: ${quantity}`)
                                        sglLinkUnit = quantity;
                                    }
                                }
                            }
                        } else if (LinkInfo[intSel].RecFix === "F") {
                            sglLinkUnit = LinkInfo[intSel].Dosage
                        } else if (LinkInfo[intSel].LinkType === INVENT) {
                            // sglLinkUnit = Val(MyInputBox("Enter quantity to use of " & vbCrLf & LinkInfo[intSel].Desc, _

                            // "Qty. To Use", str$(LinkInfo[intSel].Dosage), 6))
                            //declined = false;
                            
                            var some = this.findOption(strOptions, LinkInfo);
                            if (some.Index != -1) {
                                    sglLinkUnit = some.Option.Qty;   
                                    sglDosage = some.Option.Dosage;
                                   
                                //    declined = (typeof some.Option.Declined === 'undefined') ? false : some.Option.Declined;
                            } else {
                                //Swal.close();
                                const { value: quantity } = await Swal.fire({
                                    title: `Enter quantity to use of ${LinkInfo[intSel].Desc}`,
                                    input: 'text',
                                    inputLabel: 'Qty. To Use',
                                    inputValue: LinkInfo[intSel].Dosage ?? ''
                                    // inputPlaceholder: 'Enter your email address'
                                })

                                if (quantity) {
                                    // Swal.fire(`Entered email: ${quantity}`)
                                    sglLinkUnit = quantity;
                                }
                            }
                        }

                        if (strStatus === "F") sglLinkUnit = Number(sglLinkUnit) * -1;

                        if (LinkInfo[intSel].LinkType === 0) {
                            // MsgBox "Procedure with type " & strFix & " can have only inventory items as linkage.", vbInformation
                            await this.deleteATran(new DeleteATranModel(Trans, intIndex, intTotalIdx, false, '', this.Clinic_no, 1, false)).then(() => { });
                            intIndex = -1;
                            return;
                        }

                        if (intIndex >= 0) {
                            if (LinkInfo[intSel].BaseCharge === "") {
                                await this.checkBaseCharge(new CheckBaseChargeModel(LinkInfo[intSel].LinkNo, LinkInfo[intSel].LinkType, LinkInfo[intSel].BaseCharge ?? '', this.Clinic_no))
                                    .then((CheckBaseCharge: number) => {
                                        Trans[intIndex].Cost = Trans[intIndex].Cost + CheckBaseCharge;
                                    });

                                if (strStatus !== "F") {
                                    let u1 = new UpdateTranModel(undefined, 0, '', false, 0, '', 0, 0, '', 0);
                                    u1.Trans = Trans[intIndex];
                                    u1.sglProcPrice = Trans[intIndex].Cost;
                                    await this.updateTranCost(u1).then(() => { });
                                } else {
                                    Trans[intIndex].Cost = 0;
                                }
                            } else if (strStatus === "F") {
                                Trans[intIndex].Cost = 0;
                            }

                            //if (declined !== true) {
                            SubTrans = [];
                            SubTrans.push(new SubTranRecordModel(0, 0, 0, false, false, '', 0, '', 0))

                            if (strLChk !== "N") {
                                if (LinkInfo[intSel].ChkPrice === "Y") {
                                    SubTrans[0].CheckCost = true;
                                    let getProcCost = 0;
                                    await this.getProcCost(new ProcCostModel(LinkInfo[intSel].LinkNo, LinkInfo[intSel].LinkType, strStatus, getProcCost, this.Clinic_no, lngPetNo))
                                        .then((proc_cost: ProcCostModel) => {
                                            SubTrans[0].UnitCost = proc_cost.getProcCost;
                                        })
                                } else {
                                    SubTrans[0].CheckCost = false;
                                    SubTrans[0].UnitCost = LinkInfo[intSel].SalePrice;
                                }
                                Trans[intIndex].UnitCost = Trans[intIndex].UnitCost + SubTrans[0].UnitCost;
                                sglLinkCost = Trans[intIndex].UnitCost;
                            } else {
                                SubTrans[0].CheckCost = false;
                                SubTrans[0].UnitCost = 0;
                            }

                            if (strStatus === "F") {
                                SubTrans[0].UnitCost = SubTrans[0].UnitCost * -1
                            } else {
                                Trans[intIndex].CheckCost = LinkInfo[intSel].ChkPrice;
                            }
                            SubTrans[0].FixUnit = LinkInfo[intSel].RecFix;
                            SubTrans[0].LinkNo = LinkInfo[intSel].LinkNo;
                            SubTrans[0].LinkType = LinkInfo[intSel].LinkType;
                            SubTrans[0].Seq = Trans[intIndex].Seq;
                            SubTrans[0].SubHist = Boolean(LinkInfo[intSel].SubHist);
                            //  SubTrans[0].Declined = (typeof LinkInfo[intSel].Declined === 'undefined') ? false : LinkInfo[intSel].Declined;

                            if (strStatus === "F") {
                                Trans[intIndex].Unit = -1;
                                SubTrans[0].Unit = sglLinkUnit
                            } else {
                                Trans[intIndex].Unit = 1;
                                SubTrans[0].Unit = sglLinkUnit
                            }

                            await this.saveSubTran(new SaveSubTranModel(SubTrans, 1), LinkInfo[intSel].code, LinkInfo[intSel].Desc).then(() => { });
                        }
                        //}

                        if (k < intLinkCount - 1) {
                            if (i < intLinkCount) {
                                k = i;
                                await RepeatLoop();
                            }
                        }
                    };
                    await RepeatLoop();

                    if (strLChk === "N") {
                        Trans[intIndex].UnitCost = sglPrice;
                        Trans[intIndex].CheckCost = "N";
                    }

                    RequestProc = intIndex;

                    if (lngSupSeq !== 0) {

                        await this.updateTranInfo(new UpdateTranInfoModel(Trans[intIndex], sglLinkCost, strLinkFix, sglLinkUnit, Trans[intIndex].CheckCost, Trans[intIndex].Cost)).then(() => { });
                    } else {
                        let u1 = new UpdateTranModel(undefined, 0, '', false, 0, '', 0, 0, '', 0);
                        u1.Trans = Trans[intIndex];
                        u1.sglLUnit = Trans[intIndex].UnitCost;
                        u1.BaseCharge = Trans[intIndex].CheckCost;
                        await this.updateTranUnitChk(u1).then(() => { });
                    }
                }
                break;
            case 'X':
                if (intLinkCount === 0) {
                    // MsgBox "Mixed code " & strCodeName & " has no definition!", vbInformation
                    return;
                } else if (intLinkCatCount === 1) {
                         var build = new BuildTransactModel(
                                lngClientNo,
                                this.Clinic_no,
                                lngPetNo,
                                intCodeNo,
                                intCodeType,
                                strCodeName,
                                "",
                                0,
                                 "",
                                strFix,
                                sglLinkUnit,
                                sglLinkCost,
                                "",
                                sglDosage,
                                "",
                                "",
                                "",
                                0,
                                null,
                                intEmpNo, 
                                strReqEmp, 
                                strStatus,
                                sglPrice,
                                lngSupSeq,
                                Trans,
                                intTotalIdx,
                                intIndex

                        );    
                    
                  //  if (intIndex < 0) {
                        build.Status = "R";
                        await this.buildTransact(build)
                            .then(async (res: any) => {
                                Trans = res.Trans;
                                intIndex = res.intIndex;
                                await this.buildTreatGen_array(Trans, intIndex, intTotalIdx);
                            });
                   /* } else {
                        build.Status = "R";
                        await this.buildTransact(build)
                            .then(async (res: any) => {
                                Trans = res.Trans;
                                intIndex = res.intIndex;
                                await this.buildTreatGen_array(Trans, intIndex, intTotalIdx);
                            });
                    }*/

                    if (lngSupSeq !== 0) 
                    {
                        sglLinkUnit = sglLUnit;
                    }

                    // Arreglo nuevo por componente del mix; no usar SubTrans[i] del bucle (antes estaba vacío o era otro flujo → NaN en UnitCost y 400 en API).
                    SubTrans = [];
                    for (i = 0; i <= intLinkCount - 1; i++) {
                        let subTran = new SubTranRecordModel(0, 0, 0, false, false, '', 0, '', 0);

                        subTran.BaseCharge = LinkInfo[i].BaseCharge ?? '';
                        if (LinkInfo[i].ChkPrice === "Y") {
                            subTran.CheckCost = true;
                            let getProcCost = 0;
                            await this.getProcCost(new ProcCostModel(LinkInfo[i].LinkNo, LinkInfo[i].LinkType, LinkInfo[i].Status, getProcCost, this.Clinic_no, lngPetNo))
                                .then((proc_cost: ProcCostModel) => {
                                    subTran.UnitCost = proc_cost.getProcCost;
                                })
                        } else {
                            subTran.CheckCost = false;
                            subTran.UnitCost = LinkInfo[i].SalePrice;
                        }

                        if (LinkInfo[i].ChkPrice !== "F") {
                            subTran.UnitCost = Number(subTran.UnitCost) * Number(LinkInfo[i].Dosage);
                        }

                        Trans[intIndex].UnitCost = Trans[intIndex].UnitCost + subTran.UnitCost;
                        subTran.FixUnit = LinkInfo[i].RecFix;
                        subTran.LinkNo = LinkInfo[i].LinkNo;
                        subTran.LinkType = LinkInfo[i].LinkType;
                        subTran.Seq = Trans[intIndex].Seq;
                        subTran.SubHist = Boolean(LinkInfo[i].SubHist);
                        subTran.Unit = LinkInfo[i].Dosage;
                        //subTran.Declined = (typeof LinkInfo[i].Declined === 'undefined') ? false : LinkInfo[i].Declined;
                        SubTrans.push(subTran);
                    }

                    const lastLink = intLinkCount > 0 ? LinkInfo[intLinkCount - 1] : LinkInfo[0];
                    await this.saveSubTran(new SaveSubTranModel(SubTrans, SubTrans.length), lastLink.code, lastLink.Desc).then(() => { });

                    if (lngSupSeq === 0) {
                        await this.updateTranInfo(new UpdateTranInfoModel(Trans[intIndex], Trans[intIndex].UnitCost, strFix, sglLinkUnit, "", 0)).then(() => { });
                    } else {
                        await this.updateTranInfo(new UpdateTranInfoModel(Trans[intIndex], Trans[intIndex].Cost, strFix, sglLinkUnit, "", 0)).then(() => { });
                    }
                    RequestProc = intIndex;
                } else {
                    // MsgBox "Too many link categories found for mixed drug.", vbInformation
                    Swal.fire({
                        text: 'Too many link categories found for mixed drug.',
                    })
                    return;
                }
                break;
            default:
                break;
        }

        return await ChkOtherStatus();
    }


    async changeStatus(Trans: TranRecordModel[], Index: number, intTotalIdx: number, Status: string, PrevStatus: string, strUser: string, intUserNo: number, ClientNo: number, PetNo: number, intClinicNo: number, ActiveForm: string = '') {

        let ChangeStatus = false;
        let lngSupSeq = 0;

        let char = Status;

        if (PrevStatus === char) return;
        if (PrevStatus === "R" && !["D", "P", "W", "S", "Q", "X", "T"].includes(char)) {
            Swal.fire(`Invalid status.`)
            return ChangeStatus;
        } else if (PrevStatus === "C" && !['R', 'D', 'T', 'S', 'Q', 'X'].includes(char)) {
            Swal.fire(`Invalid status.`)
            return ChangeStatus;
        } else if (PrevStatus === "S" && !["R", "D", "T", "X"].includes(char)) {
            Swal.fire(`Invalid status.`)
            return ChangeStatus;
        } else if ((PrevStatus === "W" || PrevStatus === "P") && !["E", "D", "X"].includes(char)) {
            Swal.fire(`Invalid status.`)
            return ChangeStatus;
        } else if (PrevStatus === "D" && char !== "E" && char !== "X") {
            Swal.fire(`Invalid status.`)
            return ChangeStatus;
        } else if (["F", "Q", "T"].includes(PrevStatus) && char !== "X") {
            Swal.fire(`Invalid status.`)
            return ChangeStatus;
        } else if (char === "X") {
            const result = await Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel!'
            });

            if (result.isConfirmed == false)
                return ChangeStatus;
        }

        Swal.fire({
            title: 'Saving...',
            timerProgressBar: true,
            didOpen: () => { Swal.showLoading(); },
            allowOutsideClick: false,
        });
        try {
            switch (char) {
                case "X":
                    await this.deleteATran(new DeleteATranModel(Trans, Index, intTotalIdx, true, '', this.petService.userData.clinic_no, 0, false))
                    break;
                case "R":
                    await this.requestProc(Trans, Index, intTotalIdx, Trans[Index].LinkName, 'R', strUser, intUserNo, ClientNo, PetNo, 0)
                    if (Trans[Index].Attending <= 0) {
                        await this.updateDocs(Trans[Index]);
                    }
                    break;
                case "Q":
                    await this.requestProc(Trans, Index, intTotalIdx, Trans[Index].LinkName, 'Q', strUser, intUserNo, ClientNo, PetNo, 0)
                    for (let i = 0; i <= intTotalIdx - 1; i++) {
                        if (Trans[i].Seq === Trans[Index].SupSeq) {
                            await this.doneProc(Trans, i, intTotalIdx, strUser, intUserNo, true, ActiveForm, intClinicNo);
                            //debugger;
                            continue;
                        } else if (Trans[i].Seq === Trans[Index].Seq) {
                            await this.doneProc(Trans, i, intTotalIdx, strUser, intUserNo, true, ActiveForm, intClinicNo);
                            //debugger;
                        }
                    }
                    break;
                case "D":
                    if (PrevStatus === "C" || PrevStatus === "S") {
                        await this.requestProc(Trans, Index, intTotalIdx, Trans[Index].LinkName, "R", strUser, intUserNo, ClientNo, PetNo, 0)
                        if (Trans[Index].Attending <= 0) {
                            await this.updateDocs(Trans[Index]);
                        }
                    }
                    await this.doneProc(Trans, Index, intTotalIdx, strUser, intUserNo, false, ActiveForm, intClinicNo);
                    //debugger;
                    break;
                case "E":
                    lngSupSeq = Trans[Index].SupSeq
                    await this.requestProc(Trans, Index, intTotalIdx, Trans[Index].LinkName, "E", strUser, intUserNo, ClientNo, PetNo, lngSupSeq)
                        .then(async (res) => {
                            if (res && res.RequestProc) {
                                let intIndex = res.RequestProc;
                                if (intIndex > 0) {
                                    if (Trans[Index].Attending <= 0) {
                                        await this.updateDocs(Trans[Index]).then(() => { });
                                    }

                                    await this.doneProc(Trans, Index, intTotalIdx, strUser, intUserNo, false, ActiveForm, intClinicNo).then(() => { });
                                    //debugger;

                                    for (let i = 0; i < intTotalIdx - 1; i++) {
                                        if (Trans[i].Seq === Trans[Index].SupSeq) {
                                            Trans[i].Cost = Trans[i].Cost + Trans[Index].Cost;

                                            let u1 = new UpdateTranModel(undefined, 0, '', false, 0, '', 0, 0, '', 0);
                                            u1.Trans = Trans[Index];
                                            u1.sglProcPrice = Trans[Index].Cost;
                                            await this.updateTranCost(u1).then(() => { });
                                        }
                                    }
                                }
                            }
                        });
                    // ....
                    break;
                case "P":
                    if (PrevStatus === "C" || PrevStatus === "S") {
                        await this.requestProc(Trans, Index, intTotalIdx, Trans[Index].LinkName, "R", strUser, intUserNo, ClientNo, PetNo, 0)
                        if (Trans[Index].Attending <= 0) {
                            await this.updateDocs(Trans[Index]);
                        }
                    }
                    Trans[Index].Status = "L";
                    // ....
                    var doneProc = await this.doneProc(Trans, Index, intTotalIdx, strUser, intUserNo, false, ActiveForm, intClinicNo);
                    //debugger;

                    if (doneProc) {
                        Trans[Index].Status = "R"
                    }
                    break;
                case "T":
                    await this.requestProc(Trans, Index, intTotalIdx, Trans[Index].LinkName, "T", strUser, intUserNo, ClientNo, PetNo, 0)
                    if (Trans[Index].Attending <= 0) {
                        await this.updateDocs(Trans[Index]);
                    }
                    break;
                case "W":
                    await this.setDateToServer(Trans, Index);
                    break;
                case "S":
                    await this.suggestButDeclined(Trans[Index].Seq);
                    break;
                default:
                    Swal.fire(`Invalid status.`)
                    return ChangeStatus;
                    break;
            }
            ChangeStatus = true;

            return ChangeStatus;
        } finally {
            Swal.close();
        }
    }

    suggestButDeclined(Seq: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/suggestButDeclined`, { Seq: Seq })
                .subscribe((res: any) => {
                    if (res) {
                        // proc_cost = new ProcCostModel(res.intCodeNo, res.intCodeType, res.strStatus, res.getProcCost, res.intClinicNo);
                        // resolve(proc_cost);
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setDateToServer(Trans: TranRecordModel[], Index: number) {
        let promise = new Promise(async (resolve, reject) => {
            try {
                for (let index = 0; index < Trans.length; index++) {
                    const element = Trans[index];

                    if (element.SupSeq == Trans[Index].Seq) {
                        await this.api.post(`${this.baseUrl}/SetDateToServer`, { Seq: element.Seq }).toPromise();
                        element.Status = 'W';
                        element.WTime = new Date().toISOString().slice(0, 19);
                    }
                }


                await this.api.post(`${this.baseUrl}/SetDateToServer`, { Seq: Trans[Index].Seq }).toPromise();
                Trans[Index].Status = 'W';
                Trans[Index].WTime = new Date().toLocaleString();

                if (Trans[Index].SupSeq !== 0) {

                    let i = 0;
                    let j = -1;

                    for (let i = 0; i < Trans.length; i++) {
                        const element = Trans[i];

                        if (Trans[Index].SupSeq === element.Seq) {
                            j = i;
                            break
                        }
                    }

                    if (j > -1) {
                        await this.api.post(`${this.baseUrl}/SetDateToServer`, { Seq: Trans[j].Seq }).toPromise();
                        Trans[j].Status = 'W';
                        Trans[j].WTime = new Date().toLocaleString();
                    }

                }
                resolve(1);
            } catch (error) {
                reject(error);
            }
        });
        return promise;
    }

    async doneProc(Trans: TranRecordModel[], Index: number, intTotalIdx: number, strUser: string, intUserNo: number, blnIsEstimate: boolean = false, ActiveForm: string = '', intClinicNo: number) {

        let DoneProc = false;
        let Cost: number = 0, Unit: number = 0, i: number = 0, j: number = 0, intAppr: number = 0, intSel: number, sglWaste: number, intLinkNo: number;
        let sglUnit: number, sglAvail: number, sglBaseChg: number = 0, TimeUnit: number, strFile: string;
        let strTemp: string, strAppr: string, strResp1: string, strResp2: string | number;

        DoneProc = true;
        if ((Trans[Index].Status === "D") || (Trans[Index].Status === "Q") || (Trans[Index].Status === "S")) {
            return DoneProc;
        }
        DoneProc = false;

        //debugger;

        Cost = 0;
        if (Trans[Index].Status !== "P") {
            if ((Trans[Index].LinkType === 0) && (Trans[Index].LinkFix === "T")) {
                if (Trans[Index].Status === "W") {
                    // Unit = DateDiff("n", Trans[Index].WTime, Now)
                    if (Unit <= 0) Unit = 1;
                } else {
                    Unit = 1;
                }
                Trans[Index].Unit = Unit;
            }
            if (Trans[Index].LinkName === "PRESC") {
                await this.writtenPresc(Trans[Index]);
                Trans[Index].Status = "D";
                if (Trans[Index].DoneBy <= 0) {
                    Trans[Index].DoneBy = Trans[Index].ApproveBy
                    Trans[Index].DoneName = Trans[Index].ApproveName
                    // Trans[Index].DoneDate = Now
                    await this.updateTranDone(Trans[Index])
                        .then(() => {
                            DoneProc = true;
                            return DoneProc;
                        });
                }
            } else if (Trans[Index].LinkType === INVENT) {
                if (blnIsEstimate === false) {
                    // await this.checkForRefills(Trans[Index].PetNo, Trans[Index].LinkNo)
                    //     .then(() => {
                    //         DoneProc = true;
                    //         return DoneProc;
                    //     });
                    //debugger;
                    strTemp = await this.checkItemLbl(Trans[Index].LinkNo, Trans[Index].LinkType, Trans[Index].LinkName, Trans[Index].Status, intClinicNo);

                    if (strTemp !== '') {
                        await this.pharmProc(Trans[Index].LinkNo, Trans[Index].LinkType, Trans[Index].IType, Trans[Index].PetNo, Trans[Index].Attending, Trans[Index].Seq, Trans[Index].Status, strUser, intUserNo, strTemp, Index,Trans[Index].LinkName)
                        if (Trans[Index].LinkFix === "W") {
                            i = Math.round(Trans[Index].Unit);
                            if (Trans[Index].Unit > i) {
                                Trans[Index].Unit = i + 1;
                            } else {
                                Trans[Index].Unit = i;
                            }
                        }
                    }
                }

                const [unitUnit, unittran] = await this.ask_Unit(Trans[Index], Cost, blnIsEstimate, intClinicNo);
                Unit = unitUnit
                Trans[Index] = unittran
            } else if (Trans[Index].LinkFix !== "T") {
                if (Trans[Index].LinkFix === "X") {
                    if (Trans[Index].LinkName === "VITTOR" || Trans[Index].LinkName === "BUPR-O") {
                        await Swal.fire({
                            text: "Do you want to print a label for this product?",
                            showCancelButton: true,
                            confirmButtonText: 'Yes',
                            didOpen: () => { Swal.hideLoading(); }
                        }).then(async (result) => {
                            if (result.isConfirmed) {
                                await this.pharmProc(Trans[Index].LinkNo, Trans[Index].LinkType, Trans[Index].IType, Trans[Index].PetNo, Trans[Index].Attending, Trans[Index].Seq, Trans[Index].Status, strUser, intUserNo, strTemp, Index,Trans[Index].LinkName)
                            }
                        })
                        const [unitUnit, unittran] = await this.ask_Unit(Trans[Index], Cost, blnIsEstimate, intClinicNo);
                        Unit = unitUnit
                        Trans[Index] = unittran
                    }
                } else if (Trans[Index].LinkFix === "R" || Trans[Index].LinkFix === "F") {
                    await this.getSubTrans(Trans[Index].Seq)
                        .then((res: SubTranRecordModel[]) => {
                            SubTrans = res;
                        });
                    // .....
                    for (let index = 0; index < SubTrans.length; index++) {
                        const element = SubTrans[index];

                        intSel = intSel + 1;
                        sglWaste = 0;

                        sglAvail = element.Unit;
                        TimeUnit = element.UnitCost;

                        i = element.LinkNo
                        j = element.LinkType

                        // strAppr = await this.findFix(i, j)
                        let some: CodesFileModel = this.catalogService.codes_file.find(t => t.code_no == i && t.code_type == j && t.code_clinic == intClinicNo);
                        if (some) {
                            strAppr = some.code_fix
                        }

                        strFile = element.FixUnit;

                        var dsc: string = '';
                        await this.getLongName(i, j, this.Clinic_no)
                            .then((res: any) => {
                                dsc = res;
                            });

                        strTemp = await this.checkItemLbl(i, j, dsc, Trans[Index].Status, intClinicNo);

                        if (strTemp !== '') {
                            await this.pharmProc(i, j, "", Trans[Index].PetNo, Trans[Index].Attending, Trans[Index].Seq, Trans[Index].Status, strUser, intUserNo, strTemp, Index,dsc)
                            sglAvail = Trans[Index].Unit
                        }

                        if (strFile !== "F") {
                            if (blnIsEstimate === false) {
                                var dsc: string = '';
                                await this.getLongName(i, j, this.Clinic_no)
                                    .then((res: any) => {
                                        dsc = res;
                                    });

                                const { value: quantity } = await Swal.fire({
                                    title: `Enter units of ${dsc}, if any.`,
                                    input: 'text',
                                    inputValue: element.Unit ?? ''
                                })

                                if (quantity) {
                                    if (Number(quantity) <= 0) {
                                        await Swal.fire({
                                            text: "Cancel entering units?",
                                            showCancelButton: true,
                                            confirmButtonText: 'Yes'
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                sglWaste = 0;
                                            } else {
                                                sglWaste = Number(quantity);
                                            }
                                        })
                                    } else {
                                        sglWaste = Number(quantity);
                                    }
                                }
                            } else {
                                sglWaste = sglAvail;
                            }

                            if (sglWaste !== sglAvail) {
                                if (strFile === "A") {
                                    sglAvail = sglWaste;
                                    await this.updateSubTranUnit(sglAvail, Trans[Index].Seq, i);
                                } else if (sglWaste === 0) {
                                    sglAvail = sglWaste;
                                    await this.updateSubTranUnit(sglAvail, Trans[Index].Seq, i);
                                } else {
                                    await Swal.fire({
                                        text: `Quantity entered, ${sglWaste}, does not match recommended units of ${sglAvail}. Use anyway?`,
                                        showCancelButton: true,
                                        confirmButtonText: 'Yes'
                                    }).then(async (result) => {
                                        if (result.isConfirmed) {
                                            await this.updateSubTranUnit(sglAvail, Trans[Index].Seq, i);
                                        }
                                    })
                                }
                            } else if (sglAvail !== element.Unit) {
                                await this.updateSubTranUnit(sglAvail, Trans[Index].Seq, i);
                            }
                        }

                        if (blnIsEstimate === false) {
                            if (j === INVENT) {
                                if (sglAvail !== 0)
                                    await this.checkAvail(sglAvail, i, strAppr, intClinicNo);
                            }
                        }

                        if (Trans[Index].CheckCost === "F") {
                            Cost = TimeUnit + sglBaseChg;
                        } else if (Trans[Index].CheckCost === "N") {
                            Cost = (Trans[Index].UnitCost * sglAvail) + sglBaseChg;
                        } else {
                            Cost = Cost + (sglAvail * TimeUnit) + sglBaseChg + Trans[Index].Cost;
                        }
                    }

                    if ((intSel === 1) && (sglAvail !== 0)) {
                        Unit = sglAvail;
                    } else {
                        Unit = Trans[Index].Unit;
                    }

                    if (intSel <= 0)
                        Cost = Trans[Index].UnitCost * Unit;

                } else {
                    Unit = Trans[Index].Unit;
                    Cost = Trans[Index].UnitCost * Unit;
                }
            }
        } else {
            Unit = Trans[Index].Unit;
            Cost = Trans[Index].Cost;
            Trans[Index].Status = blnIsEstimate ? "Q" : "D";
            // await this.printALabel(strFile, 1);
        }

        if ((Trans[Index].Status !== "P") && (Trans[Index].Status !== "Z")) {
            let code = this.catalogService.codes_file.find(t => t.code_no === Trans[Index].LinkNo && t.code_type === Trans[Index].LinkType);
            Trans[Index].Approval = code.code_approval;

            if (ActiveForm === 'frmWorkScreen') {
                if (Trans[Index].Approval === "Y" || Trans[Index].Approval === "D") {
                    // .....
                }
            } else if (ActiveForm === 'frmMedTreat') {
                if (Trans[Index].Approval === "Y" || Trans[Index].Approval === "D") {
                    // .....
                }
            } else if (ActiveForm === 'frmInvoiceProcs') {
                for (let i = 0; i <= intTotalIdx - 1; i++) {
                    if (Trans[i].PetNo === Trans[Index].PetNo) {
                        // .....
                    }
                }
            } else {
                strAppr = strUser
                intAppr = intUserNo
                // Call GetDoctorInit(strAppr, intAppr)
                let options = {};
                let doctorsopt = JSON.parse(localStorage['employee_doctors']);
                doctorsopt.forEach((element, index) => {
                    options[`${index}`] = `${element.employee_no} -- ${element.employee_initial}`;
                });
                const { value: selection } = await Swal.fire({
                    title: `Select Doctor`, //route_abbrev + " -- " + route_note
                    input: 'select',
                    inputOptions: options,
                    showCancelButton: false,
                    inputValidator: (value) => {
                        return new Promise((resolve) => {
                            resolve(undefined)
                        })
                    }
                })

                if (selection) {
                    let intSel = Number(selection);
                    let doctor = doctorsopt[intSel];
                    strUser = doctor.employee_initial;
                    intAppr = doctor.employee_no;
                }
                // Call GetDoctorInit(strAppr, intAppr)
            }

            // Trans[Index].ApproveDate = Now
            Trans[Index].ApproveBy = intAppr
            Trans[Index].ApproveName = strAppr

            if (Trans[Index].Approval !== "" && Trans[Index].Approval !== "N") {
                if (Trans[Index].Approval === "Y") {
                    strAppr = strUser
                    intAppr = intUserNo
                }
                // Trans[Index].DoneDate = Now
                Trans[Index].DoneBy = intAppr
                Trans[Index].DoneName = strAppr
            } else {
                // Trans[Index].DoneDate = Now
                Trans[Index].DoneBy = intUserNo
                Trans[Index].DoneName = strUser
            }
        }

        if (Trans[Index].LinkType === INVENT) {
            // 'Update route and location if route is 'Alt'.
            if (Trans[Index].Route === "Alt") {
                let options = {};
                console.log("hahaha:", localStorage.drug_admin_route);
                localStorage.drug_admin_route.forEach((element, index) => {
                    options[`${index}`] = `${element.route_abbrev} -- ${element.route_note}`;
                });
                const { value: selection } = await Swal.fire({
                    title: `Select Route of Administration for ${Trans[Index].LinkName}`, //route_abbrev + " -- " + route_note
                    input: 'select',
                    inputOptions: options,
                    showCancelButton: false,
                    inputValidator: (value) => {
                        return new Promise((resolve) => {
                            resolve(undefined)
                        })
                    }
                })

                if (selection) {
                    intSel = Number(selection);
                }

                Trans[Index].Route = localStorage.drug_admin_route[intSel].route_abbrev;
            }

            await this.updateRouteLocation(Trans[Index].Route, Trans[Index].Location, Trans[Index].Seq).then(() => { });

            // 'Check for logs.
            strTemp = "";
            if (blnIsEstimate === false) {
                // let strOptions: any[] =
                let element: any;
                await this.selectWaste(Trans[Index].LinkNo, intClinicNo)
                    .then((res: any) => {
                        element = res;
                    });

                // const element = strOptions[index];

                if (element.item_waste !== false) {
                    const { value: quantity } = await Swal.fire({
                        title: `Enter wasted units of ${Trans[Index].LinkDesc}, if any.`,
                        input: 'text',
                        inputValue: 0
                    })

                    if (quantity) {
                        sglWaste = quantity;
                    }

                    if (sglWaste < 0)
                        sglWaste = 0;
                    if (sglWaste !== 0)
                        await this.updateWaste(sglWaste, Trans[Index].LinkNo, intClinicNo).then(() => { });

                    strTemp = element.item_log;

                    if (strTemp !== '' && strTemp !== null && strTemp !== undefined) {
                        if (Unit !== 0) {
                            await this.insertLog(strTemp, sglWaste, Unit, element.qty_on_hand, Trans[Index].LinkNo, Trans[Index].LinkDesc, Trans[Index].PetNo, Trans[Index].ApproveDate, Trans[Index].ApproveBy, intClinicNo).then(() => { });
                        }
                    }
                }
            }

            // 'Check for quantity discount for bulk purchases.
            strTemp = "";
            let discount_amount = "";
            if (Trans[Index].LinkFix = "B") {
                await this.selectDiscount(Trans[Index].LinkNo, intClinicNo)
                    .then((res: any) => {
                        strTemp = res.discount_qty;
                        discount_amount = res.discount_amount;
                    });

                if (Trans[Index].Unit >= Number(strTemp)) {
                    strTemp = discount_amount;
                    Trans[Index].Cost = Trans[Index].Cost - Number(strTemp);
                    Cost = Trans[Index].Cost;

                    let u1 = new UpdateTranModel(undefined, 0, '', false, 0, '', 0, 0, '', 0);
                    u1.Trans = Trans[Index];
                    u1.sglProcPrice = Trans[Index].Cost;
                    await this.updateTranCost(u1).then(() => { });
                }
            }

        } else {
            // 'Check subtransactions for inventory info.
            var SubTrans: SubTranRecordModel[] = []
            await this.getSubTrans(Trans[Index].Seq)
                .then((res: any[]) => {
                    SubTrans = res;
                });

            for (let index = 0; index < SubTrans.length; index++) {
                const element = SubTrans[index];

                strTemp = "";
                intLinkNo = element.LinkNo;
                sglUnit = element.Unit;

                var SubTransInventory: any[] = [];
                await this.getInventory(intLinkNo, intClinicNo)
                    .then((res: any[]) => {
                        SubTransInventory = res;
                    });
                for (let index2 = 0; index2 < SubTransInventory.length; index2++) {
                    const element2 = SubTransInventory[index2];

                    sglWaste = 0;
                    strTemp = element2.item_desc;

                    if ((element2.item_waste === true) && (blnIsEstimate === false)) {
                        const { value: quantity } = await Swal.fire({
                            title: `Enter wasted units of ${strTemp}, if any.`,
                            input: 'text',
                            inputValue: 0
                        })

                        if (quantity) {
                            sglWaste = quantity;
                        }

                        if (sglWaste < 0)
                            sglWaste = 0;
                        if (sglWaste !== 0)
                            await this.updateWaste(sglWaste, intLinkNo, intClinicNo).then(() => { });

                        strTemp = element2.item_log;

                        if ((strTemp !== "") && (blnIsEstimate === false)) {
                            if (Unit !== 0) {
                                var dsc: string = '';
                                await this.getLongName(intLinkNo, 1, this.Clinic_no)
                                    .then((res: any) => {
                                        dsc = res;
                                    });
                                await this.insertLog(strTemp, sglWaste, Unit, element2.qty_on_hand - sglWaste, intLinkNo, dsc, Trans[Index].PetNo, Trans[Index].ApproveDate, Trans[Index].ApproveBy, intClinicNo).then(() => { });
                            }
                        }
                    }
                }
            }

            strResp1 = "";

            await this.getResponse(new GetResponseModel(Trans[Index], blnIsEstimate, this.Clinic_no))
                .then((res: any) => {
                    strResp1 = res === null || res === undefined ? '' : res;
                })
                .catch(() => {
                    strResp1 = '';
                });

            await this.getRespNotes(Trans[Index].Seq).then(async (res: any) => {
                if (res === 1 && this.resp_notes.length > 0) {
                    Swal.close(); //close the previous swal
                    this.respNotesSource.next(this.resp_notes);
                    this.respNotesSource.next([]);
                    await new Promise<void>(resolve => {
                        const $el = ($('#modalRespNotes') as any);
                        if (!$el.length) { resolve(); return; }
                        $el.one('hidden.bs.modal', () => {
                            setTimeout(() => resolve(), 300);
                        });
                    });
                }
            });

            if ((Trans[Index].LinkFix === "A") && (strResp1 !== "B")) {
                strResp2 = Trans[Index].Unit;
                if (blnIsEstimate === false) {
                    const { value: quantity } = await Swal.fire({
                        title: `Enter units of ${Trans[Index].LinkDesc} used.`,
                        input: 'text',
                        inputValue: 0.05
                    })

                    if (quantity) {
                        sglWaste = quantity;
                    }

                    Trans[Index].Unit = Number(strResp2)
                    Trans[Index].Cost = Trans[Index].UnitCost * Trans[Index].Unit;

                    await this.updateTranDone(Trans[Index]);

                    Unit = Trans[Index].Unit;
                    Cost = Trans[Index].Cost;
                }
            }
        }

        if (blnIsEstimate === false) {
            // 'Check for rabies.
            if (Trans[Index].LinkName === "RETAG") {
                await this.saveRabInfo(Trans[Index].PetNo, Trans[Index].ApproveBy, true, 1, intClinicNo);
            } else if (this.checkRabies(Trans[Index]) === true) {
                if (Trans[Index].LinkName === "RAB3") {
                    await this.saveRabInfo(Trans[Index].PetNo, Trans[Index].ApproveBy, false, 3, intClinicNo);
                } else if (Trans[Index].LinkName = "CERT") {
                    await this.saveRabInfo(Trans[Index].PetNo, Trans[Index].ApproveBy, true, -1, intClinicNo);
                } else {
                    await this.saveRabInfo(Trans[Index].PetNo, Trans[Index].ApproveBy, false, 1, intClinicNo)
                }
            }

            if (this.checkHealth(Trans[Index]) === true) {
                if (this.fillHealthInfo(Trans[Index].PetNo, Trans[Index].ApproveBy) === false) {
                    return DoneProc;
                }
            }

            // If (tmpTran.LinkNo = PetInfoItemNo(i) And tmpTran.LinkType = PetInfoItemType(i) And tmpTran.SupSeq = 0) Then
            // if (Trans[Index].SupSeq === 0) {
            //     let strTemp = '';
            //     const { value: quantity } = await Swal.fire({
            //         title: `Enter ID Chip Number for this patient.`,
            //         input: 'text',
            //     })

            //     if (quantity) {
            //         strTemp = quantity;
            //         await this.checkIDChip(Trans[Index], strTemp).then(() => { });
            //     }
            // }
        }

        // 'if parent is marked done, then mark the children done also.
        for (let i = 0; i < Trans.length; i++) {
            if (Trans[Index] && Trans[i]) {
                if (Trans[Index].Seq === Trans[i].SupSeq) {
                    if (await this.doneProc(Trans, i, intTotalIdx, strUser, intUserNo, blnIsEstimate, ActiveForm, intClinicNo) === false) {
                        return DoneProc;
                    } else {
                        Cost = Cost + Trans[i].Cost;
                    }
                }
            }
        }

        if ((Trans[Index].Status !== "P") && (Trans[Index].Status !== "Z") && (Unit > 0)) {


            if ((Trans[Index].BaseChg === "" || Trans[Index].BaseChg === undefined) && (Trans[Index].CheckCost !== "N" || Trans[Index].CheckCost === undefined)) {
                await this.checkBaseCharge(new CheckBaseChargeModel(Trans[Index].LinkNo, Trans[Index].LinkType, Trans[Index].IType, intClinicNo))
                    .then((CheckBaseCharge: number) => {
                        Cost = Cost + CheckBaseCharge;
                    });
            } else {
                await this.getBaseCharge(Trans[Index].BaseChg)
                    .then((CheckBaseCharge: number) => {
                        Cost = Cost + CheckBaseCharge;
                    });
            }
        }

        if ((Trans[Index].LinkType === 0 && strResp1 !== "B") || (Trans[Index].LinkType === 1)) {
            Trans[Index].Unit = Unit
            Trans[Index].Cost = Cost
        }
        if (Trans[Index].DoneBy <= 0) {
            Trans[Index].DoneBy = intUserNo
            Trans[Index].DoneName = strUser
            // Trans[Index].DoneDate = Now
        }

        if ((Trans[Index].Status !== "P") && (Trans[Index].Status !== "Z"))
            Trans[Index].Status = blnIsEstimate ? "Q" : "D";

        let _updateTranDone = false;
        await this.updateTranDone(Trans[Index])
            .then((res: string) => {
                Trans[Index].DoneDate = res;
                _updateTranDone = true;
            });

        if (_updateTranDone) {
            if ((Trans[Index].SupSeq === 0 && Trans[Index].PStatus !== false)) {
                await this.updatePStatus(new UpdatePStatusModel(Trans[Index], false)).then(() => { });
                Trans[Index].PStatus = false;
            }

            if (blnIsEstimate === false) {
                if (Trans[Index].SupSeq === 0) {
                    let RecallInfo: any[] = [];
                    let strOptions: any[] = [];

                    await this.getRecall(Trans[Index], intClinicNo)
                        .then((res: any) => {
                            RecallInfo = res;
                        });

                    if (RecallInfo.length > 0) {
                        for (i = 0; i <= RecallInfo.length - 1; i++) {
                            strOptions.push(`${RecallInfo[i].recall_code} -- ${RecallInfo[i].recall_days} -- ${RecallInfo[i].ask_user ? 'Y' : 'N'}`);
                        }

                        let options = {};
                        strOptions.forEach((element, index) => {
                            options[`${index}`] = element;
                        });
                        const { value: selection } = await Swal.fire({
                            title: "Select Automatic Recall To Add", //route_abbrev + " -- " + route_note
                            input: 'select',
                            inputOptions: options,
                            showCancelButton: false,
                            inputValidator: (value) => {
                                return new Promise((resolve) => {
                                    resolve(undefined)
                                })
                            }
                        })

                        if (selection) {
                            intSel = Number(selection);
                        }

                        let seleccion = RecallInfo[intSel];

                        let intDays = 0;
                        if (seleccion.ask_user) {
                            const { value: quantity } = await Swal.fire({
                                title: `Enter number of days for this recall.`,
                                input: 'tel',
                                inputValue: seleccion.recall_days ?? ''
                            })

                            if (quantity) {
                                intDays = quantity;
                                if (intDays > 0) {
                                    i = 1;
                                } else {
                                    i = 0;
                                }
                            }
                        } else {
                            await Swal.fire({
                                text: "Add " + seleccion.recall_days + "-day " + seleccion.recall_code + " recall?",
                                showCancelButton: true,
                                confirmButtonText: 'Yes'
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    i = 1;
                                } else {
                                    i = 0;
                                }
                            })
                        }

                        if (i === 1) {
                            await this.addRecall(Trans[Index], intDays, seleccion.recall_code, Trans[Index].DoneDate, intClinicNo)
                                .then((strAsk: any) => {
                                    Trans[Index].RecallDate = strAsk;
                                });
                        }
                    }
                }
                if (Trans[Index].LinkName === "PHONE") {
                    let _moveToHistoryProc = false;
                    await this.moveToHistoryProc(Trans[Index], 0, intUserNo, intClinicNo)
                        .then((res: boolean) => {
                            _moveToHistoryProc = res;
                        });

                    if (_moveToHistoryProc) {
                        await this.deleteATran(new DeleteATranModel(Trans, Index, intTotalIdx, false, ActiveForm, intClinicNo, 1, false))
                    }

                    if (Trans[Index].Status === "Z") {
                        let _statusZ = false;
                        await this.statusZ(Trans[Index], intClinicNo)
                            .then((res: boolean) => {
                                _statusZ = res;
                            });

                        if (_statusZ) {
                            await this.deleteATran(new DeleteATranModel(Trans, Index, intTotalIdx, false, ActiveForm, intClinicNo, 1, false))
                        }
                    }
                }
            }

            DoneProc = true;
        }

        return { DoneProc, Trans };
    }

    async checkItemLbl(LinkNo: number, LinkType: number, LinkName: string, Status: string, intClinicNo: number): Promise<string> {
        let strTemp = '';
        let strCode = '';

        if (LinkType != INVENT)
            return strTemp

        let some2: InvtListModel = this.catalogService.inventory_list.find(t => t.item_no == LinkNo && t.item_clinic == intClinicNo);
        if (some2) {
            strCode = some2.item_presc_code;
            if (strCode !== "") {
                if (Status === "P" || Status === "L") {
                    strTemp = strCode;
                } else {
                    await Swal.fire({
                        text: `Do you want to print a label for ${LinkName}?`,
                        showCancelButton: true,
                        showConfirmButton: true,
                        confirmButtonText: 'Yes',
                        didOpen: () => { Swal.hideLoading(); }
                    }).then((result) => {
                        if (result.isConfirmed) {
                            strTemp = strCode;
                        }
                    })
                }
            } else {
                if (Status === "P" || Status === "L") {
                    strTemp = "BLANK"
                }
            }
        }
        return strTemp
    }

    getCheckAvail(intLinkNo: number, intClinicNo: number) {
        let promise = new Promise(async (resolve, reject) => {
            this.api.post(`${this.baseUrl}/CheckAvail`, { intLinkNo: intLinkNo, intClinicNo: intClinicNo })
                .subscribe((res: any) => {
                    resolve(res)
                });
        });
        return promise;

    }

    updateCheckAvail(sglQOH: number, sglQYtd: number, sglQMon: number, intLinkNo: number, intClinicNo: number) {
        let promise = new Promise(async (resolve, reject) => {
            this.api.post(`${this.baseUrl}/UpdateCheckAvail`, { sglQOH: sglQOH, sglQYtd: sglQYtd, sglQMon: sglQMon, intLinkNo: intLinkNo, intClinicNo: intClinicNo })
                .subscribe((res: any) => {
                    resolve(1);
                });
        });
        return promise;
    }

    checkAvail(sglUnits: number, intLinkNo: number, strFix: string, intClinicNo: number) {
        let promise = new Promise(async (resolve, reject) => {

            let strName: string;
            let sglQOH: number = 0, sglUPI: number = 0, sglQYtd: number = 0, sglQMon: number = 0, sglUsage: number = 0;

            await this.getCheckAvail(intLinkNo, intClinicNo)
                .then((res: any) => {
                    sglUPI = res.unit_per_issue;
                    sglQOH = res.qty_on_hand;
                    sglQYtd = res.qty_ytd;
                    sglQMon = res.qty_this_month;
                    strName = res.item_desc;
                });

            if (strFix === "S") {
                sglUsage = sglUnits * Number(sglUPI);
            } else {
                sglUsage = sglUnits;
            }

            if (sglUnits < 0) {
                await Swal.fire({
                    text: "Return " + sglUsage * -1 + " units of " + strName + "  to stock?",
                    showCancelButton: true,
                    confirmButtonText: 'Yes'
                }).then((result) => {
                    if (result.isConfirmed) {
                    } else {
                        resolve(0);
                        return;
                    }
                })
            }

            if ((sglQOH < sglUsage) && (sglUsage > 0)) {
                await Swal.fire({
                    text: "Not enough units of " + strName + " available. Continue?",
                    showCancelButton: true,
                    confirmButtonText: 'Yes'
                }).then((result) => {
                    if (result.isConfirmed) {
                    } else {
                        sglUnits = 0;
                        resolve(0);
                        return;
                    }
                })
            }

            sglQOH = Number(sglQOH) - Number(sglUsage);
            sglQMon = Number(sglQMon) + Number(sglUsage);
            sglQYtd = Number(sglQYtd) + Number(sglUsage);

            // if (intClinicType !== PETVET_CLINIC) {
            await this.updateCheckAvail(sglQOH, sglQYtd, sglQMon, intLinkNo, intClinicNo).then(() => { });
            // } else {

            // }

            resolve(1);
        });
        return promise;

    }

    updateSubTranUnit(sglAvail: number, Seq: number, i: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/UpdateSubTranUnit`, { sglAvail: sglAvail, Seq: Seq, i: i })
                .subscribe((res: any) => {
                    resolve(1);
                });
        });
        return promise;
    }

    statusZ(arg0: TranRecordModel, intClinicNo: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/statusZ`, { Tran: arg0, intClinicNo: intClinicNo })
                .subscribe((res: any) => {
                    if (res) {
                        resolve(res);
                    } else {
                        resolve(false);
                    }
                });
        });
        return promise;
    }

    moveToHistoryProc(arg0: TranRecordModel, lngInvNo: number, intUserNo: number, intClinicNo: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/MoveToHistoryProc`, { Tran: arg0, lngInvNo: lngInvNo, intUserNo: intUserNo, intClinicNo: intClinicNo })
                .subscribe((res: any) => {
                    if (res) {
                        resolve(res);
                    } else {
                        resolve(false);
                    }
                });
        });
        return promise;
    }

    getRecall(arg0: TranRecordModel, intClinicNo: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/GetRecall`, { tmpTran: arg0, intClinicNo: intClinicNo })
                .subscribe((res: any) => {
                    if (res) {
                        resolve(res);
                    } else {
                        resolve(false);
                    }
                });
        });
        return promise;
    }

    addRecall(arg0: TranRecordModel, intDays: number, strCat: string, strAsk: string, intClinicNo: number) {

        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/AddRecall`, { tmpTran: arg0, intDays: intDays, strCat: strCat, strAsk: strAsk, intClinicNo: intClinicNo })
                .subscribe((res: any) => {
                    if (res) {
                        resolve(res);
                    } else {
                        resolve(false);
                    }
                });
        });
        return promise;
    }

    getBaseCharge(BaseChg: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/GetBaseCharge`, { strBaseCode: BaseChg })
                .subscribe((res: any) => {
                    if (res) {
                        resolve(res);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    checkIDChip(arg0: TranRecordModel, strTemp: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/CheckIDChip`, { tmpTran: arg0, strTemp: strTemp })
                .subscribe((res: any) => {
                    if (res) {
                        resolve(res);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    fillHealthInfo(PetNo: number, ApproveBy: number): boolean {
        // $("#frmHealthCert").modal("toggle");
        // throw new Error("Method not implemented.");
        return false;
    }

    checkHealth(arg0: TranRecordModel): boolean {
        // CheckHealth = False
        // For i = 0 To UBound(HealthItemNo) - 1
        //     If (tmpTran.LinkNo = HealthItemNo(i) And tmpTran.LinkType = HealthItemType(i)) Then
        //         CheckHealth = True
        //         Exit For
        //     End If
        // Next i
        // throw new Error("Method not implemented.");
        return false;
    }

    checkRabies(arg0: TranRecordModel): boolean {
        // throw new Error("Method not implemented.");
        return false;
    }

    saveRabInfo_1(intClinicNo: number, lngPetNo: number, blnReTag: boolean) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SaveRabInfo_1`, { blnReTag: blnReTag, lngPetNo: lngPetNo, intClinicNo: intClinicNo })
                .subscribe((res: any) => {
                    if (res) {
                        resolve(res);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    saveRabInfo_2(PetNo: number, strTagNo: string, intVaccNum: number, strRabDate: string, intDocNo: number, intClinicNo: number, intYear: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SaveRabInfo`, { lngPetNo: PetNo, strTagNo: strTagNo, intVaccNum: intVaccNum, strRabDate: strRabDate, intDocNo: intDocNo, intClinicNo: intClinicNo, intYear: intYear })
                .subscribe((res: any) => {
                    if (res) {
                        resolve(res);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    async saveRabInfo(PetNo: number, intDocNo: number, blnReTag: boolean, intYear: number, intClinicNo: number) {
        let RabInfo_1: any[] = [];
        let strTagNo: string, strRabDate: string, intVaccNum: number, i: number, intSel: number;
        let strOptions: any[] = [];
        let intRVaccNo: any[] = [];

        await this.saveRabInfo_1(intClinicNo, PetNo, blnReTag)
            .then((res: any[]) => {
                RabInfo_1.push(...res);
            });

        if (blnReTag) {
            if (RabInfo_1.length > 0) {
                strTagNo = RabInfo_1[0].rabie_tag_no;
                strRabDate = RabInfo_1[0].rabie_vacc_date;
                intDocNo = RabInfo_1[0].rabie_doctor;
                intVaccNum = RabInfo_1[0].rabie_vacc_no;
                intYear = RabInfo_1[0].rabie_year;
            } else if (intYear < 0) {
                Swal.fire(`Cannot find an existing rabies record. Certificate CANNOT be issued.`)
                return false;
            } else {
                Swal.fire(`Cannot find an existing rabies record. RETAG code should NOT be used.`)
                return false;
            }
        } else {
            i = 0;
            if (RabInfo_1.length > 0) {
                for (i = 0; i < RabInfo_1.length; i++) {
                    const element = RabInfo_1[i];
                    strOptions.push(element.vaccine_batch_no);
                    intRVaccNo.push(element.vaccine_no);
                }

                if (i === 0) {
                    Swal.fire(`WARNING: No active Rabies vaccine batch number found! Please add a batch number and redo this procedure. Rabies certificate will not be generated without an active batch number.`)
                    return false;
                } else if (i === 1) {
                    intSel = 0;
                } else {
                    let options = {};
                    strOptions.forEach((element, index) => {
                        options[`${index}`] = element;
                    });
                    const { value: selection } = await Swal.fire({
                        title: "Select Automatic Recall To Add", //route_abbrev + " -- " + route_note
                        input: 'select',
                        inputOptions: options,
                        showCancelButton: false,
                        inputValidator: (value) => {
                            return new Promise((resolve) => {
                                resolve(undefined)
                            })
                        }
                    })

                    if (selection) {
                        intSel = Number(selection);
                    }
                }
            } else {
                Swal.fire(`WARNING: No active Rabies vaccine batch number found! Please add a batch number and redo this procedure. Rabies certificate will not be generated without an active batch number.`)
                return false;
            }
        }

        //Delete...

        if (blnReTag) {
            let options = {};
            [1, 3].forEach((element, index) => {
                options[`${index}`] = `${element}-year`;
            });
            const { value: selection } = await Swal.fire({
                title: "Is this a 1-year or a 3-year certificate?", //route_abbrev + " -- " + route_note
                input: 'select',
                inputOptions: options,
                showCancelButton: false,
                inputValidator: (value) => {
                    return new Promise((resolve) => {
                        resolve(undefined)
                    })
                }
            })

            if (selection) {
                intYear = Number(selection) === 0 ? 1 : 3;
            }

            //Insert...
            await this.saveRabInfo_2(PetNo, strTagNo, intVaccNum, strRabDate, intDocNo, intClinicNo, intYear).then(() => { });
        } else {
            for (let index = 0; index < RabInfo_1.length; index++) {
                const element = RabInfo_1[index];

                if (intYear < 0) {
                    let options = {};
                    [1, 3].forEach((element, index) => {
                        options[`${index}`] = `${element}-year`;
                    });
                    const { value: selection } = await Swal.fire({
                        title: "Is this a 1-year or a 3-year certificate?", //route_abbrev + " -- " + route_note
                        input: 'select',
                        inputOptions: options,
                        showCancelButton: false,
                        inputValidator: (value) => {
                            return new Promise((resolve) => {
                                resolve(undefined)
                            })
                        }
                    })

                    if (selection) {
                        intYear = Number(selection) === 0 ? 1 : 3;
                    }

                    //Insert...
                    await this.saveRabInfo_2(PetNo, strTagNo, intRVaccNo[intSel], strRabDate, intDocNo, intClinicNo, intYear).then(() => { });
                }
            }
        }
    }

    getLongName(intCodeNo: number, intCodeType: number, intClinicNo: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/GetLongName`, { intCodeNo: intCodeNo, intCodeType: intCodeType, intClinicNo: intClinicNo })
                .subscribe((res: any) => {
                    resolve(res.result);
                });
        });
        return promise;
    }

    getInventory(intLinkNo: number, intClinicNo: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/GetInventory`, { intLinkNo: intLinkNo, intClinicNo: intClinicNo })
                .subscribe((res: any) => {
                    resolve(res);
                });
        });
        return promise;
    }

    selectDiscount(LinkNo: number, intClinicNo: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SelectDiscount`, { intLinkNo: LinkNo, intClinicNo: intClinicNo })
                .subscribe((res: any) => {
                    resolve(res);
                });
        });
        return promise;
    }

    insertLog(strLogs: string, sglWaste: number, sglUnits: number, sglAvailable: any, intLinkNo: number, strDesc: string, lngPetNo: number, dteDate: string, intApprBy: number, intClinicNo: number) {
        let strReason = '';
        let strChar = '';

        let promise = new Promise(async (resolve, reject) => {
            const { value: quantity } = await Swal.fire({
                title: `Enter reason for using ${strDesc}`,
                input: 'text',
                inputValue: 0.05
            })

            if (quantity) {
                strReason = quantity;
            }

            let splitstrLogs = strLogs.split('');
            for (let index = 0; index < strLogs.length; index++) {
                strChar = splitstrLogs[index];
                if (strChar != '') {
                    await this.api.post(`${this.baseUrl}/InsertLog`, { strLogs: strLogs, strChar: strChar, sglWaste: sglWaste, sglUnits: sglUnits, sglAvailable: sglAvailable, intLinkNo: intLinkNo, strDesc: strDesc, lngPetNo: lngPetNo, dteDate: dteDate, strReason: strReason, intApprBy: intApprBy, intClinicNo: intClinicNo })
                        .subscribe((res: any) => {
                        });
                }
            }

            resolve(1);
        });
        return promise;
    }

    updateWaste(sglWaste: number, LinkNo: number, intClinicNo: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/UpdateWaste`, { sglWaste: sglWaste, LinkNo: LinkNo, intClinicNo: intClinicNo })
                .subscribe((res: any) => {
                    resolve(res);
                });
        });
        return promise;
    }

    selectWaste(LinkNo: number, intClinicNo: any) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SelectWaste`, { intLinkNo: LinkNo, intClinicNo: intClinicNo })
                .subscribe((res: any) => {
                    resolve(res);
                });
        });
        return promise;
    }

    updateRouteLocation(Route: string, Location: string, Seq: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/UpdateRouteLocation`, { Route: Route, Location: Location, Seq: Seq })
                .subscribe((res: any) => {
                    resolve(res);
                });
        });
        return promise;
    }

    selectRoutes() {
        let promise = new Promise((resolve, reject) => {
            if (localStorage.admin_routes) {
                this.admin_routes = JSON.parse(localStorage['admin_routes']);
                resolve(1);
                return;
            }

            this.api.post(`${this.baseUrl}/SelectRoutes`)
                .subscribe((res: DrugAdminRouteModel[]) => {
                    this.admin_routes = res;
                    localStorage['admin_routes'] = JSON.stringify(this.admin_routes)
                    resolve(res);
                });
        });
        return promise;
    }

    getSubTrans(Seq: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/GetSubTrans`, { Seq: Seq })
                .subscribe((res: any) => {
                    resolve(res);
                });
        });
        return promise;
    }

    getAsk_Unit(LinkNo: number, intClinicNo: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/Ask_Unit`, { LinkNo: LinkNo, intClinicNo: intClinicNo })
                .subscribe((res: OrderItemInfoModel[]) => {
                    resolve(res);
                });
        });
        return promise;
    }

    async ask_Unit(tmpTran: TranRecordModel, sglCost: number, blnIsEstimate: boolean, intClinicNo: number): Promise<[number, TranRecordModel]> {
        let ask_Unit = 0;
        let intTruncUnit: number, intResp: number, sglUnits: number, sglUPI: number, sglXUnits: number, strSQL: OrderItemInfoModel[], strMeasure: string, strSQL2: string;

        tmpTran.Cost = (tmpTran.Cost == undefined || tmpTran.Cost == null) ? 0 : tmpTran.Cost;

        const CalcCost = async () => {
            if (tmpTran.LinkType === INVENT) {
                if (tmpTran.Status === "F") {
                    sglUnits = sglUnits * -1;

                    if (blnIsEstimate === false)
                        await this.checkAvail(sglUnits, tmpTran.LinkNo, tmpTran.LinkFix, intClinicNo);

                    if (tmpTran.CheckCost === "F") {
                        sglCost = tmpTran.Cost * -1
                    } else if (tmpTran.LinkFix === "S") {
                        sglCost = (sglUnits * sglUPI * tmpTran.UnitCost) - sglCost;
                    } else {
                        if (sglUnits < 0 && tmpTran.UnitCost < 0)
                            sglUnits = sglUnits * -1

                        sglCost = (sglUnits * tmpTran.UnitCost) - tmpTran.Cost;

                        if (tmpTran.BaseChg === '' && tmpTran.CheckCost !== 'N') {
                            await this.checkBaseCharge(new CheckBaseChargeModel(tmpTran.LinkNo, tmpTran.LinkType, tmpTran.IType, intClinicNo))
                                .then((CheckBaseCharge: number) => {
                                    sglCost = sglCost - CheckBaseCharge;
                                });
                        } else {
                            await this.getBaseCharge(tmpTran.BaseChg)
                                .then((CheckBaseCharge: number) => {
                                    sglCost = sglCost - CheckBaseCharge;
                                });
                        }
                    }
                } else if (tmpTran.Status !== "Z") {
                    if (blnIsEstimate === false)
                        await this.checkAvail(sglUnits, tmpTran.LinkNo, tmpTran.LinkFix, intClinicNo);

                    if (tmpTran.CheckCost === "F") {
                        sglCost = tmpTran.UnitCost * tmpTran.Unit;
                    } else if (tmpTran.LinkFix === "S") {
                        if (sglUPI !== 0) {
                            sglCost = (sglUnits * sglUPI * tmpTran.UnitCost) + sglCost;
                        } else {
                            sglCost = (sglUnits * tmpTran.UnitCost) + sglCost;
                        }
                    } else {
                        sglCost = (sglUnits * tmpTran.UnitCost) + tmpTran.Cost;
                    }
                }
            } else if (tmpTran.CheckCost === "F") {
                if (tmpTran.LinkFix === "X") {
                    sglCost = tmpTran.UnitCost;
                } else {
                    sglCost = (tmpTran.Cost * -1) - sglCost;
                }
            } else {
                sglCost = (sglUnits * tmpTran.UnitCost) + sglCost;
            }

            if (sglUPI !== 0 && sglUPI !== undefined) {
                sglUnits = sglUnits * sglUPI;
            }

            sglUnits = Math.round(sglUnits);
            sglCost = Math.round(sglCost);

            let u1 = new UpdateTranModel(undefined, 0, '', false, 0, '', 0, 0, '', 0);
            u1.Trans = tmpTran;
            u1.sglProcPrice = sglUnits;
            await this.updateTranCost(u1).then(() => { });

            let u2 = new UpdateTranModel(undefined, 0, '', false, 0, '', 0, 0, '', 0);
            u2.Trans = tmpTran;
            u2.Trans = tmpTran;
            await this.updateTranUnit(u2).then(() => { });

            tmpTran.Unit = sglUnits;
            tmpTran.Cost = sglCost;

            ask_Unit = tmpTran.Unit;

            return [ask_Unit, tmpTran];
        }
        //debugger;
        await this.getAsk_Unit(tmpTran.LinkNo, intClinicNo)
            .then((res: OrderItemInfoModel[]) => {
                strSQL = res;
            });

        ask_Unit = tmpTran.Unit;
        if (tmpTran.LinkType === INVENT) {

            if (strSQL && strSQL.length === 0) {
                await Swal.fire(`Cannot get unit of measure for ${tmpTran.LinkName} (${tmpTran.LinkDesc})`)
                sglCost = 0;
                return [ask_Unit, tmpTran];
            } else {
                if (tmpTran.LinkFix === "M") {
                    sglUnits = tmpTran.Unit;
                    await CalcCost();
                } else if (tmpTran.LinkFix === "F") {
                    sglUnits = tmpTran.Unit;
                    if (tmpTran.IType === 'P' || tmpTran.IType === 'S') {
                        strMeasure = strSQL[0].issue_container;
                    } else {
                        strMeasure = strSQL[0].method_of_issue;
                    }
                } else if (tmpTran.LinkFix === "S") {
                    strMeasure = strSQL[0].issue_container;
                } else {
                    strMeasure = strSQL[0].method_of_issue;
                }
            }

            if (tmpTran.LinkFix !== "F") {
                if (tmpTran.Status === "P" || tmpTran.Status === "D") {
                    sglUnits = tmpTran.Unit;
                } else {
                    const { value: quantity } = await Swal.fire({
                        title: `Please enter the number of ${strMeasure} of ${tmpTran.LinkDesc}`,
                        input: 'tel',
                        inputValue: tmpTran.Unit ?? ''
                    })

                    if (quantity) {
                        if (Number(quantity) <= 0) {
                            await Swal.fire({
                                text: "Cancel entering units?",
                                showCancelButton: true,
                                confirmButtonText: 'Yes'
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    ask_Unit = 0;
                                    sglCost = 0;
                                    sglUnits = 0;
                                    return { ask_Unit, tmpTran };
                                } else {
                                    sglUnits = Number(quantity);
                                }
                            })
                        } else {
                            sglUnits = Number(quantity);
                        }

                        let proc_code: any;

                        this.catalogService.getProcLinkInfo(tmpTran.LinkNo, intClinicNo)
                            .then((res: any) => {
                                if (res) {
                                    proc_code = this.catalogService.proc_links.find(t => t.link_no === tmpTran.LinkNo.toString() && t.link_clinic === tmpTran.ClinicNo.toString() && t.link_type === tmpTran.LinkType.toString())?.proc_no;
                                    //update chip number or chip ID in the pet profile
                                    let strTemp = '';
                                    if (proc_code && this.catalogService.clinic_code.some(t => t.pet_info_proc_no === Number(proc_code))) {
                                        strTemp = quantity;
                                        //this.checkIDChip(tmpTran, strTemp).then(() => { });

                                        let curpet = this.petService.pet
                                        this.petService.SetupPetProfile(curpet.pet_no, this.petService.getCurrentDateTime(), 35, Number(strTemp)).then(() => {
                                            this.petService.GetPetProfileLastEntry(curpet.pet_no).then(() => { });
                                            this.petService.pet.chip_no = strTemp;
                                        })

                                    }
                                }
                            });

                    }
                }
            }

            if (tmpTran.LinkFix === "F") {
                if (tmpTran.IType === "P" || tmpTran.IType === "S") {
                    sglUnits = strSQL[0].unit_per_issue;
                } else {
                    const { value: quantity } = await Swal.fire({
                        title: `Please enter the number of ${strMeasure} of ${tmpTran.LinkDesc}`,
                        input: 'tel',
                        inputValue: tmpTran.Unit ?? ''
                    })

                    if (quantity) {
                        if (Number(quantity) <= 0) {
                            ask_Unit = sglUnits;
                            sglCost = 0;
                            return [ask_Unit, tmpTran];
                        }
                    }
                }
            } else if (tmpTran.LinkFix === "Y") {
                if (blnIsEstimate === false) {
                    const { value: quantity } = await Swal.fire({
                        title: `Please enter the number of ${strMeasure} used of ${tmpTran.LinkDesc}. Minimum = ${tmpTran.Unit}`,
                        input: 'tel',
                        inputValue: tmpTran.Unit ?? '',
                        inputValidator: (value) => {
                            if (!value) {
                                return 'You need to write something!'
                            }
                            if (Number(value) < tmpTran.Unit) {
                                return `Minimum = ${tmpTran.Unit}`;
                            }
                        }
                    })

                    if (quantity) {
                        sglUnits = Number(quantity);
                    }
                } else {
                    sglUnits = tmpTran.Unit;
                }
            } else if (tmpTran.LinkFix === "S") {
                sglUPI = strSQL[0].unit_per_issue;
            }

        } else if (tmpTran.LinkType === 0) {
            if (tmpTran.LinkFix === "X") {
                if (blnIsEstimate === false) {
                    if (tmpTran.LinkName !== "VITTOR" && tmpTran.LinkName !== "BUPR-O") {
                        const { value: quantity } = await Swal.fire({
                            title: `Please enter the number of ${tmpTran.LinkDesc}`,
                            input: 'tel',
                            inputValue: tmpTran.Unit ?? ''
                        })

                        if (quantity) {
                            if (quantity <= 0) {
                                await Swal.fire({
                                    text: "Cancel entering units?",
                                    showCancelButton: true,
                                    confirmButtonText: 'Yes'
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        sglUnits = 0;
                                    } else {
                                        sglUnits = quantity;
                                    }
                                })
                            } else {
                                sglUnits = quantity;
                            }
                        }
                    } else {
                        sglUnits = tmpTran.Unit;
                    }
                } else {
                    sglUnits = tmpTran.Unit;
                }

                if (sglUnits !== tmpTran.Unit) {
                    let u1 = new UpdateTranModel(undefined, 0, '', false, 0, '', 0, 0, '', 0);
                    u1.Trans = tmpTran;
                    await this.updateTranUnit(u1).then(() => { });
                    tmpTran.Unit = sglUnits;
                }
            }

            var SubTrans: SubTranRecordModel[] = []
            await this.getSubTrans(tmpTran.Seq)
                .then((res: any[]) => {
                    SubTrans = res;
                });

            for (let index = 0; index < SubTrans.length; index++) {
                const element = SubTrans[index];

                if (tmpTran.LinkFix !== "X") {
                    await this.getBaseCharge(element.BaseCharge)
                        .then((CheckBaseCharge: number) => {
                            sglXUnits = CheckBaseCharge;
                        });

                    if (tmpTran.Status === "F") {
                        sglUnits = element.Unit;

                        if (tmpTran.LinkFix === "F") {
                            sglCost = tmpTran.UnitCost * -1 + tmpTran.Cost - sglXUnits
                        } else if (tmpTran.CheckCost === "F") {
                            sglCost = tmpTran.UnitCost + tmpTran.Cost - sglXUnits;
                        } else {
                            sglCost = sglUnits * tmpTran.UnitCost + tmpTran.Cost - sglXUnits;
                        }
                    } else {
                        tmpTran.Cost = tmpTran.Cost + sglXUnits;
                        sglUnits = tmpTran.Unit;
                    }
                } else {
                    sglUnits = tmpTran.Unit * element.Unit;
                }

                intResp = element.LinkNo;

                if (element.LinkType === INVENT) {
                    // FindFix
                    let some: CodesFileModel = this.catalogService.codes_file.find(t => t.code_no == intResp && t.code_type == 1 && t.code_clinic == intClinicNo);
                    if (some) {
                        strMeasure = some.code_fix;
                        sglUnits = Math.round(sglUnits);

                        if (blnIsEstimate === false) {
                            await this.checkAvail(sglUnits, intResp, "T", intClinicNo);
                        }

                        if (tmpTran.LinkFix === "X") {
                            await this.updateSubTranUnit(sglUnits, tmpTran.Seq, intResp);
                        }
                    }
                }
            }

            if (tmpTran.Status === 'F') {
                if (sglUnits === 0)
                    sglUnits = tmpTran.Unit;

                if (sglCost > 0)
                    sglCost = sglCost * -1;

                let u1 = new UpdateTranModel(undefined, 0, '', false, 0, '', 0, 0, '', 0);
                u1.Trans = tmpTran;
                u1.sglProcPrice = sglUnits;
                await this.updateTranCost(u1).then(() => { });

                tmpTran.Unit = sglUnits;
                tmpTran.Cost = sglCost;
                ask_Unit = tmpTran.Unit;
                return [ask_Unit, tmpTran];
            }

            if (tmpTran.LinkFix === "X") {
                sglUnits = tmpTran.Unit
            } else {
                sglUnits = 1;
            }
        }

        await CalcCost();

        return [ask_Unit, tmpTran];
    }

    async pharmProc(LinkNo: number, LinkType: number, IType: string, PetNo: number, Attending: number, Seq: number, Status: string, strUser: string, intUserNo: number, strLabelCode: string, Index: number, LinkName: string): Promise<void> {
        const res: PharmProcModel | undefined = await this.getPharmProc(LinkNo, LinkType, IType, PetNo, Attending, Seq, Status, strUser, intUserNo, strLabelCode, Index);
        if (!res) return;

        let sglUPI: number;
        let unitLabel: string;
        let strItemFix: string;

        if (LinkType === INVENT) {
            const codeFix = res.code_fix ?? '';
            if (codeFix === 'B' || codeFix === 'S') {
                sglUPI     = res.unit_per_issue ?? 0;
                unitLabel  = res.issue_container ?? '';
                strItemFix = 'S';
            } else if (codeFix === 'F') {
                if (IType === 'S' || IType === 'P') {
                    sglUPI     = res.unit_per_issue ?? 0;
                    unitLabel  = res.issue_container ?? '';
                    strItemFix = 'S';
                } else {
                    sglUPI     = 1;
                    unitLabel  = res.method_of_issue ?? '';
                    strItemFix = 'T';
                }
            } else {
                sglUPI     = 1;
                unitLabel  = res.method_of_issue ?? '';
                strItemFix = 'T';
            }
        } else {
            sglUPI     = 1;
            unitLabel  = 'mls.';
            strItemFix = 'X';
        }

        let pet_name='';
        let species='';
        let client_no=0;
        let client_name='';

        this.petService.getPetById(PetNo).then((res: PetDetailModel) => {
              if(res){
                pet_name = res.pet_name;
                // this.weight = res.weight;
                //this.sex = res.sex;
                species = res.specie_name;
                // this.breed = res.breed_name;
                // this.color = res.color_name;
                // this.done_date = res.rabieDate;
        
                this.clientService.getClientById(res.client_no).then((res: ClientModel) => {
                  if(res){
                    client_no = res.client_no;
                    client_name = res.last_name + ', ' + res.first_name + ' ' + res.middle_initial;
                    // this.home_phone = res.home_phone;
                    // this.work_phone = res.work_phone;
                    // this.address = res.address;
                  }
                });
              }
            });

        const labelEntry = new LabelEntry(
            0,                                      // lngClientNo
            intUserNo,                              // intUserNo
            Index,                                  // intIndex
            strLabelCode.toUpperCase(),             // labelCode
            pet_name,                               // petName
            species,                                // specie
            unitLabel,                              // unitLabel
            LinkNo,                                 // intDocNo (using LinkNo as the document number)
            sglUPI,                                 // sglUPI
            '',                                     // strLabelType (will be set by frmLabelEntry)
            Seq,                                    // lngTranSeq
            0,                                      // intItemNo
            '',                                     // strInstructions
            strItemFix,                             // strItemFix
            0                                       // sglTotal
        );

        labelEntry.intUserNo = (Attending > 0) ? Attending : intUserNo;
        labelEntry.specie = species;

        const result = await this.labelEntryService.LabelEntry(labelEntry, Status, Seq, LinkName );
        if (result) {
            labelEntry.sglUPI = result.sglUPI;
            labelEntry.strInstructions = result.strInstructions;
        }
    }

    getPharmProc(LinkNo: number, LinkType: number, IType: string, PetNo: number, Attending: number, Seq: number, Status: string, strUser: string, intUserNo: number, strTemp: string, Index: number): Promise<PharmProcModel | undefined> {
        const body: Partial<PharmProcModel> = {
            intLinkNo:    LinkNo,
            intLinkType:  LinkType,
            strIType:     IType,
            lngPetNo:     PetNo,
            intAttending: Attending,
            lngSeq:       Seq,
            strStatus:    Status,
            strUser:      strUser,
            intUserNo:    intUserNo,
            strLabelCode: strTemp,
            Index:        Index
        };
        return new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/PharmProc`, body)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(new PharmProcModel(
                            res.method_of_issue,
                            res.unit_per_issue,
                            res.issue_container,
                            res.code_fix,
                            res.intLinkNo,
                            res.intLinkType,
                            res.strIType,
                            res.lngPetNo,
                            res.intAttending,
                            res.lngSeq,
                            res.strStatus,
                            res.strUser,
                            res.intUserNo,
                            res.strLabelCode,
                            res.Index,
                            res.dispensedLater ?? null
                        ));
                    } else {
                        resolve(undefined);
                    }
                });
        });
    }

    checkForRefills(PetNo: number, LinkNo: number) {
        let promise = new Promise((resolve, reject) => {
            resolve(1);
        });
        return promise;
    }

    updateTranDone(arg0: TranRecordModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/updateTranDone`, arg0)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(res);
                    } else {
                        resolve(undefined);
                    }
                });
        });
        return promise;
    }

    writtenPresc(arg0: TranRecordModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/WrittenPresc`, arg0)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(res);
                    } else {
                        resolve(undefined);
                    }
                });
        });
        return promise;
    }

    updateDocs(arg0: TranRecordModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/updateDocs`, arg0)
                .subscribe((res: any) => {
                    if (res) {
                        // proc_cost = new ProcCostModel(res.intCodeNo, res.intCodeType, res.strStatus, res.getProcCost, res.intClinicNo);
                        // resolve(proc_cost);
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    findOption_v2(strOptions: string[]): { Option, Index } {
        let salida: { Option, Index } = undefined;
        strOptions.forEach((child, index) => {

            if (this.LinkInfoParent.some(t => t.SelectedLinkName === child)) {
                salida = { Option: this.LinkInfoParent.find(t => t.SelectedLinkName === child), Index: index }
            }
        });

        return salida;
    }

    findOption(strOptions: string[], LinkInfo: LinkRecordModel[] = []): { Option: any, Index: number } {
    let salida: { Option: any, Index: number } = { Option: undefined, Index: -1 };
    let splitResult: string[] = [];
    let code: string = '';

    for (let index = 0; index < strOptions.length; index++) {
        const child = strOptions[index];
        splitResult = child.split(' -- ');

        if (this.LinkInfoParent.some(t => t.SelectedLinkName === child)) {

            return { Option: this.LinkInfoParent.find(t => t.SelectedLinkName === child), Index: index };
        }
        else if (splitResult.length > 1) {
            code = splitResult[0] + ' -- ';

            if (this.LinkInfoParent.some(t => t.SelectedLinkName && t.SelectedLinkName.includes(code))) {
                return { Option: this.LinkInfoParent.find(t => t.SelectedLinkName && t.SelectedLinkName.includes(code)), Index: index };
            }
            else {
                if (this.LinkInfoParent.some(t => t.SelectedArr && t.SelectedArr.includes(child)))
                    return { Option: this.LinkInfoParent.find(t => t.SelectedArr && t.SelectedArr.includes(child)), Index: index };
            }
        }
    }

        for (let index = 0; index < LinkInfo.length; index++) {
               const child = LinkInfo[index];
    
                let selected = this.LinkInfoParent.find(t => t.Category == child.Category && t.Category !="");
                if (selected) {
                    return { Option: selected, Index: index };
                }
        }

     return salida;
}

    fillTrans(trans: any): boolean {
    let option: LinkRecordModel | undefined = 
        this.LinkInfoParent.find(t => t.SelectedLinkName.includes(trans.LinkName + ' -- '));

    if (!option) {
        option = this.LinkInfoParent.find(t => t.LinkNo === trans.LinkNo);
    }

    if (!option)
        return false;

    const splitResult = option.SelectedLinkName.split(' -- ');

    trans.LinkDesc = splitResult.length > 1 
        ? splitResult[1] 
        : option.SelectedLinkName;

    trans.Category       = option.Category;
    trans.IndicationID   = option.IndicationID;
    trans.Unit           = option.Qty;
    trans.Dosage         = option.Dosage;
    trans.Unit_Measure   = option.DosageUnit;
    trans.Route          = option.AdminRoute;
    trans.Location       = option.Location;
    trans.Frequency      = option.Freq;
    trans.Days            = option.Days;

    return true;
    }

    fillBuildTrans(build: BuildTransactModel): boolean {
    return this.fillTrans(build);
    }

    fillHandleTrans(tran: TranRecordModel): boolean {
    return this.fillTrans(tran);
    }

    async assignProcLinkData(lngSupSeq: number, LinkModel: GetProcLinkModel) {

        let result: GetProcLinkModel = new GetProcLinkModel(0, 0, '', [], 0, 0, 0, 0, 0, LinkModel.strStatus);


        await this.getProcLink_New(LinkModel).then((res: GetProcLinkModel) => {
            result = res;

            result.strStatus = LinkModel.strStatus;
            if (this.LinkInfoParent.length > 0) {


                if (lngSupSeq != 0) {
                    let linkParent: LinkRecordModel = this.LinkInfoParent.find(x => x.LinkNo === LinkModel.intCodeNo);
                    if (linkParent)
                    {    
                        
                        result.strStatus = linkParent.Status;
               
                    }
                }
                else {
                    result.LinkInfo.forEach((child) => {
                        let selected = this.LinkInfoParent.find(t => t.Category == child.Category);
                        if (selected) {
                            child.Status = selected.Status;
                        }
                    });
                    result.LinkInfo = result.LinkInfo.filter(t => t.Status !== "X");
                    result.intLinkCount = result.LinkInfo.length;
                    result.intLinkCatCount = new Set(result.LinkInfo.map(x => x.Category)).size;
                }

            }

        });
        return result;
    }

    private usDateToISO(dateStr: string | null | undefined): string | null {
        if (!dateStr) return null;
        const m = dateStr.match(/^(\d{2})\/(\d{2})\/(\d{4})\s(\d{2}:\d{2}:\d{2})$/);
        return m ? `${m[3]}-${m[1]}-${m[2]}T${m[4]}` : dateStr;
    }

    displayTran(trans: PetProcsModel[]): TranRecordModel[] {
        let Trans: TranRecordModel[] = [];

        if (trans && trans.length > 0) {
            trans.forEach(element => {
                let t: TranRecordModel = new TranRecordModel();

                t.Seq = element.tran_sequence;
                t.SupSeq = element.sup_sequence
                t.PetNo = Number(element.pet_no)
                t.ClientNo = Number(element.client_no)
                t.ClinicNo = Number(element.clinic_no)
                t.LinkNo = element.link_no
                t.LinkType = element.link_type
                t.LinkName = element.link_name
                t.LinkDesc = element.link_desc === null ? element.link_name : element.link_desc
                t.LinkFix = element.item_type
                t.Unit = Number(element.unit)
                t.UnitCost = Number(element.unit_cost)
                t.ReqDate = this.usDateToISO(element.req_date) || '0001-01-01T00:00:00'
                t.ReqBy = element.req_by != null ? Number(element.req_by) : null
                t.ReqName = element.req_employee_initial
                t.ApproveDate = this.usDateToISO(element.appr_date)
                t.ApproveBy = element.appr_by != null ? Number(element.appr_by) : null
                t.ApproveName = element.appr_employee_initial
                t.DoneDate = this.usDateToISO(element.done_date)
                t.DoneBy = element.done_by != null ? Number(element.done_by) : null
                t.DoneName = element.done_employee_initial
                t.InvDate = this.usDateToISO(element.inv_date)
                t.InvBy = element.inv_by != null ? Number(element.inv_by) : null
                t.InvName = element.inv_employee_initial
                t.Status = element.status
                t.PStatus = element.pstatus === 'True' ? true : false
                t.Tax = Number(element.tax)
                t.Response1 = element.response1
                t.Response2 = element.response2
                t.Approval = element.approval
                t.CheckCost = element.chk_cost
                t.Cost = Number(element.cost)
                t.SubCost = Number(element.sub_cost)
                t.IType = element.item_type
                t.Route = element.route
                t.Printed = Boolean(Number(element.printed))
                t.WTime = this.usDateToISO(element.wtime)
                t.Moved = Boolean(Number(element.moved))
                t.RecallDate = this.usDateToISO(element.recall_date)
                t.IsOptional = element.optional != null ? Boolean(Number(element.optional)) : null
                t.IsRerequest = element.rerequest
                t.Supervisor = element.supervisor
                t.Attending = element.attending
                t.Location = element.location
                t.BaseChg = element.basechg
                t.IndicationID = element.indicationID != null ? Number(element.indicationID) : null
                t.Days = element.days != null ? Number(element.days) : null
                t.Frequency = element.frequency
                t.Dosage = element.dosage;
                
                Trans.push(t);

                if (element.children && element.children.length > 0) {
                    Trans.push(...this.displayTran(element.children));
                }
            });
        }

        return Trans;
    }

    getParentCode(Trans: TranRecordModel[], intTotalIdx: number, lngSupSeq: number, intPIdx: any) {
        let GetParentCode = 0;
        intPIdx = -1;
        if (Trans.some(t => t.Seq === lngSupSeq)) {
            intPIdx = Trans.findIndex(t => t.Seq === lngSupSeq);
            GetParentCode = Trans[intPIdx].LinkNo;
        }
        return GetParentCode;
    }

    getProcCost(proc_cost: ProcCostModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/procCost`, proc_cost)
                .subscribe((res: any) => {
                    if (res) {
                        proc_cost = new ProcCostModel(res.intCodeNo, res.intCodeType, res.strStatus, res.getProcCost, res.intClinicNo, res.lngPetNo);
                        resolve(proc_cost);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    checkPetSexSpecie(): Promise<CheckPetSexSpecieModel> {
        return new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/checkPetSexSpecie`, this.check_pss)
                .subscribe((res: any) => {
                    if (res) {
                        this.check_pss = new CheckPetSexSpecieModel(res.intCodeNo, res.intCodeType, res.lngPetNo, res.INVENT, res.intClinicNo, res.message, res.check);
                        resolve(this.check_pss);
                    } else {
                        resolve(this.check_pss);
                    }
                }, (error: any) => {
                    reject(error);
                });
        });
    }

    handleInvt2(handle_invt: HandleInvtModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/handleInvt`, handle_invt)
                .subscribe((res: any) => {
                    if (res) {
                        // handle_invt = new HandleInvtModel(res.lngClientNo, res.lngPetNo, res.intCodeNo, res.strStatus, res.strReqEmp, res.intEmpNo, res.strFix, res.data.intTotalIdx, res.data.intIndex, res.data.strCodeName, res.data.lngSupSeq, res.data.strLinkSaleTreat, res.data.sglLinkUnit, res.data.intSel, res.data.intClinicNo);
                        resolve(res);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    handleInvt(handle_invt: HandleInvtModel) {
        return new Promise((resolve, reject) => {
            let tmpTran = new TranRecordModel();
            let strBaseCharge = '';
            let strIType = '';

            tmpTran.ClientNo = handle_invt.lngClientNo
            tmpTran.ClinicNo = handle_invt.intClinicNo
            tmpTran.PetNo = handle_invt.lngPetNo
            tmpTran.LinkNo = handle_invt.intCodeNo
            tmpTran.LinkType = INVENT
            tmpTran.LinkName = handle_invt.strCodeName
            tmpTran.Status = handle_invt.strStatus
            tmpTran.ReqName = handle_invt.strReqEmp
            tmpTran.ReqBy = handle_invt.intEmpNo
            tmpTran.ReqDate = new Date().toISOString().split('T')[0]
            tmpTran.SupSeq = handle_invt.lngSupSeq
            tmpTran.LinkFix = handle_invt.strFix
            
            
            //tmpTran.UnitCost = handle_invt.sglLinkUnit;

            this.HandleInvt_GetItemDets(handle_invt.intCodeNo, handle_invt.intClinicNo,handle_invt.lngClientNo).then(async (res: Proc_HandleInvtModel) => {
                if (res != null) {
                    tmpTran.LinkDesc = res.item_desc;
                    tmpTran.UnitCost = res.unit_price;
                    strBaseCharge = res.item_base_charge;


                    if (handle_invt.strStatus == "F" && handle_invt.strLinkSaleTreat == "") {
                         
                        await this.checkBaseCharge(new CheckBaseChargeModel(handle_invt.intCodeNo,1, strIType, handle_invt.intClinicNo))
                                    .then((CheckBaseCharge: number) => {
                                        tmpTran.Cost = CheckBaseCharge;
                                    });

                        tmpTran.CheckCost = "N";
                    }
                    else if (handle_invt.strFix == "F") {
                        const options = {
                            0: 'SALE',
                            1: 'TREATMENT'
                        };
                        let intSel = 0

                        if (handle_invt.strLinkSaleTreat === "S") {
                            intSel = 0;  // SALE
                        } else if (handle_invt.strLinkSaleTreat === "T" || handle_invt.strLinkSaleTreat === "L") {
                            intSel = 1  // TREATMENT
                        } else {
                            const { value: selection } = await Swal.fire({
                                title: "Select Option for " + res.item_desc,
                                input: 'select',
                                inputOptions: options,
                                showCancelButton: false,
                                inputValidator: (value) => {
                                    return new Promise((resolve) => {
                                        resolve(undefined)
                                    })
                                }
                            })
                            intSel = Number(selection);
                        }

                        if (intSel == 0) {
                            strIType = "P";
                        }
                        else {
                            strIType = "T";
                        }
                    }
                    else {
                        strIType = ""
                    }

                    tmpTran.IType = strIType
                    tmpTran.Tax = (res.item_tax1 == true) ? 1 : 0;


                    if (handle_invt.strFix == "Y") {
                        let sglUnit = res.smallest_unit;
                        if (sglUnit < handle_invt.sglLinkUnit) {
                            tmpTran.Unit = sglUnit;
                        } else {
                            tmpTran.Unit = handle_invt.sglLinkUnit;
                        }
                    } else {
                        tmpTran.Unit = handle_invt.sglLinkUnit;
                    }
                }

                tmpTran.Printed = true
                tmpTran.ClinicNo = this.Clinic_no;

                await this.InsertTran(tmpTran).then((res: any) => {
                    tmpTran.Seq = res;
                })

                if (this.ArrayCount <= handle_invt.intTotalIdx) {
                    if (handle_invt.intTotalIdx > 0) {
                        handle_invt.Trans.length = handle_invt.intTotalIdx + 2;
                    }
                    this.ArrayCount = handle_invt.intTotalIdx;
                }

                handle_invt.intIndex = handle_invt.intTotalIdx;
                handle_invt.Trans[handle_invt.intTotalIdx] = tmpTran;
                handle_invt.intTotalIdx += 1;

                resolve(handle_invt);
            }).catch(reject);
        });
    }

    HandleInvt_GetItemDets(item_no, item_clinic,client_no) {
        let promise = new Promise((resolve, reject) => {
            this.api.get(`${this.baseUrl}/HandleInvt_GetItemDets?item_no=${item_no}&item_clinic=${item_clinic}&client_no=${client_no}`)
                .subscribe((res: any) => {
                    let item = new Proc_HandleInvtModel(res.data[0].item_desc, res.data[0].unit_price, res.data[0].admin_route, res.data[0].smallest_unit, res.data[0].item_tax1, res.data[0].item_base_charge)
                    resolve(item);
                });
        });
        return promise;
    }

    InsertTran(tran: TranRecordModel) {
        this.fillHandleTrans(tran);
        const endpoint = this.estimation ? `${this.baseUrl}/InsertEstTran?group_no=${this.estgroupno}` : `${this.baseUrl}/InsertTran`;
        const payload = {
            ...tran,
            ReqDate: tran.ReqDate || new Date().toISOString(),
            WTime: tran.WTime || null,
            RecallDate: tran.RecallDate || null,
            Printed: tran.Printed,
            Moved: tran.Moved,
            PStatus: tran.PStatus,
            IsOptional: tran.IsOptional,
        };
        let promise = new Promise((resolve, reject) => {
            this.api.post(endpoint, payload)
                .subscribe({
                    next: (res: any) => {
                        if (res) {
                            resolve(res.data);
                        } else {
                            resolve(0);
                        }
                    },
                    error: (err: any) => {
                        console.error('[InsertTran] 400 body:', err?.error);
                        console.error('[InsertTran] model sent:', JSON.stringify(payload));
                        reject(err);
                    }
                });
        });
        return promise;
    }

    updateTranInfo(update_tran: UpdateTranInfoModel) {
        const endpoint = this.estimation ? `${this.baseUrl}/updateEstTranInfo` : `${this.baseUrl}/updateTranInfo`;
        let promise = new Promise((resolve, reject) => {
            this.api.post(endpoint, update_tran)
                .subscribe((res: any) => {
                    if (res) {
                        update_tran = new UpdateTranInfoModel(res.tmpTran, res.sglLinkCost, res.strLinkFix, res.sglLinkUnit, res.strChkCost, res.sglProcPrice);
                        resolve(update_tran);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    updateTran(update_tran: UpdateTranModel) {
        const endpoint = this.estimation ? `${this.baseUrl}/updateEstTran` : `${this.baseUrl}/updateTran`;
        let promise = new Promise((resolve, reject) => {
            this.api.post(endpoint, update_tran)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    updateTranSec(update_tran: UpdateTranModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/updateTranSec`, update_tran)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    updateTranUnit(update_tran: UpdateTranModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/updateTranUnit`, update_tran)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    updateTranUnitChk(update_tran: UpdateTranModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/updateTranUnitChk`, update_tran)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    updateTranLUnit(update_tran: UpdateTranModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/updateTranLUnit`, update_tran)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    updateTranBaseCharge(update_tran: UpdateTranModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/updateTranBaseCharge`, update_tran)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    updateTranPrintable(update_tran: UpdateTranModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/updateTranPrintable`, update_tran)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    deleteATran(model: DeleteATranModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/deleteATran`, model)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(res);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    handleCorS(model: HandleCorSModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/handleCorS`, model)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(res);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    updateStatus(model: UpdateStatusModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/updateStatus`, model)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(res);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    updatePStatus(model: UpdatePStatusModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/updatePStatus`, model)
                .subscribe(
                    (res: any) => {
                        if (res) {
                            resolve(res);
                        } else {
                            resolve(0);
                        }
                    },
                    (err: any) => {
                        console.error('[updatePStatus] 400 body:', err?.error);
                        console.error('[updatePStatus] model sent:', JSON.stringify(model));
                        reject(err);
                    }
                );
        });
        return promise;
    }

    tranDynOpt(model: TranDynOptModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/tranDynOpt`, model)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(res);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getChildPrice(model: GetChildPriceModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/getChildPrice`, model)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(res);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getProcLink(model: GetProcLinkModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/getProcLink_New`, model)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(res);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getProcLink_New(model: GetProcLinkModel) {
        let promise = new Promise((resolve, reject) => {
            this.getProcLink(model).then((res: GetProcLinkModel) => {
                if (res) {
                    resolve(res);

                } else {
                    return new GetProcLinkModel(0, 0, '', [], 0, 0, 0, this.Clinic_no, 0, '');
                }
            }).catch((err: any) => {
                resolve(0);
            });
        });
        return promise;
    }

    getTreatmentProc(seq: number, pet_no: number): Observable<TreatmentProcModel> {
        return this.api.get(`${this.baseUrl}/getTreatmentProc?Seq=${seq}&PetNo=${pet_no}`);
    }
    async buildTreatGen_array(Trans: TranRecordModel[], intIndex: number, intTotalIdx: number) {
        let success = 0;
        if (Trans[intIndex].SupSeq === 0) {

            for (let i = 0; i < this.tx_setup_array.length; i++) {

                if (this.tx_setup_array[i].start_date != '') {
                    let next = this.tx_setup_array[i].next;
                    let tr = new TreatmentProcModel(this.tx_setup_array[i].treatmentID, Trans[intIndex].Seq, Trans[intIndex].PetNo, this.tx_setup_array[i].immediately, this.tx_setup_array[i].start_date, this.tx_setup_array[i].no_times, Number(this.tx_setup_array[i].repeat_in), Number(this.tx_setup_array[i].total_times), this.tx_setup_array[i].immediately, next, true,"","");
                    await this.treatmentProc(tr)
                        .then((_tr: TreatmentProcModel) => {
                            tr = _tr;
                            success = success + 1;
                        });

                    if (tr.TreatmentProc) {
                        if (tr.Generate) {
                            await this.treatGen(new TreatGenModel(Trans, intIndex, intTotalIdx, this.Clinic_no))
                                .then((res: TreatGenModel) => {
                                    Trans = res.Trans;
                                    intIndex = res.intIndex;
                                    intTotalIdx = res.intTotalIdx;
                                });
                        }
                    }
                }
            }
        }
        return success;
    }

    estimation: boolean = false;
    estgroupno: number = 0;


    buildTransact(model: BuildTransactModel) {

        this.fillBuildTrans(model);
        const endpoint = this.estimation ? `${this.baseUrl}/buildEstTransact?group_no=${this.estgroupno}` : `${this.baseUrl}/buildTransact`;
        let promise = new Promise((resolve, reject) => {
            this.api.post(endpoint, model)
                .subscribe({
                    next: (res: any) => {
                        if (res) resolve(res);
                        else resolve(0);
                        this.estimation = false;
                    },
                    error: (err: any) => {
                        console.error('[buildTransact] 400 body:', err?.error);
                        console.error('[buildTransact] model sent:', JSON.stringify(model));
                        reject(err);
                    }
                });
        });
        return promise;
    }

    public CalcDosage(model: CalcDosageModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/calcDosage`, model)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(res);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }


    /**
     * ASP.NET Core deserializa el body en camelCase por defecto.
     * Usa await sobre el Observable (toPromise) para que el llamador no siga hasta la respuesta HTTP.
     */
    async saveSubTran(model: SaveSubTranModel, linkCode: string, linkName: string): Promise<any> {

        try {
            const res = await this.api.post<any>(`${this.baseUrl}/saveSubTran`, model).toPromise();
            return res != null ? res : 0;
        } catch (err: any) {
            const msg = err?.error != null
                ? (typeof err.error === 'string' ? err.error : JSON.stringify(err.error))
                : err?.message ?? 'Error saving sub-transaction';
            await Swal.fire({
                icon: 'error',
                title: 'saveSubTran',
                text: msg + (linkName ? ` (${linkName})` : ''),
            });
            throw err;
        }
    }

    updateTranBaseCost(update_tran: UpdateTranModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/updateTranBaseCost`, update_tran)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    updateTranCost(update_tran: UpdateTranModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/updateTranCost`, update_tran)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    updateTranBaseChargeCost(update_tran: UpdateTranModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/updateTranBaseChargeCost`, update_tran)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    updateTranBaseChargeCostChk(update_tran: UpdateTranModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/updateTranBaseChargeCostChk`, update_tran)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    updateTranBaseChargeCostChkUnitDiv(update_tran: UpdateTranModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/updateTranBaseChargeCostChkUnitDiv`, update_tran)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    updateTranBaseChargeCostUnit(update_tran: UpdateTranModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/updateTranBaseChargeCostUnit`, update_tran)
                .subscribe({
                    next: (res: any) => resolve(res ? 1 : 0),
                    error: (err) => {
                        console.error('Validation errors:', err.error?.errors);  // ← aquí ves qué campo falla
                        reject(err);
                    }
                });
        });
        return promise;
    }


    // updateTranBaseChargeCostUnit(update_tran: UpdateTranNewModel) {
    //     let promise = new Promise((resolve, reject) => {
    //         this.api.post(`${this.baseUrl}/updateTranBaseChargeCostUnit`, update_tran)
    //             .subscribe((res: any) => {
    //                 if (res) {
    //                     resolve(1);
    //                 } else {
    //                     resolve(0);
    //                 }
    //             });
    //     });
    //     return promise;
    // }

    updateTranBaseChargeCostChkUnit(update_tran: UpdateTranModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/updateTranBaseChargeCostChkUnit`, update_tran)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    checkBaseCharge(update_tran: CheckBaseChargeModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.get(`${this.baseUrl}/CheckBaseCharge?intLinkNo=${update_tran.intLinkNo}&intLinkType=${update_tran.intLinkType}&strIType=${update_tran.strIType}&intClinicNo=${update_tran.intClinicNo}`)
                .subscribe(async (res: any) => {
                    if (res) {
                        if (res.data.length > 1) {
                            let options = {};
                            res.data.forEach((item, index) => {
                                options[index] = item.base_charge_desc + ' - $' + item.base_charge_price;
                            });
                            const { value: selection } = await Swal.fire({
                                title: "Select Option for Base Charge",
                                input: 'select',
                                inputOptions: options,
                                showCancelButton: false,
                                inputValidator: (value) => {
                                    return new Promise((resolve) => {
                                        resolve(undefined);
                                    });
                                }
                            });
                            if (selection !== undefined) {
                                resolve(res.data[selection].base_charge_price);
                            } else {
                                resolve(0);
                            }
                        }
                        else {
                            resolve(res.data[0].base_charge_price);
                        }
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getResponse(update_tran: GetResponseModel): Promise<string> {
        return new Promise((resolve, reject) => {
            this.api.postText(`${this.baseUrl}/getResponse`, update_tran)
                .subscribe({
                    next: (res: string) => resolve(res ?? ''),
                    error: (err) => reject(err)
                });
        });
    }

    refundProc(update_tran: RefundProcModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/refundProc`, update_tran)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(res);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    treatmentProc(update_tran: TreatmentProcModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/treatmentProc`, update_tran)
                .subscribe((res: TreatmentProcModel) => {
                    if (res) {
                        resolve(res);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    treatGen(update_tran: TreatGenModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/treatGen`, update_tran)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(res);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }


    updateTranBaseDone(update_tran: UpdateTranModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/updateTranBaseDone`, update_tran)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(res);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    UpdateTranPresc(update_tran: TranRecordModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/UpdateTranPresc`, update_tran)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(res);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    //----NEW CODE 
    getIndicationByProc(strCodeName: string, intClinicNo: number, lngPetNo: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getIndicationByProc?strCodeName=${strCodeName}&intClinicNo=${intClinicNo}&lngPetNo=${lngPetNo}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.LinkIndications = [];
                        this.LinkIndications = res.data.map((element) => {

                            return new IndicationModel(element.indicationID, element.indications);
                        });
                        resolve(1);
                    } else {
                        this.LinkIndications = [];
                        resolve(0);
                    }
                });
        });

        return promise;
    }

    getProcTreeview(Pet_no: number, Clinic_no: number, Code_type: number, Proc_no: number) {
        return this.api.get<LinkRecordModel[]>(`${this.baseUrl}/getProcTreeview?Pet_no=${Pet_no}&Clinic_no=${Clinic_no}&Code_type=${Code_type}&Proc_no=${Proc_no}`);
    }


    FindFix(code_no: number, code_type: number, code_clinic: number): Promise<string> {
        let promise = new Promise<string>((resolve, reject) => {
            this.api.get(`${this.baseUrl}/FindFix?code_no=${code_no}&code_type=${code_type}&code_clinic=${code_clinic}`)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(res.data);
                    } else {
                        resolve('');
                    }
                }, (error) => {
                    reject(error);
                });
        });
        return promise;
    }

    async childProcAll(intIndex: number, intTotalIdx: number, strCodeName: string, strStatus: string, strReqEmp: string, intEmpNo: number,
        lngClientNo: number, lngPetNo: number, lngSupSeq: number, SelectedLinks: string[]) {

        let intCodeType: number, intCodeNo: number, intSel: number;
        let intLinkCount: number;
        let intLinkCatCount: number, j: number, k: number, i: number;

        let lngSeq: number
        let strFix: string, strLinkCat: string
        let LinkInfo: LinkRecordModel[] = [];
        let DoseArr: DosageModel[] = [];
        let strOptions: string[] = [];

        let intLinkIndicationID: number = 0;


        let code = this.catalogService.codes_file.find(t => t.code_name === strCodeName);

        let RequestProc = -1
        let Result: LinkRecordModel
        //debugger;

        if (intIndex < 0) {
            if (code && code.code_type < 0) {
                Swal.fire({
                    title: `Code Not Found`,
                    text: `Invalid code type for ${strCodeName}`,
                    didOpen: () => {
                    },
                })
                return { RequestProc, Result };
            }

            intCodeType = code.code_type;
            intCodeNo = code.code_no;

            if (intCodeType === undefined) {
                Swal.fire({
                    title: `Code Not Found`,
                    text: `Invalid code type for ${strCodeName}`,
                    didOpen: () => {
                    },
                })
                return { RequestProc, Result };
            }
        }
        else {
            return { RequestProc, Result };
        }

        this.check_pss = new CheckPetSexSpecieModel(code.code_no, code.code_type, this.petService.current_pet_no, INVENT, this.Clinic_no, '', 0);
        await this.checkPetSexSpecie()
            .then(() => {
                // Swal.close();

            });
        if (this.check_pss.check !== 1) {
            Swal.fire({
                title: this.check_pss.message,
                didOpen: () => {
                },
            })
            return { RequestProc, Result };

        }

        let strCodeDesc = '';

        let intPIdx: number;

        strFix = code.code_fix;

        await this.getProcLink(new GetProcLinkModel(intCodeNo, intCodeType, strCodeName, LinkInfo, intLinkCount, intLinkCatCount, lngPetNo, this.Clinic_no, 0, ''))
            .then((res: GetProcLinkModel) => {
                LinkInfo = res.LinkInfo;
                intLinkCount = res.intLinkCount;
                intLinkCatCount = res.intLinkCatCount;
            });

        switch (strFix) {
            case 'G':
                if (intIndex >= 0) {
                    Swal.fire({
                        title: `Invalid Code Setup`,
                        text: `Group codes cannot be linked to other codes.`,
                        didOpen: () => {
                        },
                    })
                    return;
                }
                else if (intLinkCount === 0) {
                    Swal.fire({
                        text: `No linkages found for a group code.`,
                        didOpen: () => {
                        },
                    })
                    return;
                } else {
                    i = 0
                    k = 0

                    // NextLinkCat:
                    do {

                        let strLinkCat = LinkInfo[k].Category

                        for (i = k; i <= intLinkCount - 1; i++) {
                            if (strLinkCat == LinkInfo[i].Category) {
                                strOptions.push(`${LinkInfo[i].LinkName}`);
                                //this.strOptionsAll.push(new ProcLinksAllModel(LinkInfo[i].LinkNo, `${LinkInfo[i].code} -- ${LinkInfo[i].Desc}`, intCodeNo, true));
                                j = j + 1;
                            } else {
                                continue;
                            }
                        }

                        if (j == 1) {
                            intSel = 0 + k;
                        } else {

                            // intSel = OptionSelection("Select Item for " & strCodeName, j) + k
                            var some = this.findOption_v2(strOptions);
                            if (some) {
                                intSel = some.Index;
                                Result = LinkInfo[intSel]
                                SelectedLinks.push(`${Result.LinkName}`);
                            } else {
                                let options = {};
                                strOptions.forEach((element, index) => {
                                    options[`${index}`] = element;
                                });

                                // const { value: selection } = await Swal.fire({
                                //     title: "Select Item for " + strCodeName,
                                //     input: 'select',
                                //     inputOptions: options,
                                //     // inputPlaceholder: 'Select a fruit',
                                //     showCancelButton: false,
                                //     inputValidator: (value) => {
                                //         return new Promise((resolve) => {
                                //             resolve(undefined)
                                //         })
                                //     }
                                // })

                                // if (selection) {
                                //     // Swal.fire(`You selected: ${selection}`)
                                //     // if (strOptions.some(t => t === selection)) {
                                //     intSel = Number(selection) + k;
                                //     Result= LinkInfo[intSel]
                                //     SelectedLinks.push(`${Result.code} -- ${Result.Desc}`);
                                //     // }
                                // }
                            }
                        }


                        k = i;
                    } while (k < intLinkCount - 1 && i < intLinkCount);

                    RequestProc = 0;
                }
                break;
            case 'M':
                if (intLinkCount === 0) {
                    Swal.fire({
                        text: `No linkages found for a menu code.`,
                        didOpen: () => {
                        },
                    })
                    return;
                } else if (intLinkCatCount === 1) {
                    //code
                    if (intIndex < 0) {
                        for (i = 0; i <= intLinkCount - 1; i++) {
                            strOptions.push(`${LinkInfo[i].LinkName}`);
                            //this.strOptionsAll.push(new ProcLinksAllModel(LinkInfo[i].LinkNo, `${LinkInfo[i].code} -- ${LinkInfo[i].Desc}`, intCodeNo, true));
                        }
                        if (i === 1) {
                            intSel = 0;
                            Result = LinkInfo[intSel];
                            SelectedLinks.push(`${Result.code} -- ${Result.Desc}`);
                        } else {

                            var some = this.findOption_v2(strOptions);
                            if (some) {
                                intSel = some.Index;
                                Result = LinkInfo[intSel]
                            } else {
                                let options = {};
                                strOptions.forEach((element, index) => {
                                    options[`${index}`] = element;
                                });
                                //LKRK
                                // const { value: selection } = await Swal.fire({
                                //     title: "Select Item for " + strCodeName,
                                //     input: 'select',
                                //     inputOptions: options,
                                //     // inputPlaceholder: 'Select a fruit',
                                //     showCancelButton: true,
                                //     inputValidator: (value) => {
                                //         return new Promise((resolve) => {
                                //             resolve(undefined)
                                //         })
                                //     }
                                // })
                                // if (selection) {
                                //     intSel = Number(selection);
                                //     Result = LinkInfo[intSel]
                                //     SelectedLinks.push(`${Result.code} -- ${Result.Desc}`);
                                // }


                            }

                        }


                        // if (intSel >= 0) {

                        //     await this.childProc( intIndex, intTotalIdx, LinkInfo[intSel].code, strStatus, strReqEmp, intEmpNo, lngClientNo, lngPetNo, lngSupSeq,SelectedLinks)
                        //         .then((res) => {
                        //             if (res && res.RequestProc)
                        //                 intIndex = res.RequestProc;


                        //         });
                        // }                        

                        strOptions.forEach((element, index) => {

                            intSel = Number(index);
                            Result = LinkInfo[intSel]
                            SelectedLinks.push(`${Result.LinkName}`);

                            this.childProcAll(intIndex, intTotalIdx, LinkInfo[index].code, strStatus, strReqEmp, intEmpNo, lngClientNo, lngPetNo, lngSupSeq, SelectedLinks)
                                .then((res) => {
                                    if (res && res.RequestProc)
                                        intIndex = res.RequestProc;


                                });
                        });

                        RequestProc = intIndex;

                    }
                } else {
                    Swal.fire({
                        text: `Too many link categories found for M type code.`,
                        didOpen: () => {
                        },
                    })
                    return;
                }
                break;

                const DoAgain = async (ejecutar: boolean, exec: boolean) => {

                    if (intIndex < 0 || ejecutar) {
                        if (exec) {
                            if (!(lngSupSeq === 0 && exec)) {
                                lngSeq = lngSupSeq;
                            }

                            i = 0;
                            k = 0;

                            DoseArr = [];
                        }

                        // DoAgain:

                        strLinkCat = LinkInfo[k].Category;
                        j = 0;
                        strOptions = [];

                        for (i = k; i <= intLinkCount - 1; i++) {
                            if (strLinkCat === LinkInfo[i].Category) {
                                strOptions.push(`${LinkInfo[i].LinkName}`);
                                if (LinkInfo[i].LinkType === INVENT) {
                                    if (LinkInfo[i].RecFix === "R") {
                                        var sglRecDose = 0;
                                        DoseArr.push(new DosageModel(sglRecDose, 0, 0, 0, ''));
                                        await this.CalcDosage(new CalcDosageModel(LinkInfo[i].LinkNo, LinkInfo[i].Dosage, lngPetNo, LinkInfo[i].Variant, DoseArr[i].sglMinDose, DoseArr[i].sglMaxDose, this.Clinic_no, DoseArr[i].sglRecDose, DoseArr[i].sglQty, DoseArr[i].QtyUnit))
                                            .then((res: CalcDosageModel) => {
                                                DoseArr[i].sglRecDose = res.CalcDose;
                                                DoseArr[i].sglMinDose = res.sglMinDose;
                                                DoseArr[i].sglMaxDose = res.sglMaxDose;
                                            });
                                        //strOptions[i] = `${strOptions[i]}"`
                                    } else if (LinkInfo[i].RecFix === "F") {
                                        // DoseArr[i].sglRecDose = LinkInfo[i].Dosage
                                        DoseArr.push(new DosageModel(LinkInfo[i].Dosage, 0, 0, 0, LinkInfo[i].DosageUnit));
                                    } else {
                                        // DoseArr[i].sglRecDose = 1;
                                        DoseArr.push(new DosageModel(1, 0, 0, 0, ''));
                                    }
                                } else {
                                    // DoseArr[i].sglRecDose = 1
                                    DoseArr.push(new DosageModel(1, 0, 0, 0, ''));
                                }
                                j = j + 1;
                            } else {
                                break;
                            }
                        }

                        if (j === 1) {
                            intSel = 0 + k;
                        } else {

                            // intSel = OptionSelection("Select Item for " & strCodeName, j) + k
                            var some = this.findOption_v2(strOptions);
                            if (some) {
                                intSel = some.Index + k;
                                Result = LinkInfo[intSel]
                                SelectedLinks.push(`${Result.LinkName}`);
                            } else {
                                let options = {};
                                strOptions.forEach((element, index) => {
                                    options[`${index}`] = element;
                                });
                                // const { value: selection } = await Swal.fire({
                                //     title: "Select Item for " + strCodeName,
                                //     input: 'select',
                                //     inputOptions: options,
                                //     // inputPlaceholder: 'Select a fruit',
                                //     showCancelButton: false,
                                //     inputValidator: (value) => {
                                //         return new Promise((resolve) => {
                                //             resolve(undefined)
                                //         })
                                //     }
                                // })

                                // if (selection) {
                                //     // Swal.fire(`You selected: ${selection}`)
                                //     // if (strOptions.some(t => t === selection)) {
                                //     intSel = Number(selection) + k;
                                //     Result= LinkInfo[intSel]
                                //     SelectedLinks.push(`${Result.code} -- ${Result.Desc}`);
                                //     // }
                                // }
                            }
                        }

                        if (intSel < k) {
                            return;
                        } else if (LinkInfo[intSel].LinkNo === NOMED && LinkInfo[intSel].LinkType === 0) {
                            if (k < intLinkCount - 1) {
                                if (i < intLinkCount) {
                                    k = i
                                    // GoTo DoAgain
                                    await DoAgain(true, false);
                                } else {
                                    RequestProc = intIndex
                                    // GoTo ChkOtherStatus
                                }
                            }
                        }

                        await this.childProcAll(-1, intTotalIdx, LinkInfo[intSel].code, strStatus, strReqEmp, intEmpNo, lngClientNo, lngPetNo, lngSeq, SelectedLinks)
                            .then((res: any) => {
                                if (res && res.RequestProc)
                                    intIndex = res.RequestProc;

                            });
                        if (k < intLinkCount - 1) {
                            if (i < intLinkCount) {
                                k = i;
                                // GoTo DoAgain
                                await DoAgain(true, false);
                            }
                        }


                    }
                    await DoAgain(true, true);
                }

                RequestProc = intIndex;
                break;
            case 'P':

                for (i = 0; i <= intLinkCount - 1; i++) {
                    strOptions.push(`${LinkInfo[i].LinkName}`);
                    // this.strOptionsAll.push(new ProcLinksAllModel(LinkInfo[i].LinkNo, `${LinkInfo[i].code} -- ${LinkInfo[i].Desc}`, intCodeNo, true));

                    if (LinkInfo[i].LinkType === INVENT) {
                        if (LinkInfo[i].RecFix === "R") {
                            var sglRecDose = 0;
                            DoseArr.push(new DosageModel(sglRecDose, 0, 0, 0, ''))
                            await this.CalcDosage(new CalcDosageModel(LinkInfo[i].LinkNo, LinkInfo[i].Dosage, lngPetNo, LinkInfo[i].Variant, DoseArr[i].sglMinDose, DoseArr[i].sglMaxDose, this.Clinic_no, DoseArr[i].sglRecDose, DoseArr[i].sglQty, DoseArr[i].QtyUnit))
                                .then((res: CalcDosageModel) => {
                                    DoseArr[i].sglRecDose = res.CalcDose;
                                    DoseArr[i].sglMinDose = res.sglMinDose;
                                    DoseArr[i].sglMaxDose = res.sglMaxDose;
                                    DoseArr[i].QtyUnit = res.QtyUnit
                                });
                            // DoseArr.push(new DosageModel(sglRecDose, 0, 0));
                            //strOptions[i] = `${strOptions[i]}"`
                        } else if (LinkInfo[i].RecFix === "F") {
                            // DoseArr[i].sglRecDose = LinkInfo[i].Dosage;
                            DoseArr.push(new DosageModel(LinkInfo[i].Dosage, 0, 0, 0, ''));
                        } else {
                            // DoseArr[i].sglRecDose = 1;
                            DoseArr.push(new DosageModel(1, 0, 0, 0, ''));
                        }
                    } else {
                        // DoseArr[i].sglRecDose = 1;
                        DoseArr.push(new DosageModel(1, 0, 0, 0, ''));
                    }
                }
                if (i === 1) {
                    intSel = 0;
                    Result = LinkInfo[intSel]
                    SelectedLinks.push(`${Result.LinkName}`);
                } else {

                    // intSel = OptionSelection("Select Item for " & strCodeName, i)e
                    var some = this.findOption_v2(strOptions);
                    if (some) {
                        intSel = some.Index;
                    } else {
                        let options = {};
                        strOptions.forEach((element, index) => {
                            options[`${index}`] = element;
                        });
                        // const { value: selection } = await Swal.fire({
                        //     title: "Select Item for " + strCodeName,
                        //     input: 'select',
                        //     inputOptions: options,
                        //     // inputPlaceholder: 'Select a fruit',
                        //     showCancelButton: false,
                        //     inputValidator: (value) => {
                        //         return new Promise((resolve) => {
                        //             resolve(undefined)
                        //         })
                        //     }
                        // })

                        // if (selection) {
                        //     // Swal.fire(`You selected: ${selection}`)
                        //     // if (strOptions.some(t => t === selection)) {
                        //     intSel = Number(selection);
                        //     Result= LinkInfo[intSel]
                        //     SelectedLinks.push(`${Result.code} -- ${Result.Desc}`);
                        //     // }
                        // }
                    }
                }


                break;
        }

        return { RequestProc, Result };




    }

    getRespNotes(sequence_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getRespNotes?sequence_no=${sequence_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.resp_notes = []
                        this.resp_notes = res.data.map((element) => {
                            return new RespNotesModel(element.respNoteID, element.sequence_no, element.pet_no, element.note_date, element.note_text, element.note_type, element.note_value);
                        });

                        resolve(1);
                    } else {
                        this.resp_notes = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    updateRespNotes(resp_notes: RespNotesModel[]): Promise<any> {
        return new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/UpdateRespNotes`, resp_notes)
                .subscribe({
                    next: (res: any) => resolve(res),
                    error: (err) => reject(err)
                });
        });
    }

    TransferEstTotblTransaction(petProcsModel: PetProcsModel[]) {
        let promise = new Promise((resolve, reject) => {
            petProcsModel.forEach(element => {
                this.api.post(`${this.baseUrl}/TransferEstTotblTransaction?tran_sequence=${element.tran_sequence}`)
                    .subscribe((res: any) => {
                        if (res && res.data) {
                            resolve(1);
                        } else {
                            resolve(0);
                        }
                    });
            });

        });
        return promise;
    }

}